(function() {
    'use strict';

    angular
        .module('virtuallibraryApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ui.select',
            'ngSanitize',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',



        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' ];

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('VideoTypeIbqDialogController', VideoTypeIbqDialogController);

    VideoTypeIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VideoType'];

    function VideoTypeIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VideoType) {
        var vm = this;

        vm.videoType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.videoType.id !== null) {
                VideoType.update(vm.videoType, onSaveSuccess, onSaveError);
            } else {
                VideoType.save(vm.videoType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:videoTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('VideoTypeIbqDetailController', VideoTypeIbqDetailController);

    VideoTypeIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'VideoType'];

    function VideoTypeIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, VideoType) {
        var vm = this;

        vm.videoType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:videoTypeUpdate', function(event, result) {
            vm.videoType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('VideoTypeIbqDeleteController',VideoTypeIbqDeleteController);

    VideoTypeIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'VideoType'];

    function VideoTypeIbqDeleteController($uibModalInstance, entity, VideoType) {
        var vm = this;

        vm.videoType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VideoType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('video-type-ibq', {
            parent: 'entity',
            url: '/video-type-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.videoType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/video-type/video-typesibq.html',
                    controller: 'VideoTypeIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('videoType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('video-type-ibq-detail', {
            parent: 'video-type-ibq',
            url: '/video-type-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.videoType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/video-type/video-type-ibq-detail.html',
                    controller: 'VideoTypeIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('videoType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VideoType', function($stateParams, VideoType) {
                    return VideoType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'video-type-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('video-type-ibq-detail.edit', {
            parent: 'video-type-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-type/video-type-ibq-dialog.html',
                    controller: 'VideoTypeIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VideoType', function(VideoType) {
                            return VideoType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('video-type-ibq.new', {
            parent: 'video-type-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-type/video-type-ibq-dialog.html',
                    controller: 'VideoTypeIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('video-type-ibq', null, { reload: 'video-type-ibq' });
                }, function() {
                    $state.go('video-type-ibq');
                });
            }]
        })
        .state('video-type-ibq.edit', {
            parent: 'video-type-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-type/video-type-ibq-dialog.html',
                    controller: 'VideoTypeIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VideoType', function(VideoType) {
                            return VideoType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('video-type-ibq', null, { reload: 'video-type-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('video-type-ibq.delete', {
            parent: 'video-type-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-type/video-type-ibq-delete-dialog.html',
                    controller: 'VideoTypeIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VideoType', function(VideoType) {
                            return VideoType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('video-type-ibq', null, { reload: 'video-type-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('VideoType', VideoType);

    VideoType.$inject = ['$resource'];

    function VideoType ($resource) {
        var resourceUrl =  'api/video-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('VideoTypeSearch', VideoTypeSearch);

    VideoTypeSearch.$inject = ['$resource'];

    function VideoTypeSearch($resource) {
        var resourceUrl =  'api/_search/video-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('VideoTypeIbqController', VideoTypeIbqController);

    VideoTypeIbqController.$inject = ['$state', 'VideoType', 'VideoTypeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function VideoTypeIbqController($state, VideoType, VideoTypeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                VideoTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                VideoType.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.videoTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('VideoIbqDialogController', VideoIbqDialogController);

    VideoIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Video', 'VideoType', 'MusicalPiece', 'Language', 'Person', 'Copyright'];

    function VideoIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Video, VideoType, MusicalPiece, Language, Person, Copyright) {
        var vm = this;

        vm.video = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.videotypes = VideoType.query();
        vm.musicalpieces = MusicalPiece.query();
        vm.languages = Language.query();
        vm.people = Person.query();
        vm.copyrights = Copyright.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.video.id !== null) {
                Video.update(vm.video, onSaveSuccess, onSaveError);
            } else {
                Video.save(vm.video, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:videoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('VideoIbqDetailController', VideoIbqDetailController);

    VideoIbqDetailController.$inject = ['$scope', '$sce', '$rootScope', '$stateParams', 'previousState', 'entity', 'Video', 'VideoType', 'MusicalPiece', 'Language', 'Person', 'Copyright'];

    function VideoIbqDetailController($scope, $sce, $rootScope, $stateParams, previousState, entity, Video, VideoType, MusicalPiece, Language, Person, Copyright) {
        var vm = this;
        vm.trustAsHtml=$sce.trustAsHtml;
        vm.video = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:videoUpdate', function(event, result) {
            vm.video = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('VideoIbqDeleteController',VideoIbqDeleteController);

    VideoIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Video'];

    function VideoIbqDeleteController($uibModalInstance, entity, Video) {
        var vm = this;

        vm.video = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Video.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('video-ibq', {
            parent: 'entity',
            url: '/video-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.video.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/video/videosibq.html',
                    controller: 'VideoIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('video');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('video-ibq-detail', {
            parent: 'video-ibq',
            url: '/video-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.video.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/video/video-ibq-detail.html',
                    controller: 'VideoIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('video');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Video', function($stateParams, Video) {
                    return Video.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'video-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('video-ibq-detail.edit', {
            parent: 'video-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video/video-ibq-dialog.html',
                    controller: 'VideoIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Video', function(Video) {
                            return Video.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('video-ibq.new', {
            parent: 'video-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video/video-ibq-dialog.html',
                    controller: 'VideoIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                creationDate: null,
                                creationPlace: null,
                                videoUrl: null,
                                comments: null,
                                duration: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('video-ibq', null, { reload: 'video-ibq' });
                }, function() {
                    $state.go('video-ibq');
                });
            }]
        })
        .state('video-ibq.edit', {
            parent: 'video-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video/video-ibq-dialog.html',
                    controller: 'VideoIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Video', function(Video) {
                            return Video.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('video-ibq', null, { reload: 'video-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('video-ibq.delete', {
            parent: 'video-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video/video-ibq-delete-dialog.html',
                    controller: 'VideoIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Video', function(Video) {
                            return Video.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('video-ibq', null, { reload: 'video-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Video', Video);

    Video.$inject = ['$resource', 'DateUtils'];

    function Video ($resource, DateUtils) {
        var resourceUrl =  'api/videos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertLocalDateFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.creationDate = DateUtils.convertLocalDateToServer(copy.creationDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.creationDate = DateUtils.convertLocalDateToServer(copy.creationDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('VideoSearch', VideoSearch);

    VideoSearch.$inject = ['$resource'];

    function VideoSearch($resource) {
        var resourceUrl =  'api/_search/videos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('VideoIbqController', VideoIbqController);

    VideoIbqController.$inject = ['$state','$sce', 'Video', 'VideoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function VideoIbqController($state, $sce, Video, VideoSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;
        vm.trustAsHtml=$sce.trustAsHtml;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                VideoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Video.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.videos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('TypeIbqDialogController', TypeIbqDialogController);

    TypeIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Type'];

    function TypeIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Type) {
        var vm = this;

        vm.type = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.type.id !== null) {
                Type.update(vm.type, onSaveSuccess, onSaveError);
            } else {
                Type.save(vm.type, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:typeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('TypeIbqDetailController', TypeIbqDetailController);

    TypeIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Type'];

    function TypeIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Type) {
        var vm = this;

        vm.type = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:typeUpdate', function(event, result) {
            vm.type = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('TypeIbqDeleteController',TypeIbqDeleteController);

    TypeIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Type'];

    function TypeIbqDeleteController($uibModalInstance, entity, Type) {
        var vm = this;

        vm.type = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Type.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('type-ibq', {
            parent: 'entity',
            url: '/type-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.type.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/type/typesibq.html',
                    controller: 'TypeIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('type');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-ibq-detail', {
            parent: 'type-ibq',
            url: '/type-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.type.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/type/type-ibq-detail.html',
                    controller: 'TypeIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('type');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Type', function($stateParams, Type) {
                    return Type.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'type-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('type-ibq-detail.edit', {
            parent: 'type-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/type/type-ibq-dialog.html',
                    controller: 'TypeIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Type', function(Type) {
                            return Type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-ibq.new', {
            parent: 'type-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/type/type-ibq-dialog.html',
                    controller: 'TypeIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-ibq', null, { reload: 'type-ibq' });
                }, function() {
                    $state.go('type-ibq');
                });
            }]
        })
        .state('type-ibq.edit', {
            parent: 'type-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/type/type-ibq-dialog.html',
                    controller: 'TypeIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Type', function(Type) {
                            return Type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-ibq', null, { reload: 'type-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-ibq.delete', {
            parent: 'type-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/type/type-ibq-delete-dialog.html',
                    controller: 'TypeIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Type', function(Type) {
                            return Type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-ibq', null, { reload: 'type-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Type', Type);

    Type.$inject = ['$resource'];

    function Type ($resource) {
        var resourceUrl =  'api/types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('TypeSearch', TypeSearch);

    TypeSearch.$inject = ['$resource'];

    function TypeSearch($resource) {
        var resourceUrl =  'api/_search/types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('TypeIbqController', TypeIbqController);

    TypeIbqController.$inject = ['$state', 'Type', 'TypeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TypeIbqController($state, Type, TypeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Type.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.types = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('StateIbqDialogController', StateIbqDialogController);

    StateIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'State'];

    function StateIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, State) {
        var vm = this;

        vm.state = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.state.id !== null) {
                State.update(vm.state, onSaveSuccess, onSaveError);
            } else {
                State.save(vm.state, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:stateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('StateIbqDetailController', StateIbqDetailController);

    StateIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'State'];

    function StateIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, State) {
        var vm = this;

        vm.state = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:stateUpdate', function(event, result) {
            vm.state = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('StateIbqDeleteController',StateIbqDeleteController);

    StateIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'State'];

    function StateIbqDeleteController($uibModalInstance, entity, State) {
        var vm = this;

        vm.state = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            State.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('state-ibq', {
            parent: 'entity',
            url: '/state-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.state.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/state/statesibq.html',
                    controller: 'StateIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('state-ibq-detail', {
            parent: 'state-ibq',
            url: '/state-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.state.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/state/state-ibq-detail.html',
                    controller: 'StateIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'State', function($stateParams, State) {
                    return State.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'state-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('state-ibq-detail.edit', {
            parent: 'state-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/state/state-ibq-dialog.html',
                    controller: 'StateIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['State', function(State) {
                            return State.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('state-ibq.new', {
            parent: 'state-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/state/state-ibq-dialog.html',
                    controller: 'StateIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('state-ibq', null, { reload: 'state-ibq' });
                }, function() {
                    $state.go('state-ibq');
                });
            }]
        })
        .state('state-ibq.edit', {
            parent: 'state-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/state/state-ibq-dialog.html',
                    controller: 'StateIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['State', function(State) {
                            return State.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('state-ibq', null, { reload: 'state-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('state-ibq.delete', {
            parent: 'state-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/state/state-ibq-delete-dialog.html',
                    controller: 'StateIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['State', function(State) {
                            return State.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('state-ibq', null, { reload: 'state-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('State', State);

    State.$inject = ['$resource'];

    function State ($resource) {
        var resourceUrl =  'api/states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('StateSearch', StateSearch);

    StateSearch.$inject = ['$resource'];

    function StateSearch($resource) {
        var resourceUrl =  'api/_search/states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('StateIbqController', StateIbqController);

    StateIbqController.$inject = ['$state', 'State', 'StateSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function StateIbqController($state, State, StateSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                StateSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                State.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.states = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('SpecialtyIbqDialogController', SpecialtyIbqDialogController);

    SpecialtyIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Specialty'];

    function SpecialtyIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Specialty) {
        var vm = this;

        vm.specialty = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.specialty.id !== null) {
                Specialty.update(vm.specialty, onSaveSuccess, onSaveError);
            } else {
                Specialty.save(vm.specialty, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:specialtyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('SpecialtyIbqDetailController', SpecialtyIbqDetailController);

    SpecialtyIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Specialty'];

    function SpecialtyIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Specialty) {
        var vm = this;

        vm.specialty = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:specialtyUpdate', function(event, result) {
            vm.specialty = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('SpecialtyIbqDeleteController',SpecialtyIbqDeleteController);

    SpecialtyIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Specialty'];

    function SpecialtyIbqDeleteController($uibModalInstance, entity, Specialty) {
        var vm = this;

        vm.specialty = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Specialty.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('specialty-ibq', {
            parent: 'entity',
            url: '/specialty-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.specialty.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/specialty/specialtiesibq.html',
                    controller: 'SpecialtyIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specialty');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('specialty-ibq-detail', {
            parent: 'specialty-ibq',
            url: '/specialty-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.specialty.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/specialty/specialty-ibq-detail.html',
                    controller: 'SpecialtyIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specialty');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Specialty', function($stateParams, Specialty) {
                    return Specialty.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'specialty-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('specialty-ibq-detail.edit', {
            parent: 'specialty-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specialty/specialty-ibq-dialog.html',
                    controller: 'SpecialtyIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Specialty', function(Specialty) {
                            return Specialty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('specialty-ibq.new', {
            parent: 'specialty-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specialty/specialty-ibq-dialog.html',
                    controller: 'SpecialtyIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('specialty-ibq', null, { reload: 'specialty-ibq' });
                }, function() {
                    $state.go('specialty-ibq');
                });
            }]
        })
        .state('specialty-ibq.edit', {
            parent: 'specialty-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specialty/specialty-ibq-dialog.html',
                    controller: 'SpecialtyIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Specialty', function(Specialty) {
                            return Specialty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('specialty-ibq', null, { reload: 'specialty-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('specialty-ibq.delete', {
            parent: 'specialty-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specialty/specialty-ibq-delete-dialog.html',
                    controller: 'SpecialtyIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Specialty', function(Specialty) {
                            return Specialty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('specialty-ibq', null, { reload: 'specialty-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Specialty', Specialty);

    Specialty.$inject = ['$resource'];

    function Specialty ($resource) {
        var resourceUrl =  'api/specialties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('SpecialtySearch', SpecialtySearch);

    SpecialtySearch.$inject = ['$resource'];

    function SpecialtySearch($resource) {
        var resourceUrl =  'api/_search/specialties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('SpecialtyIbqController', SpecialtyIbqController);

    SpecialtyIbqController.$inject = ['$state', 'Specialty', 'SpecialtySearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SpecialtyIbqController($state, Specialty, SpecialtySearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SpecialtySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Specialty.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.specialties = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('RoleIbqDialogController', RoleIbqDialogController);

    RoleIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Role', 'Person'];

    function RoleIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Role, Person) {
        var vm = this;

        vm.role = entity;
        vm.clear = clear;
        vm.save = save;
        vm.people = Person.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.role.id !== null) {
                Role.update(vm.role, onSaveSuccess, onSaveError);
            } else {
                Role.save(vm.role, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:roleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('RoleIbqDetailController', RoleIbqDetailController);

    RoleIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Role', 'Person'];

    function RoleIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Role, Person) {
        var vm = this;

        vm.role = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:roleUpdate', function(event, result) {
            vm.role = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('RoleIbqDeleteController',RoleIbqDeleteController);

    RoleIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Role'];

    function RoleIbqDeleteController($uibModalInstance, entity, Role) {
        var vm = this;

        vm.role = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Role.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('role-ibq', {
            parent: 'entity',
            url: '/role-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.role.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/role/rolesibq.html',
                    controller: 'RoleIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('role');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('role-ibq-detail', {
            parent: 'role-ibq',
            url: '/role-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.role.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/role/role-ibq-detail.html',
                    controller: 'RoleIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('role');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Role', function($stateParams, Role) {
                    return Role.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'role-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('role-ibq-detail.edit', {
            parent: 'role-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/role/role-ibq-dialog.html',
                    controller: 'RoleIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Role', function(Role) {
                            return Role.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('role-ibq.new', {
            parent: 'role-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/role/role-ibq-dialog.html',
                    controller: 'RoleIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                roleName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('role-ibq', null, { reload: 'role-ibq' });
                }, function() {
                    $state.go('role-ibq');
                });
            }]
        })
        .state('role-ibq.edit', {
            parent: 'role-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/role/role-ibq-dialog.html',
                    controller: 'RoleIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Role', function(Role) {
                            return Role.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('role-ibq', null, { reload: 'role-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('role-ibq.delete', {
            parent: 'role-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/role/role-ibq-delete-dialog.html',
                    controller: 'RoleIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Role', function(Role) {
                            return Role.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('role-ibq', null, { reload: 'role-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Role', Role);

    Role.$inject = ['$resource'];

    function Role ($resource) {
        var resourceUrl =  'api/roles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('RoleSearch', RoleSearch);

    RoleSearch.$inject = ['$resource'];

    function RoleSearch($resource) {
        var resourceUrl =  'api/_search/roles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('RoleIbqController', RoleIbqController);

    RoleIbqController.$inject = ['$state', 'Role', 'RoleSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function RoleIbqController($state, Role, RoleSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                RoleSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Role.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.roles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PublisherIbqDialogController', PublisherIbqDialogController);

    PublisherIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Publisher', 'Material'];

    function PublisherIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Publisher, Material) {
        var vm = this;

        vm.publisher = entity;
        vm.clear = clear;
        vm.save = save;
        vm.materials = Material.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publisher.id !== null) {
                Publisher.update(vm.publisher, onSaveSuccess, onSaveError);
            } else {
                Publisher.save(vm.publisher, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:publisherUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PublisherIbqDetailController', PublisherIbqDetailController);

    PublisherIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Publisher', 'Material'];

    function PublisherIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Publisher, Material) {
        var vm = this;

        vm.publisher = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:publisherUpdate', function(event, result) {
            vm.publisher = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PublisherIbqDeleteController',PublisherIbqDeleteController);

    PublisherIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Publisher'];

    function PublisherIbqDeleteController($uibModalInstance, entity, Publisher) {
        var vm = this;

        vm.publisher = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Publisher.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('publisher-ibq', {
            parent: 'entity',
            url: '/publisher-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.publisher.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/publisher/publishersibq.html',
                    controller: 'PublisherIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publisher');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('publisher-ibq-detail', {
            parent: 'publisher-ibq',
            url: '/publisher-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.publisher.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/publisher/publisher-ibq-detail.html',
                    controller: 'PublisherIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publisher');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Publisher', function($stateParams, Publisher) {
                    return Publisher.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'publisher-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('publisher-ibq-detail.edit', {
            parent: 'publisher-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/publisher/publisher-ibq-dialog.html',
                    controller: 'PublisherIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Publisher', function(Publisher) {
                            return Publisher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('publisher-ibq.new', {
            parent: 'publisher-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/publisher/publisher-ibq-dialog.html',
                    controller: 'PublisherIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                address: null,
                                webPage: null,
                                phone: null,
                                email: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('publisher-ibq', null, { reload: 'publisher-ibq' });
                }, function() {
                    $state.go('publisher-ibq');
                });
            }]
        })
        .state('publisher-ibq.edit', {
            parent: 'publisher-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/publisher/publisher-ibq-dialog.html',
                    controller: 'PublisherIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Publisher', function(Publisher) {
                            return Publisher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('publisher-ibq', null, { reload: 'publisher-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('publisher-ibq.delete', {
            parent: 'publisher-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/publisher/publisher-ibq-delete-dialog.html',
                    controller: 'PublisherIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Publisher', function(Publisher) {
                            return Publisher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('publisher-ibq', null, { reload: 'publisher-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Publisher', Publisher);

    Publisher.$inject = ['$resource'];

    function Publisher ($resource) {
        var resourceUrl =  'api/publishers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('PublisherSearch', PublisherSearch);

    PublisherSearch.$inject = ['$resource'];

    function PublisherSearch($resource) {
        var resourceUrl =  'api/_search/publishers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PublisherIbqController', PublisherIbqController);

    PublisherIbqController.$inject = ['$state', 'Publisher', 'PublisherSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PublisherIbqController($state, Publisher, PublisherSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PublisherSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Publisher.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publishers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PortalRoleDialogController', PortalRoleDialogController);

    PortalRoleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PortalRole'];

    function PortalRoleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PortalRole) {
        var vm = this;

        vm.portalRole = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.portalRole.id !== null) {
                PortalRole.update(vm.portalRole, onSaveSuccess, onSaveError);
            } else {
                PortalRole.save(vm.portalRole, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:portalRoleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PortalRoleDetailController', PortalRoleDetailController);

    PortalRoleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PortalRole', 'MusicalPiece'];

    function PortalRoleDetailController($scope, $rootScope, $stateParams, previousState, entity, PortalRole, MusicalPiece) {
        var vm = this;

        vm.portalRole = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:portalRoleUpdate', function(event, result) {
            vm.portalRole = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PortalRoleDeleteController',PortalRoleDeleteController);

    PortalRoleDeleteController.$inject = ['$uibModalInstance', 'entity', 'PortalRole'];

    function PortalRoleDeleteController($uibModalInstance, entity, PortalRole) {
        var vm = this;

        vm.portalRole = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PortalRole.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
            .factory('PortalRoleSync', PortalRoleSync);

    PortalRoleSync.$inject = ['$resource'];

    function PortalRoleSync($resource) {
        var resourceUrl =  'api/portal-roles/sync';

        return $resource(resourceUrl, {}, {
            'sync': { method: 'GET'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('portal-role', {
            parent: 'entity',
            url: '/portal-role',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.portalRole.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/portal-role/portal-roles.html',
                    controller: 'PortalRoleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('portalRole');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('portal-role-detail', {
            parent: 'portal-role',
            url: '/portal-role/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.portalRole.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/portal-role/portal-role-detail.html',
                    controller: 'PortalRoleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('portalRole');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PortalRole', function($stateParams, PortalRole) {
                    return PortalRole.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'portal-role',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('portal-role-detail.edit', {
            parent: 'portal-role-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/portal-role/portal-role-dialog.html',
                    controller: 'PortalRoleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PortalRole', function(PortalRole) {
                            return PortalRole.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('portal-role.new', {
            parent: 'portal-role',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/portal-role/portal-role-dialog.html',
                    controller: 'PortalRoleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                roleId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('portal-role', null, { reload: 'portal-role' });
                }, function() {
                    $state.go('portal-role');
                });
            }]
        })
        .state('portal-role.edit', {
            parent: 'portal-role',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/portal-role/portal-role-dialog.html',
                    controller: 'PortalRoleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PortalRole', function(PortalRole) {
                            return PortalRole.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('portal-role', null, { reload: 'portal-role' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('portal-role.delete', {
            parent: 'portal-role',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/portal-role/portal-role-delete-dialog.html',
                    controller: 'PortalRoleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PortalRole', function(PortalRole) {
                            return PortalRole.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('portal-role', null, { reload: 'portal-role' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('PortalRole', PortalRole);

    PortalRole.$inject = ['$resource'];

    function PortalRole ($resource) {
        var resourceUrl =  'api/portal-roles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('PortalRoleSearch', PortalRoleSearch);

    PortalRoleSearch.$inject = ['$resource'];

    function PortalRoleSearch($resource) {
        var resourceUrl =  'api/_search/portal-roles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PortalRoleController', PortalRoleController);

    PortalRoleController.$inject = ['$http', '$q', '$timeout', 'PortalRoleSync', 'PortalRole', 'PortalRoleSearch'];

    function PortalRoleController($http, $q, $timeout, PortalRoleSync, PortalRole, PortalRoleSearch) {

        var vm = this;

        vm.portalRoles = [];
        vm.clear = clear;
        vm.sync = sync;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {

            PortalRole.query(function (result) {
                vm.portalRoles = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PortalRoleSearch.query({query: vm.searchQuery}, function (result) {
                vm.portalRoles = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }


        function sync() {

            $http.get("api/portal-roles/sync").then(function (response) {   vm.loadAll(); });

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PhotoIbqDialogController', PhotoIbqDialogController);

    PhotoIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Photo', 'MusicalPiece', 'Person'];

    function PhotoIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Photo, MusicalPiece, Person) {
        var vm = this;

        vm.photo = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.musicalpieces = MusicalPiece.query();
        vm.people = Person.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.photo.id !== null) {
                Photo.update(vm.photo, onSaveSuccess, onSaveError);
            } else {
                Photo.save(vm.photo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:photoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setPhotoFile = function ($file, photo) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        photo.photoFile = base64Data;
                        photo.photoFileContentType = $file.type;
                        photo.photoPath=$file.name;

                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PhotoIbqDetailController', PhotoIbqDetailController);

    PhotoIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Photo', 'MusicalPiece', 'Person'];

    function PhotoIbqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Photo, MusicalPiece, Person) {
        var vm = this;

        vm.photo = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:photoUpdate', function(event, result) {
            vm.photo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PhotoIbqDeleteController',PhotoIbqDeleteController);

    PhotoIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Photo'];

    function PhotoIbqDeleteController($uibModalInstance, entity, Photo) {
        var vm = this;

        vm.photo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Photo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('photo-ibq', {
            parent: 'entity',
            url: '/photo-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.photo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/photo/photosibq.html',
                    controller: 'PhotoIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('photo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('photo-ibq-detail', {
            parent: 'photo-ibq',
            url: '/photo-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.photo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/photo/photo-ibq-detail.html',
                    controller: 'PhotoIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('photo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Photo', function($stateParams, Photo) {
                    return Photo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'photo-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('photo-ibq-detail.edit', {
            parent: 'photo-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/photo/photo-ibq-dialog.html',
                    controller: 'PhotoIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Photo', function(Photo) {
                            return Photo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('photo-ibq.new', {
            parent: 'photo-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/photo/photo-ibq-dialog.html',
                    controller: 'PhotoIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                subtitle: null,
                                photoFile: null,
                                photoFileContentType: null,
                                photoPath: null,
                                footer: null,
                                originalSupport: null,
                                physicalDescription: null,
                                originalDimensions: null,
                                comments: null,
                                alternativeText: null,
                                source: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('photo-ibq', null, { reload: 'photo-ibq' });
                }, function() {
                    $state.go('photo-ibq');
                });
            }]
        })
        .state('photo-ibq.edit', {
            parent: 'photo-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/photo/photo-ibq-dialog.html',
                    controller: 'PhotoIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Photo', function(Photo) {
                            return Photo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('photo-ibq', null, { reload: 'photo-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('photo-ibq.delete', {
            parent: 'photo-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/photo/photo-ibq-delete-dialog.html',
                    controller: 'PhotoIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Photo', function(Photo) {
                            return Photo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('photo-ibq', null, { reload: 'photo-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Photo', Photo);

    Photo.$inject = ['$resource'];

    function Photo ($resource) {
        var resourceUrl =  'api/photos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('PhotoSearch', PhotoSearch);

    PhotoSearch.$inject = ['$resource'];

    function PhotoSearch($resource) {
        var resourceUrl =  'api/_search/photos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PhotoIbqController', PhotoIbqController);

    PhotoIbqController.$inject = ['$state', 'DataUtils', 'Photo', 'PhotoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PhotoIbqController($state, DataUtils, Photo, PhotoSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PhotoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Photo.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.photos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PersonRoleIbqDialogController', PersonRoleIbqDialogController);

    PersonRoleIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PersonRole', 'Person'];

    function PersonRoleIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PersonRole, Person) {
        var vm = this;

        vm.personRole = entity;
        vm.clear = clear;
        vm.save = save;
        vm.people = Person.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.personRole.id !== null) {
                PersonRole.update(vm.personRole, onSaveSuccess, onSaveError);
            } else {
                PersonRole.save(vm.personRole, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:personRoleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PersonRoleIbqDetailController', PersonRoleIbqDetailController);

    PersonRoleIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PersonRole', 'Person'];

    function PersonRoleIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, PersonRole, Person) {
        var vm = this;

        vm.personRole = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:personRoleUpdate', function(event, result) {
            vm.personRole = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PersonRoleIbqDeleteController',PersonRoleIbqDeleteController);

    PersonRoleIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'PersonRole'];

    function PersonRoleIbqDeleteController($uibModalInstance, entity, PersonRole) {
        var vm = this;

        vm.personRole = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PersonRole.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('person-role-ibq', {
            parent: 'entity',
            url: '/person-role-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.personRole.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/person-role/person-rolesibq.html',
                    controller: 'PersonRoleIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('personRole');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('person-role-ibq-detail', {
            parent: 'person-role-ibq',
            url: '/person-role-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.personRole.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/person-role/person-role-ibq-detail.html',
                    controller: 'PersonRoleIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('personRole');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PersonRole', function($stateParams, PersonRole) {
                    return PersonRole.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'person-role-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('person-role-ibq-detail.edit', {
            parent: 'person-role-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person-role/person-role-ibq-dialog.html',
                    controller: 'PersonRoleIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PersonRole', function(PersonRole) {
                            return PersonRole.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('person-role-ibq.new', {
            parent: 'person-role-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person-role/person-role-ibq-dialog.html',
                    controller: 'PersonRoleIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('person-role-ibq', null, { reload: 'person-role-ibq' });
                }, function() {
                    $state.go('person-role-ibq');
                });
            }]
        })
        .state('person-role-ibq.edit', {
            parent: 'person-role-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person-role/person-role-ibq-dialog.html',
                    controller: 'PersonRoleIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PersonRole', function(PersonRole) {
                            return PersonRole.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('person-role-ibq', null, { reload: 'person-role-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('person-role-ibq.delete', {
            parent: 'person-role-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person-role/person-role-ibq-delete-dialog.html',
                    controller: 'PersonRoleIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PersonRole', function(PersonRole) {
                            return PersonRole.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('person-role-ibq', null, { reload: 'person-role-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('PersonRole', PersonRole);

    PersonRole.$inject = ['$resource'];

    function PersonRole ($resource) {
        var resourceUrl =  'api/person-roles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('PersonRoleSearch', PersonRoleSearch);

    PersonRoleSearch.$inject = ['$resource'];

    function PersonRoleSearch($resource) {
        var resourceUrl =  'api/_search/person-roles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PersonRoleIbqController', PersonRoleIbqController);

    PersonRoleIbqController.$inject = ['$state', 'PersonRole', 'PersonRoleSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PersonRoleIbqController($state, PersonRole, PersonRoleSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PersonRoleSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PersonRole.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.personRoles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .filter('propsFilter', function() {
            return function(items, props) {
                var out = [];

                if (angular.isArray(items)) {
                    var keys = Object.keys(props);

                    items.forEach(function(item) {
                        var itemMatches = false;

                        for (var i = 0; i < keys.length; i++) {
                            var prop = keys[i];
                            var text = props[prop].toLowerCase();
                            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                                itemMatches = true;
                                break;
                            }
                        }

                        if (itemMatches) {
                            out.push(item);
                        }
                    });
                } else {
                    // Let the output be the input untouched
                    out = items;
                }

                return out;
            };
        })
        .controller('PersonIbqDialogController', PersonIbqDialogController);

    PersonIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Person', 'Country', 'Audio', 'Photo', 'Role', 'Specialty', 'Material'];

    function PersonIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Person, Country, Audio, Photo, Role, Specialty, Material) {
        var vm = this;

        vm.person = entity;
        vm.clearDialog = clearDialog;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        vm.countries = Country.query();
        vm.countries.$promise.then(function(countries){
            vm.country=countries.find(function (country) {
                return country.id===vm.person.countryId;
            })
        });
        vm.audio = Audio.query();
        vm.photos = Photo.query();
        vm.roles = Role.query();
        vm.specialties = Specialty.query();
        vm.materials = Material.query();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clearDialog () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
             vm.isSaving = true;
             vm.person.countryId=vm.country && vm.country.id;

             if (vm.person.id !== null) {
                Person.update(vm.person, onSaveSuccess, onSaveError);
            } else {
                Person.save(vm.person, onSaveSuccess, onSaveError);
            }
        }



        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:personUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setPictureFile = function ($file, person) {
            if ($file && $file.$error === 'pattern') {

                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        person.pictureFile = base64Data;
                        person.pictureFileContentType = $file.type;
                        person.picturePath=$file.name;

                    });
                });
            }
        };
        vm.datePickerOpenStatus.birthDate = false;
        vm.datePickerOpenStatus.deathDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }



        //New


        vm.setInputFocus = function (){
            $scope.$broadcast('UiSelectDemo1');
        };


        vm.clear = function() {
            //  vm.person.selected = undefined;
            //  vm.address.selected = undefined;
            //  vm.country.selected = undefined;
        };

        vm.someGroupFn = function (item){

            if (item.name[0] >= 'A' && item.name[0] <= 'M')
                return 'From A - M';

            if (item.name[0] >= 'N' && item.name[0] <= 'Z')
                return 'From N - Z';

        };

        vm.firstLetterGroupFn = function (item){
            return item.name[0];
        };

        vm.reverseOrderFilterFn = function(groups) {
            return groups.reverse();
        };

        vm.counter = 0;
        vm.onSelectCallback = function (item, model){
            vm.counter++;
            vm.eventResult = {item: item, model: model};
        };

        vm.removed = function (item, model) {
            vm.lastRemoved = {
                item: item,
                model: model
            };
        };

        vm.tagTransform = function (newTag) {
            var item = {
                name: newTag,
                email: newTag.toLowerCase()+'@email.com',
                age: 'unknown',
                country: 'unknown'
            };

            return item;
        };

    }

})();


(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PersonIbqDetailController', PersonIbqDetailController);

    PersonIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Person', 'Country', 'Audio', 'Role', 'Specialty', 'Material', 'Photo'];

    function PersonIbqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Person, Country, Audio, Role, Specialty, Material, Photo) {
        var vm = this;

        vm.person = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:personUpdate', function(event, result) {
            vm.person = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PersonIbqDeleteController',PersonIbqDeleteController);

    PersonIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Person'];

    function PersonIbqDeleteController($uibModalInstance, entity, Person) {
        var vm = this;

        vm.person = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Person.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('person-ibq', {
            parent: 'entity',
            url: '/person-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.person.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/person/peopleibq.html',
                    controller: 'PersonIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('person');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('person-ibq-detail', {
            parent: 'person-ibq',
            url: '/person-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.person.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/person/person-ibq-detail.html',
                    controller: 'PersonIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('person');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Person', function($stateParams, Person) {
                    return Person.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'person-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('person-ibq-detail.edit', {
            parent: 'person-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person/person-ibq-dialog.html',
                    controller: 'PersonIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Person', function(Person) {
                            return Person.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('person-ibq.new', {
            parent: 'person-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person/person-ibq-dialog.html',
                    controller: 'PersonIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                lastName: null,
                                artisticName: null,
                                pictureFile: null,
                                pictureFileContentType: null,
                                picturePath: null,
                                birthDate: null,
                                birthPlace: null,
                                deathDate: null,
                                deathPlace: null,
                                sex: null,
                                review: null,
                                sources: null,
                                comments: null,
                                birthCountry: null,
                                deadCountry: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('person-ibq', null, { reload: 'person-ibq' });
                }, function() {
                    $state.go('person-ibq');
                });
            }]
        })
        .state('person-ibq.edit', {
            parent: 'person-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person/person-ibq-dialog.html',
                    controller: 'PersonIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Person', function(Person) {
                            return Person.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('person-ibq', null, { reload: 'person-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('person-ibq.delete', {
            parent: 'person-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person/person-ibq-delete-dialog.html',
                    controller: 'PersonIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Person', function(Person) {
                            return Person.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('person-ibq', null, { reload: 'person-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Person', Person);

    Person.$inject = ['$resource', 'DateUtils'];

    function Person ($resource, DateUtils) {
        var resourceUrl =  'api/people/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthDate = DateUtils.convertLocalDateFromServer(data.birthDate);
                        data.deathDate = DateUtils.convertLocalDateFromServer(data.deathDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthDate = DateUtils.convertLocalDateToServer(copy.birthDate);
                    copy.deathDate = DateUtils.convertLocalDateToServer(copy.deathDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthDate = DateUtils.convertLocalDateToServer(copy.birthDate);
                    copy.deathDate = DateUtils.convertLocalDateToServer(copy.deathDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('PersonSearch', PersonSearch);

    PersonSearch.$inject = ['$resource'];

    function PersonSearch($resource) {
        var resourceUrl =  'api/_search/people/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PersonIbqController', PersonIbqController);

    PersonIbqController.$inject = ['$state', 'DataUtils', 'Person', 'PersonSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PersonIbqController($state, DataUtils, Person, PersonSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PersonSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Person.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.people = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular.module('virtuallibraryApp').controller('ParticipationIbqDialogController', ParticipationIbqDialogController);

    ParticipationIbqDialogController.$inject = [
        '$http',
        '$timeout',
        '$scope',
        '$stateParams',
        '$uibModalInstance',
        'entity',
        'Participation',
        'Person',
        'Role',
        'MusicalPiece'
    ];

    function ParticipationIbqDialogController(
    $http,
    $timeout,
    $scope,
    $stateParams,
    $uibModalInstance,
    entity,
    Participation,
    Person,
    Role,
    MusicalPiece
  ) {
        var vm = this;
        vm.person = {};
        vm.person.fullName = '';
        vm.participation = entity;
        vm.clear = clear;
        vm.save = save;
    // vm.people = Person.query();
        vm.people = [];
        vm.roles = Role.query();
        vm.musicalpieces = MusicalPiece.query();

        $http({
            method: 'GET',
            url: 'api/people?page=0&size=500'
        }).success(function(data) {
            vm.people = data;
        });

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            generateTitle();
            if (vm.participation.id !== null) {
                Participation.update(vm.participation, onSaveSuccess, onSaveError);
            } else {
                Participation.save(vm.participation, onSaveSuccess, onSaveError);
            }
        }

        function generateTitle() {
            vm.participation.title = '';

            vm.people.forEach(function(element) {
                if (element.id === vm.participation.personId) {
                    vm.participation.title = element.name + ' ' + element.lastName;
                }
            });

            var rolesList = new Array();
            vm.participation.roles.forEach(function(element) {
                rolesList.push(element.roleName);
            });

      //rolesList=rolesList.join(', ');
      //var rolesText='( '+rolesList+' )';
            vm.participation.title += '( ' + rolesList.join(', ') + ' )';
        }

        function onSaveSuccess(result) {
            $scope.$emit('virtuallibraryApp:participationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('ParticipationIbqDetailController', ParticipationIbqDetailController);

    ParticipationIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Participation', 'Person', 'Role', 'MusicalPiece'];

    function ParticipationIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Participation, Person, Role, MusicalPiece) {
        var vm = this;

        vm.participation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:participationUpdate', function(event, result) {
            vm.participation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('ParticipationIbqDeleteController',ParticipationIbqDeleteController);

    ParticipationIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Participation'];

    function ParticipationIbqDeleteController($uibModalInstance, entity, Participation) {
        var vm = this;

        vm.participation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Participation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('participation-ibq', {
            parent: 'entity',
            url: '/participation-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.participation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/participation/participationsibq.html',
                    controller: 'ParticipationIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('participation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('participation-ibq-detail', {
            parent: 'participation-ibq',
            url: '/participation-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.participation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/participation/participation-ibq-detail.html',
                    controller: 'ParticipationIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('participation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Participation', function($stateParams, Participation) {
                    return Participation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'participation-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('participation-ibq-detail.edit', {
            parent: 'participation-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/participation/participation-ibq-dialog.html',
                    controller: 'ParticipationIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Participation', function(Participation) {
                            return Participation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('participation-ibq.new', {
            parent: 'participation-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/participation/participation-ibq-dialog.html',
                    controller: 'ParticipationIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('participation-ibq', null, { reload: 'participation-ibq' });
                }, function() {
                    $state.go('participation-ibq');
                });
            }]
        })
        .state('participation-ibq.edit', {
            parent: 'participation-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/participation/participation-ibq-dialog.html',
                    controller: 'ParticipationIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Participation', function(Participation) {
                            return Participation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('participation-ibq', null, { reload: 'participation-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('participation-ibq.delete', {
            parent: 'participation-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/participation/participation-ibq-delete-dialog.html',
                    controller: 'ParticipationIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Participation', function(Participation) {
                            return Participation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('participation-ibq', null, { reload: 'participation-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Participation', Participation);

    Participation.$inject = ['$resource'];

    function Participation ($resource) {
        var resourceUrl =  'api/participations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('ParticipationSearch', ParticipationSearch);

    ParticipationSearch.$inject = ['$resource'];

    function ParticipationSearch($resource) {
        var resourceUrl =  'api/_search/participations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('ParticipationIbqController', ParticipationIbqController);

    ParticipationIbqController.$inject = ['$state', 'Participation', 'ParticipationSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ParticipationIbqController($state, Participation, ParticipationSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ParticipationSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Participation.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.participations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PartIbqDialogController', PartIbqDialogController);

    PartIbqDialogController.$inject = ['$http','$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Part', 'MusicalPiece', 'Publisher', 'Level', 'State', 'Instrument'];

    function PartIbqDialogController ($http ,$timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Part, MusicalPiece, Publisher, Level, State, Instrument) {
        var vm = this;

        vm.part = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        // vm.musicalpieces = MusicalPiece.query();
        vm.musicalpieces = [];
        vm.publishers = Publisher.query();
        vm.levels = Level.query();
        vm.states = State.query();
        vm.instruments = Instrument.query();

        //vm.instruments = this.getAllInstruments;

        $http({
            method: 'GET',
            url: 'api/musical-pieces?page=0&size=1000'
        }).success(function(data) {
            vm.musicalpieces = data;
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function getAllInstruments () {
            $http.get("api/instruments?page=0&size=100", null).then(function (response) {vm.instruments=response ; });
        }

        function save () {
            vm.isSaving = true;
            if (vm.part.id !== null) {
                Part.update(vm.part, onSaveSuccess, onSaveError);
            } else {
                Part.save(vm.part, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:partUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setPartFile = function ($file, part) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        part.partFile = base64Data;
                        part.partFileContentType = $file.type;
                        part.partPath = $file.name;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PartIbqDetailController', PartIbqDetailController);

    PartIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Part', 'MusicalPiece', 'Publisher', 'Level', 'State', 'Instrument'];

    function PartIbqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Part, MusicalPiece, Publisher, Level, State, Instrument) {
        var vm = this;

        vm.part = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:partUpdate', function(event, result) {
            vm.part = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PartIbqDeleteController',PartIbqDeleteController);

    PartIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Part'];

    function PartIbqDeleteController($uibModalInstance, entity, Part) {
        var vm = this;

        vm.part = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Part.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('part-ibq', {
            parent: 'entity',
            url: '/part-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.part.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/part/partsibq.html',
                    controller: 'PartIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('part');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('part-ibq-detail', {
            parent: 'part-ibq',
            url: '/part-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.part.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/part/part-ibq-detail.html',
                    controller: 'PartIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('part');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Part', function($stateParams, Part) {
                    return Part.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'part-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('part-ibq-detail.edit', {
            parent: 'part-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/part/part-ibq-dialog.html',
                    controller: 'PartIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Part', function(Part) {
                            return Part.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('part-ibq.new', {
            parent: 'part-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/part/part-ibq-dialog.html',
                    controller: 'PartIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                partFile: null,
                                partFileContentType: null,
                                partPath: null,
                                pages: null,
                                isbn: null,
                                comments: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('part-ibq', null, { reload: 'part-ibq' });
                }, function() {
                    $state.go('part-ibq');
                });
            }]
        })
        .state('part-ibq.edit', {
            parent: 'part-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/part/part-ibq-dialog.html',
                    controller: 'PartIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Part', function(Part) {
                            return Part.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('part-ibq', null, { reload: 'part-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('part-ibq.delete', {
            parent: 'part-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/part/part-ibq-delete-dialog.html',
                    controller: 'PartIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Part', function(Part) {
                            return Part.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('part-ibq', null, { reload: 'part-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Part', Part);

    Part.$inject = ['$resource'];

    function Part ($resource) {
        var resourceUrl =  'api/parts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('PartSearch', PartSearch);

    PartSearch.$inject = ['$resource'];

    function PartSearch($resource) {
        var resourceUrl =  'api/_search/parts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PartIbqController', PartIbqController);

    PartIbqController.$inject = ['$state', 'DataUtils', 'Part', 'PartSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PartIbqController($state, DataUtils, Part, PartSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PartSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Part.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.parts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalPieceIbqDialogController', MusicalPieceIbqDialogController);

    MusicalPieceIbqDialogController.$inject = ['$timeout', '$http', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'MusicalPiece', 'MusicSheet', 'Role', 'Person', 'Participation','Album','PortalRole', 'Ensamble'];

    function MusicalPieceIbqDialogController ($timeout, $http, $scope, $stateParams, $uibModalInstance, DataUtils, entity, MusicalPiece, MusicSheet, Role, Person, Participation, Album, PortalRole, Ensamble) {
        var vm = this;

        vm.musicalPiece = entity;
        vm.clear = clear;
        //vm.datePickerOpenStatus = {};
        vm.participant = {};
        vm.participant.show=false;
        //vm.participation = [];
        vm.addParticipant=addParticipant;
        vm.deleteParticipant=deleteParticipant;
        //vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.participations = Participation.query();
        vm.musicsheets = MusicSheet.query();
        vm.roles = Role.query();
        vm.people = Person.query();
        vm.albums = Album.query();
        vm.portalroles = PortalRole.query();
        vm.ensambles = Ensamble.query();

        /*Person.query().$promise.then(function(people){
            vm.people=people.find(function (people) {
                return people.id===vm.person.countryId;
            })
        });*/

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.musicalPiece.id !== null) {
                MusicalPiece.update(vm.musicalPiece, onSaveSuccess, onSaveError);
            } else {
                MusicalPiece.save(vm.musicalPiece, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:musicalPieceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


       // vm.datePickerOpenStatus.compositionDate = false;

        vm.setCover = function ($file, musicalPiece) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        musicalPiece.cover = base64Data;
                        musicalPiece.coverContentType = $file.type;
                        musicalPiece.musicalPiecePath=$file.name;
                    });
                });
            }
        };


        /*function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }*/

        function addParticipant () {
            vm.participant.personName=vm.participant.person.name+' '+vm.participant.person.lastName;
            var rolesList = new Array;
            vm.participant.roles.forEach(function(element) {
                rolesList.push(element.roleName);
            });

            rolesList=rolesList.join(', ');

            var rolesText='('+rolesList+')';
            vm.participant.title=vm.participant.personName+' '+rolesText;
            vm.participant.personId=vm.participant.person.id;

            console.log(vm.participant);

            //Participation.save(vm.participant);

            $http.post("api/participations/",vm.participant,null).then(function (response) {
                vm.participations=Participation.query();
               // $http.get('api/participations/', null).then(function (response){vm.participations=response; })
            });

            vm.participant={};
            !vm.participant.show;

        }

        function deleteParticipant (participant) {
            vm.participation.splice(vm.participation.find(function(p){
                return p.person.id===participant.person.id;
            }),1);

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalPieceIbqDetailController', MusicalPieceIbqDetailController);

    MusicalPieceIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'MusicalPiece', 'MusicSheet', 'Participation', 'Album', 'PortalRole', 'Ensamble'];

    function MusicalPieceIbqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, MusicalPiece, MusicSheet, Participation, Album, PortalRole, Ensamble) {
        var vm = this;

        vm.musicalPiece = entity;
        vm.previousState = previousState.name;

        //vm.byteSize = DataUtils.byteSize;
        //vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:musicalPieceUpdate', function(event, result) {
            vm.musicalPiece = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalPieceIbqDeleteController',MusicalPieceIbqDeleteController);

    MusicalPieceIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'MusicalPiece'];

    function MusicalPieceIbqDeleteController($uibModalInstance, entity, MusicalPiece) {
        var vm = this;

        vm.musicalPiece = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MusicalPiece.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('musical-piece-ibq', {
            parent: 'entity',
            url: '/musical-piece-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicalPiece.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/musical-piece/musical-piecesibq.html',
                    controller: 'MusicalPieceIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicalPiece');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('musical-piece-ibq-detail', {
            parent: 'musical-piece-ibq',
            url: '/musical-piece-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicalPiece.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/musical-piece/musical-piece-ibq-detail.html',
                    controller: 'MusicalPieceIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicalPiece');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MusicalPiece', function($stateParams, MusicalPiece) {
                    return MusicalPiece.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'musical-piece-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('musical-piece-ibq-detail.edit', {
            parent: 'musical-piece-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-piece/musical-piece-ibq-dialog.html',
                    controller: 'MusicalPieceIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicalPiece', function(MusicalPiece) {
                            return MusicalPiece.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('musical-piece-ibq.new', {
            parent: 'musical-piece-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-piece/musical-piece-ibq-dialog.html',
                    controller: 'MusicalPieceIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                mainTitle: null,
                                alternateTitle: null,
                                subtitle: null,
                                dedication: null,
                                compositionYear: null,
                                cover: null,
                                coverContentType: null,
                                musicalPiecePath: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('musical-piece-ibq', null, { reload: 'musical-piece-ibq' });
                }, function() {
                    $state.go('musical-piece-ibq');
                });
            }]
        })
        .state('musical-piece-ibq.edit', {
            parent: 'musical-piece-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-piece/musical-piece-ibq-dialog.html',
                    controller: 'MusicalPieceIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicalPiece', function(MusicalPiece) {
                            return MusicalPiece.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('musical-piece-ibq', null, { reload: 'musical-piece-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('musical-piece-ibq.delete', {
            parent: 'musical-piece-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-piece/musical-piece-ibq-delete-dialog.html',
                    controller: 'MusicalPieceIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MusicalPiece', function(MusicalPiece) {
                            return MusicalPiece.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('musical-piece-ibq', null, { reload: 'musical-piece-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('MusicalPiece', MusicalPiece);

    MusicalPiece.$inject = ['$resource', 'DateUtils'];

    function MusicalPiece ($resource, DateUtils) {
        var resourceUrl =  'api/musical-pieces/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.compositionDate = DateUtils.convertLocalDateFromServer(data.compositionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.compositionDate = DateUtils.convertLocalDateToServer(copy.compositionDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.compositionDate = DateUtils.convertLocalDateToServer(copy.compositionDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('MusicalPieceSearch', MusicalPieceSearch);

    MusicalPieceSearch.$inject = ['$resource'];

    function MusicalPieceSearch($resource) {
        var resourceUrl =  'api/_search/musical-pieces/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalPieceIbqController', MusicalPieceIbqController);

    MusicalPieceIbqController.$inject = ['$state', 'DataUtils', 'MusicalPiece', 'MusicalPieceSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MusicalPieceIbqController($state, DataUtils, MusicalPiece, MusicalPieceSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                MusicalPieceSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MusicalPiece.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.musicalPieces = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalArrangementTypeIbqDialogController', MusicalArrangementTypeIbqDialogController);

    MusicalArrangementTypeIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MusicalArrangementType'];

    function MusicalArrangementTypeIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MusicalArrangementType) {
        var vm = this;

        vm.musicalArrangementType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.musicalArrangementType.id !== null) {
                MusicalArrangementType.update(vm.musicalArrangementType, onSaveSuccess, onSaveError);
            } else {
                MusicalArrangementType.save(vm.musicalArrangementType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:musicalArrangementTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalArrangementTypeIbqDetailController', MusicalArrangementTypeIbqDetailController);

    MusicalArrangementTypeIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MusicalArrangementType'];

    function MusicalArrangementTypeIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, MusicalArrangementType) {
        var vm = this;

        vm.musicalArrangementType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:musicalArrangementTypeUpdate', function(event, result) {
            vm.musicalArrangementType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalArrangementTypeIbqDeleteController',MusicalArrangementTypeIbqDeleteController);

    MusicalArrangementTypeIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'MusicalArrangementType'];

    function MusicalArrangementTypeIbqDeleteController($uibModalInstance, entity, MusicalArrangementType) {
        var vm = this;

        vm.musicalArrangementType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MusicalArrangementType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('musical-arrangement-type-ibq', {
            parent: 'entity',
            url: '/musical-arrangement-type-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicalArrangementType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/musical-arrangement-type/musical-arrangement-typesibq.html',
                    controller: 'MusicalArrangementTypeIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicalArrangementType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('musical-arrangement-type-ibq-detail', {
            parent: 'musical-arrangement-type-ibq',
            url: '/musical-arrangement-type-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicalArrangementType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/musical-arrangement-type/musical-arrangement-type-ibq-detail.html',
                    controller: 'MusicalArrangementTypeIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicalArrangementType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MusicalArrangementType', function($stateParams, MusicalArrangementType) {
                    return MusicalArrangementType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'musical-arrangement-type-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('musical-arrangement-type-ibq-detail.edit', {
            parent: 'musical-arrangement-type-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement-type/musical-arrangement-type-ibq-dialog.html',
                    controller: 'MusicalArrangementTypeIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicalArrangementType', function(MusicalArrangementType) {
                            return MusicalArrangementType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('musical-arrangement-type-ibq.new', {
            parent: 'musical-arrangement-type-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement-type/musical-arrangement-type-ibq-dialog.html',
                    controller: 'MusicalArrangementTypeIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('musical-arrangement-type-ibq', null, { reload: 'musical-arrangement-type-ibq' });
                }, function() {
                    $state.go('musical-arrangement-type-ibq');
                });
            }]
        })
        .state('musical-arrangement-type-ibq.edit', {
            parent: 'musical-arrangement-type-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement-type/musical-arrangement-type-ibq-dialog.html',
                    controller: 'MusicalArrangementTypeIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicalArrangementType', function(MusicalArrangementType) {
                            return MusicalArrangementType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('musical-arrangement-type-ibq', null, { reload: 'musical-arrangement-type-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('musical-arrangement-type-ibq.delete', {
            parent: 'musical-arrangement-type-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement-type/musical-arrangement-type-ibq-delete-dialog.html',
                    controller: 'MusicalArrangementTypeIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MusicalArrangementType', function(MusicalArrangementType) {
                            return MusicalArrangementType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('musical-arrangement-type-ibq', null, { reload: 'musical-arrangement-type-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('MusicalArrangementType', MusicalArrangementType);

    MusicalArrangementType.$inject = ['$resource'];

    function MusicalArrangementType ($resource) {
        var resourceUrl =  'api/musical-arrangement-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('MusicalArrangementTypeSearch', MusicalArrangementTypeSearch);

    MusicalArrangementTypeSearch.$inject = ['$resource'];

    function MusicalArrangementTypeSearch($resource) {
        var resourceUrl =  'api/_search/musical-arrangement-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalArrangementTypeIbqController', MusicalArrangementTypeIbqController);

    MusicalArrangementTypeIbqController.$inject = ['$state', 'MusicalArrangementType', 'MusicalArrangementTypeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MusicalArrangementTypeIbqController($state, MusicalArrangementType, MusicalArrangementTypeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                MusicalArrangementTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MusicalArrangementType.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.musicalArrangementTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalArrangementIbqDialogController', MusicalArrangementIbqDialogController);

    MusicalArrangementIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'MusicalArrangement', 'MusicalArrangementType', 'Level', 'State', 'Publisher', 'Person'];

    function MusicalArrangementIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, MusicalArrangement, MusicalArrangementType, Level, State, Publisher, Person) {
        var vm = this;

        vm.musicalArrangement = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.musicalarrangementtypes = MusicalArrangementType.query();
        vm.levels = Level.query();
        vm.states = State.query();
        vm.publishers = Publisher.query();
        vm.people = Person.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.musicalArrangement.id !== null) {
                MusicalArrangement.update(vm.musicalArrangement, onSaveSuccess, onSaveError);
            } else {
                MusicalArrangement.save(vm.musicalArrangement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:musicalArrangementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setArrangementFile = function ($file, musicalArrangement) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        musicalArrangement.arrangementFile = base64Data;
                        musicalArrangement.arrangementFileContentType = $file.type;
                        musicalArrangement.arrangementFilePath = $file.name;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalArrangementIbqDetailController', MusicalArrangementIbqDetailController);

    MusicalArrangementIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'MusicalArrangement', 'MusicalArrangementType', 'Level', 'State', 'Publisher', 'Person'];

    function MusicalArrangementIbqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, MusicalArrangement, MusicalArrangementType, Level, State, Publisher, Person) {
        var vm = this;

        vm.musicalArrangement = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:musicalArrangementUpdate', function(event, result) {
            vm.musicalArrangement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalArrangementIbqDeleteController',MusicalArrangementIbqDeleteController);

    MusicalArrangementIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'MusicalArrangement'];

    function MusicalArrangementIbqDeleteController($uibModalInstance, entity, MusicalArrangement) {
        var vm = this;

        vm.musicalArrangement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MusicalArrangement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('musical-arrangement-ibq', {
            parent: 'entity',
            url: '/musical-arrangement-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicalArrangement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/musical-arrangement/musical-arrangementsibq.html',
                    controller: 'MusicalArrangementIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicalArrangement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('musical-arrangement-ibq-detail', {
            parent: 'musical-arrangement-ibq',
            url: '/musical-arrangement-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicalArrangement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/musical-arrangement/musical-arrangement-ibq-detail.html',
                    controller: 'MusicalArrangementIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicalArrangement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MusicalArrangement', function($stateParams, MusicalArrangement) {
                    return MusicalArrangement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'musical-arrangement-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('musical-arrangement-ibq-detail.edit', {
            parent: 'musical-arrangement-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement/musical-arrangement-ibq-dialog.html',
                    controller: 'MusicalArrangementIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicalArrangement', function(MusicalArrangement) {
                            return MusicalArrangement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('musical-arrangement-ibq.new', {
            parent: 'musical-arrangement-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement/musical-arrangement-ibq-dialog.html',
                    controller: 'MusicalArrangementIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                arrangementFile: null,
                                arrangementFileContentType: null,
                                arrangementFilePath: null,
                                pages: null,
                                comments: null,
                                instrumentation: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('musical-arrangement-ibq', null, { reload: 'musical-arrangement-ibq' });
                }, function() {
                    $state.go('musical-arrangement-ibq');
                });
            }]
        })
        .state('musical-arrangement-ibq.edit', {
            parent: 'musical-arrangement-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement/musical-arrangement-ibq-dialog.html',
                    controller: 'MusicalArrangementIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicalArrangement', function(MusicalArrangement) {
                            return MusicalArrangement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('musical-arrangement-ibq', null, { reload: 'musical-arrangement-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('musical-arrangement-ibq.delete', {
            parent: 'musical-arrangement-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-arrangement/musical-arrangement-ibq-delete-dialog.html',
                    controller: 'MusicalArrangementIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MusicalArrangement', function(MusicalArrangement) {
                            return MusicalArrangement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('musical-arrangement-ibq', null, { reload: 'musical-arrangement-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('MusicalArrangement', MusicalArrangement);

    MusicalArrangement.$inject = ['$resource'];

    function MusicalArrangement ($resource) {
        var resourceUrl =  'api/musical-arrangements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('MusicalArrangementSearch', MusicalArrangementSearch);

    MusicalArrangementSearch.$inject = ['$resource'];

    function MusicalArrangementSearch($resource) {
        var resourceUrl =  'api/_search/musical-arrangements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicalArrangementIbqController', MusicalArrangementIbqController);

    MusicalArrangementIbqController.$inject = ['$state', 'DataUtils', 'MusicalArrangement', 'MusicalArrangementSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MusicalArrangementIbqController($state, DataUtils, MusicalArrangement, MusicalArrangementSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                MusicalArrangementSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MusicalArrangement.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.musicalArrangements = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicSheetIbqDialogController', MusicSheetIbqDialogController);

    MusicSheetIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'MusicSheet', 'MusicalPiece', 'Publisher', 'Level', 'State', 'MusicalArrangementType', 'Person', 'PortalRole', 'Country', 'Ensamble'];

    function MusicSheetIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, MusicSheet, MusicalPiece, Publisher, Level, State, MusicalArrangementType, Person, PortalRole, Country, Ensamble ) {
        var vm = this;

        vm.musicSheet = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.musicalpieces = MusicalPiece.query();
        vm.publishers = Publisher.query();
        vm.levels = Level.query();
        vm.states = State.query();
        vm.musicalarrangementtypes = MusicalArrangementType.query();
        vm.people = Person.query();
        vm.portalroles = PortalRole.query();
        vm.countries = Country.query();
        vm.ensambles = Ensamble.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.musicSheet.id !== null) {
                MusicSheet.update(vm.musicSheet, onSaveSuccess, onSaveError);
            } else {
                MusicSheet.save(vm.musicSheet, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:musicSheetUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setMusicSheetFile = function ($file, musicSheet) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        musicSheet.musicSheetFile = base64Data;
                        musicSheet.musicSheetFileContentType = $file.type;
                        musicSheet.musicSheetFilePath=$file.name;
                    });
                });
            }
        };

        vm.setMusicSheetCoverFile = function ($file, musicSheet) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        musicSheet.musicSheetCoverFile = base64Data;
                        musicSheet.musicSheetCoverFileContentType = $file.type;
                        musicSheet.cover=$file.name;
                    });
                });
            }
        };

        vm.datePickerOpenStatus.editionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicSheetIbqDetailController', MusicSheetIbqDetailController);

    MusicSheetIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'MusicSheet', 'MusicalPiece', 'Publisher', 'Level', 'State', 'MusicalArrangementType', 'Person', 'PortalRole', 'Country', 'Ensamble'];

    function MusicSheetIbqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, MusicSheet, MusicalPiece, Publisher, Level, State, MusicalArrangementType, Person, PortalRole, Country, Ensamble) {
        var vm = this;

        vm.musicSheet = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:musicSheetUpdate', function(event, result) {
            vm.musicSheet = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicSheetIbqDeleteController',MusicSheetIbqDeleteController);

    MusicSheetIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'MusicSheet'];

    function MusicSheetIbqDeleteController($uibModalInstance, entity, MusicSheet) {
        var vm = this;

        vm.musicSheet = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MusicSheet.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('music-sheet-ibq', {
            parent: 'entity',
            url: '/music-sheet-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicSheet.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/music-sheet/music-sheetsibq.html',
                    controller: 'MusicSheetIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicSheet');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('music-sheet-ibq-detail', {
            parent: 'music-sheet-ibq',
            url: '/music-sheet-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicSheet.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/music-sheet/music-sheet-ibq-detail.html',
                    controller: 'MusicSheetIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicSheet');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MusicSheet', function($stateParams, MusicSheet) {
                    return MusicSheet.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'music-sheet-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('music-sheet-ibq-detail.edit', {
            parent: 'music-sheet-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/music-sheet/music-sheet-ibq-dialog.html',
                    controller: 'MusicSheetIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicSheet', function(MusicSheet) {
                            return MusicSheet.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('music-sheet-ibq.new', {
            parent: 'music-sheet-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/music-sheet/music-sheet-ibq-dialog.html',
                    controller: 'MusicSheetIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                musicSheetFile: null,
                                musicSheetFileContentType: null,
                                editionDate: null,
                                pages: null,
                                comments: null,
                                musicSheetFilePath: null,
                                title: null,
                                arrangement: null,
                                cover: null,
                                duration: null,
                                movements: null,
                                instrumentation: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('music-sheet-ibq', null, { reload: 'music-sheet-ibq' });
                }, function() {
                    $state.go('music-sheet-ibq');
                });
            }]
        })
        .state('music-sheet-ibq.edit', {
            parent: 'music-sheet-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/music-sheet/music-sheet-ibq-dialog.html',
                    controller: 'MusicSheetIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicSheet', function(MusicSheet) {
                            return MusicSheet.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('music-sheet-ibq', null, { reload: 'music-sheet-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('music-sheet-ibq.delete', {
            parent: 'music-sheet-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/music-sheet/music-sheet-ibq-delete-dialog.html',
                    controller: 'MusicSheetIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MusicSheet', function(MusicSheet) {
                            return MusicSheet.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('music-sheet-ibq', null, { reload: 'music-sheet-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('MusicSheet', MusicSheet);

    MusicSheet.$inject = ['$resource', 'DateUtils'];

    function MusicSheet ($resource, DateUtils) {
        var resourceUrl =  'api/music-sheets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.editionDate = DateUtils.convertLocalDateFromServer(data.editionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.editionDate = DateUtils.convertLocalDateToServer(copy.editionDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.editionDate = DateUtils.convertLocalDateToServer(copy.editionDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('MusicSheetSearch', MusicSheetSearch);

    MusicSheetSearch.$inject = ['$resource'];

    function MusicSheetSearch($resource) {
        var resourceUrl =  'api/_search/music-sheets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicSheetIbqController', MusicSheetIbqController);

    MusicSheetIbqController.$inject = ['$state', 'DataUtils', 'MusicSheet', 'MusicSheetSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MusicSheetIbqController($state, DataUtils, MusicSheet, MusicSheetSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                MusicSheetSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MusicSheet.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.musicSheets = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialFileIbqDialogController', MaterialFileIbqDialogController);

    MaterialFileIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'MaterialFile', 'Material', 'PortalRole', 'Copyright'];

    function MaterialFileIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, MaterialFile, Material, PortalRole, Copyright) {
        var vm = this;

        vm.materialFile = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.materials = Material.query();
        vm.portalroles = PortalRole.query();
        vm.copyrights = Copyright.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.materialFile.id !== null) {
                MaterialFile.update(vm.materialFile, onSaveSuccess, onSaveError);
            } else {
                MaterialFile.save(vm.materialFile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:materialFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setMatlFile = function ($file, materialFile) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        materialFile.matlFile = base64Data;
                        materialFile.matlFileContentType = $file.type;
                        materialFile.partPath=$file.name;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialFileIbqDetailController', MaterialFileIbqDetailController);

    MaterialFileIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'MaterialFile', 'Material', 'PortalRole', 'Copyright'];

    function MaterialFileIbqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, MaterialFile, Material, PortalRole, Copyright) {
        var vm = this;

        vm.materialFile = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:materialFileUpdate', function(event, result) {
            vm.materialFile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialFileIbqDeleteController',MaterialFileIbqDeleteController);

    MaterialFileIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'MaterialFile'];

    function MaterialFileIbqDeleteController($uibModalInstance, entity, MaterialFile) {
        var vm = this;

        vm.materialFile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MaterialFile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('material-file-ibq', {
            parent: 'entity',
            url: '/material-file-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.materialFile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/material-file/material-filesibq.html',
                    controller: 'MaterialFileIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('materialFile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('material-file-ibq-detail', {
            parent: 'material-file-ibq',
            url: '/material-file-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.materialFile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/material-file/material-file-ibq-detail.html',
                    controller: 'MaterialFileIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('materialFile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MaterialFile', function($stateParams, MaterialFile) {
                    return MaterialFile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'material-file-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('material-file-ibq-detail.edit', {
            parent: 'material-file-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material-file/material-file-ibq-dialog.html',
                    controller: 'MaterialFileIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MaterialFile', function(MaterialFile) {
                            return MaterialFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('material-file-ibq.new', {
            parent: 'material-file-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material-file/material-file-ibq-dialog.html',
                    controller: 'MaterialFileIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                matlFile: null,
                                matlFileContentType: null,
                                partPath: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('material-file-ibq', null, { reload: 'material-file-ibq' });
                }, function() {
                    $state.go('material-file-ibq');
                });
            }]
        })
        .state('material-file-ibq.edit', {
            parent: 'material-file-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material-file/material-file-ibq-dialog.html',
                    controller: 'MaterialFileIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MaterialFile', function(MaterialFile) {
                            return MaterialFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('material-file-ibq', null, { reload: 'material-file-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('material-file-ibq.delete', {
            parent: 'material-file-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material-file/material-file-ibq-delete-dialog.html',
                    controller: 'MaterialFileIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MaterialFile', function(MaterialFile) {
                            return MaterialFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('material-file-ibq', null, { reload: 'material-file-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('MaterialFile', MaterialFile);

    MaterialFile.$inject = ['$resource'];

    function MaterialFile ($resource) {
        var resourceUrl =  'api/material-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('MaterialFileSearch', MaterialFileSearch);

    MaterialFileSearch.$inject = ['$resource'];

    function MaterialFileSearch($resource) {
        var resourceUrl =  'api/_search/material-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialFileIbqController', MaterialFileIbqController);

    MaterialFileIbqController.$inject = ['$state', 'DataUtils', 'MaterialFile', 'MaterialFileSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MaterialFileIbqController($state, DataUtils, MaterialFile, MaterialFileSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                MaterialFileSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MaterialFile.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.materialFiles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialIbqDialogController', MaterialIbqDialogController);

    MaterialIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Material', 'MaterialFile', 'Type', 'Publisher', 'Person', 'PortalRole'];

    function MaterialIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Material, MaterialFile, Type, Publisher, Person, PortalRole) {
        var vm = this;

        vm.material = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.materialfiles = MaterialFile.query();
        vm.types = Type.query();
        vm.publishers = Publisher.query();
        vm.people = Person.query();
        vm.portalroles = PortalRole.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.material.id !== null) {
                Material.update(vm.material, onSaveSuccess, onSaveError);
            } else {
                Material.save(vm.material, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:materialUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setCoverFile = function ($file, material) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        material.coverFile = base64Data;
                        material.coverFileContentType = $file.type;
                        material.coverPath = $file.name;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialIbqDetailController', MaterialIbqDetailController);

    MaterialIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Material', 'MaterialFile', 'Type', 'Publisher', 'Person', 'PortalRole'];

    function MaterialIbqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Material, MaterialFile, Type, Publisher, Person, PortalRole) {
        var vm = this;

        vm.material = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:materialUpdate', function(event, result) {
            vm.material = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialIbqDeleteController',MaterialIbqDeleteController);

    MaterialIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Material'];

    function MaterialIbqDeleteController($uibModalInstance, entity, Material) {
        var vm = this;

        vm.material = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Material.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('material-ibq', {
            parent: 'entity',
            url: '/material-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.material.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/material/materialsibq.html',
                    controller: 'MaterialIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('material');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('material-ibq-detail', {
            parent: 'material-ibq',
            url: '/material-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.material.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/material/material-ibq-detail.html',
                    controller: 'MaterialIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('material');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Material', function($stateParams, Material) {
                    return Material.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'material-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('material-ibq-detail.edit', {
            parent: 'material-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material/material-ibq-dialog.html',
                    controller: 'MaterialIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Material', function(Material) {
                            return Material.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('material-ibq.new', {
            parent: 'material-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material/material-ibq-dialog.html',
                    controller: 'MaterialIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                subtitle: null,
                                editionNumber: null,
                                pages: null,
                                isbn: null,
                                description: null,
                                editionYear: null,
                                coverFile: null,
                                coverFileContentType: null,
                                coverPath: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('material-ibq', null, { reload: 'material-ibq' });
                }, function() {
                    $state.go('material-ibq');
                });
            }]
        })
        .state('material-ibq.edit', {
            parent: 'material-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material/material-ibq-dialog.html',
                    controller: 'MaterialIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Material', function(Material) {
                            return Material.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('material-ibq', null, { reload: 'material-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('material-ibq.delete', {
            parent: 'material-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material/material-ibq-delete-dialog.html',
                    controller: 'MaterialIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Material', function(Material) {
                            return Material.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('material-ibq', null, { reload: 'material-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Material', Material);

    Material.$inject = ['$resource'];

    function Material ($resource) {
        var resourceUrl =  'api/materials/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('MaterialSearch', MaterialSearch);

    MaterialSearch.$inject = ['$resource'];

    function MaterialSearch($resource) {
        var resourceUrl =  'api/_search/materials/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialIbqController', MaterialIbqController);

    MaterialIbqController.$inject = ['$state', 'DataUtils', 'Material', 'MaterialSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MaterialIbqController($state, DataUtils, Material, MaterialSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                MaterialSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Material.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.materials = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LevelIbqDialogController', LevelIbqDialogController);

    LevelIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Level'];

    function LevelIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Level) {
        var vm = this;

        vm.level = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.level.id !== null) {
                Level.update(vm.level, onSaveSuccess, onSaveError);
            } else {
                Level.save(vm.level, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:levelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LevelIbqDetailController', LevelIbqDetailController);

    LevelIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Level'];

    function LevelIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Level) {
        var vm = this;

        vm.level = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:levelUpdate', function(event, result) {
            vm.level = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LevelIbqDeleteController',LevelIbqDeleteController);

    LevelIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Level'];

    function LevelIbqDeleteController($uibModalInstance, entity, Level) {
        var vm = this;

        vm.level = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Level.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('level-ibq', {
            parent: 'entity',
            url: '/level-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.level.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/level/levelsibq.html',
                    controller: 'LevelIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('level');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('level-ibq-detail', {
            parent: 'level-ibq',
            url: '/level-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.level.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/level/level-ibq-detail.html',
                    controller: 'LevelIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('level');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Level', function($stateParams, Level) {
                    return Level.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'level-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('level-ibq-detail.edit', {
            parent: 'level-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/level/level-ibq-dialog.html',
                    controller: 'LevelIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Level', function(Level) {
                            return Level.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('level-ibq.new', {
            parent: 'level-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/level/level-ibq-dialog.html',
                    controller: 'LevelIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('level-ibq', null, { reload: 'level-ibq' });
                }, function() {
                    $state.go('level-ibq');
                });
            }]
        })
        .state('level-ibq.edit', {
            parent: 'level-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/level/level-ibq-dialog.html',
                    controller: 'LevelIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Level', function(Level) {
                            return Level.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('level-ibq', null, { reload: 'level-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('level-ibq.delete', {
            parent: 'level-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/level/level-ibq-delete-dialog.html',
                    controller: 'LevelIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Level', function(Level) {
                            return Level.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('level-ibq', null, { reload: 'level-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Level', Level);

    Level.$inject = ['$resource'];

    function Level ($resource) {
        var resourceUrl =  'api/levels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('LevelSearch', LevelSearch);

    LevelSearch.$inject = ['$resource'];

    function LevelSearch($resource) {
        var resourceUrl =  'api/_search/levels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LevelIbqController', LevelIbqController);

    LevelIbqController.$inject = ['$state', 'Level', 'LevelSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function LevelIbqController($state, Level, LevelSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                LevelSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Level.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.levels = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LanguageIbqDialogController', LanguageIbqDialogController);

    LanguageIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Language'];

    function LanguageIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Language) {
        var vm = this;

        vm.language = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.language.id !== null) {
                Language.update(vm.language, onSaveSuccess, onSaveError);
            } else {
                Language.save(vm.language, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:languageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LanguageIbqDetailController', LanguageIbqDetailController);

    LanguageIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Language'];

    function LanguageIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Language) {
        var vm = this;

        vm.language = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:languageUpdate', function(event, result) {
            vm.language = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LanguageIbqDeleteController',LanguageIbqDeleteController);

    LanguageIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Language'];

    function LanguageIbqDeleteController($uibModalInstance, entity, Language) {
        var vm = this;

        vm.language = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Language.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('language-ibq', {
            parent: 'entity',
            url: '/language-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.language.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/language/languagesibq.html',
                    controller: 'LanguageIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('language');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('language-ibq-detail', {
            parent: 'language-ibq',
            url: '/language-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.language.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/language/language-ibq-detail.html',
                    controller: 'LanguageIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('language');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Language', function($stateParams, Language) {
                    return Language.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'language-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('language-ibq-detail.edit', {
            parent: 'language-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language/language-ibq-dialog.html',
                    controller: 'LanguageIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Language', function(Language) {
                            return Language.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('language-ibq.new', {
            parent: 'language-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language/language-ibq-dialog.html',
                    controller: 'LanguageIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('language-ibq', null, { reload: 'language-ibq' });
                }, function() {
                    $state.go('language-ibq');
                });
            }]
        })
        .state('language-ibq.edit', {
            parent: 'language-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language/language-ibq-dialog.html',
                    controller: 'LanguageIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Language', function(Language) {
                            return Language.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('language-ibq', null, { reload: 'language-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('language-ibq.delete', {
            parent: 'language-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language/language-ibq-delete-dialog.html',
                    controller: 'LanguageIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Language', function(Language) {
                            return Language.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('language-ibq', null, { reload: 'language-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Language', Language);

    Language.$inject = ['$resource'];

    function Language ($resource) {
        var resourceUrl =  'api/languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('LanguageSearch', LanguageSearch);

    LanguageSearch.$inject = ['$resource'];

    function LanguageSearch($resource) {
        var resourceUrl =  'api/_search/languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LanguageIbqController', LanguageIbqController);

    LanguageIbqController.$inject = ['$state', 'Language', 'LanguageSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function LanguageIbqController($state, Language, LanguageSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                LanguageSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Language.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.languages = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('InstrumentDialogController', InstrumentDialogController);

    InstrumentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Instrument'];

    function InstrumentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Instrument) {
        var vm = this;

        vm.instrument = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.instrument.id !== null) {
                Instrument.update(vm.instrument, onSaveSuccess, onSaveError);
            } else {
                Instrument.save(vm.instrument, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:instrumentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('InstrumentDetailController', InstrumentDetailController);

    InstrumentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Instrument'];

    function InstrumentDetailController($scope, $rootScope, $stateParams, previousState, entity, Instrument) {
        var vm = this;

        vm.instrument = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:instrumentUpdate', function(event, result) {
            vm.instrument = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('InstrumentDeleteController',InstrumentDeleteController);

    InstrumentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Instrument'];

    function InstrumentDeleteController($uibModalInstance, entity, Instrument) {
        var vm = this;

        vm.instrument = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Instrument.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('instrument', {
            parent: 'entity',
            url: '/instrument?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.instrument.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/instrument/instruments.html',
                    controller: 'InstrumentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('instrument');
                    $translatePartialLoader.addPart('instrumentType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('instrument-detail', {
            parent: 'instrument',
            url: '/instrument/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.instrument.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/instrument/instrument-detail.html',
                    controller: 'InstrumentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('instrument');
                    $translatePartialLoader.addPart('instrumentType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Instrument', function($stateParams, Instrument) {
                    return Instrument.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'instrument',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('instrument-detail.edit', {
            parent: 'instrument-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument/instrument-dialog.html',
                    controller: 'InstrumentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Instrument', function(Instrument) {
                            return Instrument.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('instrument.new', {
            parent: 'instrument',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument/instrument-dialog.html',
                    controller: 'InstrumentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                representation: null,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('instrument', null, { reload: 'instrument' });
                }, function() {
                    $state.go('instrument');
                });
            }]
        })
        .state('instrument.edit', {
            parent: 'instrument',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument/instrument-dialog.html',
                    controller: 'InstrumentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Instrument', function(Instrument) {
                            return Instrument.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('instrument', null, { reload: 'instrument' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('instrument.delete', {
            parent: 'instrument',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument/instrument-delete-dialog.html',
                    controller: 'InstrumentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Instrument', function(Instrument) {
                            return Instrument.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('instrument', null, { reload: 'instrument' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Instrument', Instrument);

    Instrument.$inject = ['$resource'];

    function Instrument ($resource) {
        var resourceUrl =  'api/instruments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('InstrumentSearch', InstrumentSearch);

    InstrumentSearch.$inject = ['$resource'];

    function InstrumentSearch($resource) {
        var resourceUrl =  'api/_search/instruments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('InstrumentController', InstrumentController);

    InstrumentController.$inject = ['$http', '$state', '$scope', 'Upload','DataUtils', 'Instrument', 'InstrumentSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function InstrumentController($http, $state, $scope, Upload, DataUtils, Instrument, InstrumentSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;


        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.myFile;

        loadAll();

        function loadAll() {
            if (pagingParams.search) {
                InstrumentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Instrument.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.instruments = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        vm.setCSVFile = function ($file) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {

                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {

                        $http.post("api/instruments/import", base64Data , null).then(function (response) {
                            loadAll();
                        });
                    });
                });


            }
        };

        $scope.upload = function (file) {
            Upload.upload({
                url: 'api/instruments/import',
                data: {file: file, 'username': ""}
            }).then(function (resp) {
                //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                loadAll();
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('GraphicArchiveItemIbqDialogController', GraphicArchiveItemIbqDialogController);

    GraphicArchiveItemIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GraphicArchiveItem', 'MusicalPiece', 'Publisher', 'Country', 'Person'];

    function GraphicArchiveItemIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GraphicArchiveItem, MusicalPiece, Publisher, Country, Person) {
        var vm = this;

        vm.graphicArchiveItem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.musicalpieces = MusicalPiece.query();
        vm.publishers = Publisher.query();
        vm.countries = Country.query();
        vm.people = Person.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.graphicArchiveItem.id !== null) {
                GraphicArchiveItem.update(vm.graphicArchiveItem, onSaveSuccess, onSaveError);
            } else {
                GraphicArchiveItem.save(vm.graphicArchiveItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:graphicArchiveItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.publicationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('GraphicArchiveItemIbqDetailController', GraphicArchiveItemIbqDetailController);

    GraphicArchiveItemIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GraphicArchiveItem', 'MusicalPiece', 'Publisher', 'Country', 'Person'];

    function GraphicArchiveItemIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, GraphicArchiveItem, MusicalPiece, Publisher, Country, Person) {
        var vm = this;

        vm.graphicArchiveItem = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:graphicArchiveItemUpdate', function(event, result) {
            vm.graphicArchiveItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('GraphicArchiveItemIbqDeleteController',GraphicArchiveItemIbqDeleteController);

    GraphicArchiveItemIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'GraphicArchiveItem'];

    function GraphicArchiveItemIbqDeleteController($uibModalInstance, entity, GraphicArchiveItem) {
        var vm = this;

        vm.graphicArchiveItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GraphicArchiveItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('graphic-archive-item-ibq', {
            parent: 'entity',
            url: '/graphic-archive-item-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.graphicArchiveItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/graphic-archive-item/graphic-archive-itemsibq.html',
                    controller: 'GraphicArchiveItemIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('graphicArchiveItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('graphic-archive-item-ibq-detail', {
            parent: 'graphic-archive-item-ibq',
            url: '/graphic-archive-item-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.graphicArchiveItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/graphic-archive-item/graphic-archive-item-ibq-detail.html',
                    controller: 'GraphicArchiveItemIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('graphicArchiveItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GraphicArchiveItem', function($stateParams, GraphicArchiveItem) {
                    return GraphicArchiveItem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'graphic-archive-item-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('graphic-archive-item-ibq-detail.edit', {
            parent: 'graphic-archive-item-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/graphic-archive-item/graphic-archive-item-ibq-dialog.html',
                    controller: 'GraphicArchiveItemIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GraphicArchiveItem', function(GraphicArchiveItem) {
                            return GraphicArchiveItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('graphic-archive-item-ibq.new', {
            parent: 'graphic-archive-item-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/graphic-archive-item/graphic-archive-item-ibq-dialog.html',
                    controller: 'GraphicArchiveItemIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                publicationDate: null,
                                publicationPlace: null,
                                note: null,
                                source: null,
                                title: null,
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('graphic-archive-item-ibq', null, { reload: 'graphic-archive-item-ibq' });
                }, function() {
                    $state.go('graphic-archive-item-ibq');
                });
            }]
        })
        .state('graphic-archive-item-ibq.edit', {
            parent: 'graphic-archive-item-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/graphic-archive-item/graphic-archive-item-ibq-dialog.html',
                    controller: 'GraphicArchiveItemIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GraphicArchiveItem', function(GraphicArchiveItem) {
                            return GraphicArchiveItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('graphic-archive-item-ibq', null, { reload: 'graphic-archive-item-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('graphic-archive-item-ibq.delete', {
            parent: 'graphic-archive-item-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/graphic-archive-item/graphic-archive-item-ibq-delete-dialog.html',
                    controller: 'GraphicArchiveItemIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GraphicArchiveItem', function(GraphicArchiveItem) {
                            return GraphicArchiveItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('graphic-archive-item-ibq', null, { reload: 'graphic-archive-item-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('GraphicArchiveItem', GraphicArchiveItem);

    GraphicArchiveItem.$inject = ['$resource', 'DateUtils'];

    function GraphicArchiveItem ($resource, DateUtils) {
        var resourceUrl =  'api/graphic-archive-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.publicationDate = DateUtils.convertLocalDateFromServer(data.publicationDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.publicationDate = DateUtils.convertLocalDateToServer(copy.publicationDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.publicationDate = DateUtils.convertLocalDateToServer(copy.publicationDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('GraphicArchiveItemSearch', GraphicArchiveItemSearch);

    GraphicArchiveItemSearch.$inject = ['$resource'];

    function GraphicArchiveItemSearch($resource) {
        var resourceUrl =  'api/_search/graphic-archive-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('GraphicArchiveItemIbqController', GraphicArchiveItemIbqController);

    GraphicArchiveItemIbqController.$inject = ['$state', 'GraphicArchiveItem', 'GraphicArchiveItemSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function GraphicArchiveItemIbqController($state, GraphicArchiveItem, GraphicArchiveItemSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                GraphicArchiveItemSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                GraphicArchiveItem.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.graphicArchiveItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('GenreIbqDialogController', GenreIbqDialogController);

    GenreIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Genre'];

    function GenreIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Genre) {
        var vm = this;

        vm.genre = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.genre.id !== null) {
                Genre.update(vm.genre, onSaveSuccess, onSaveError);
            } else {
                Genre.save(vm.genre, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:genreUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('GenreIbqDetailController', GenreIbqDetailController);

    GenreIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Genre'];

    function GenreIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Genre) {
        var vm = this;

        vm.genre = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:genreUpdate', function(event, result) {
            vm.genre = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('GenreIbqDeleteController',GenreIbqDeleteController);

    GenreIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Genre'];

    function GenreIbqDeleteController($uibModalInstance, entity, Genre) {
        var vm = this;

        vm.genre = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Genre.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('genre-ibq', {
            parent: 'entity',
            url: '/genre-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.genre.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/genre/genresibq.html',
                    controller: 'GenreIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('genre');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('genre-ibq-detail', {
            parent: 'genre-ibq',
            url: '/genre-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.genre.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/genre/genre-ibq-detail.html',
                    controller: 'GenreIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('genre');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Genre', function($stateParams, Genre) {
                    return Genre.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'genre-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('genre-ibq-detail.edit', {
            parent: 'genre-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/genre/genre-ibq-dialog.html',
                    controller: 'GenreIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Genre', function(Genre) {
                            return Genre.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('genre-ibq.new', {
            parent: 'genre-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/genre/genre-ibq-dialog.html',
                    controller: 'GenreIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('genre-ibq', null, { reload: 'genre-ibq' });
                }, function() {
                    $state.go('genre-ibq');
                });
            }]
        })
        .state('genre-ibq.edit', {
            parent: 'genre-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/genre/genre-ibq-dialog.html',
                    controller: 'GenreIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Genre', function(Genre) {
                            return Genre.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('genre-ibq', null, { reload: 'genre-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('genre-ibq.delete', {
            parent: 'genre-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/genre/genre-ibq-delete-dialog.html',
                    controller: 'GenreIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Genre', function(Genre) {
                            return Genre.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('genre-ibq', null, { reload: 'genre-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Genre', Genre);

    Genre.$inject = ['$resource'];

    function Genre ($resource) {
        var resourceUrl =  'api/genres/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('GenreSearch', GenreSearch);

    GenreSearch.$inject = ['$resource'];

    function GenreSearch($resource) {
        var resourceUrl =  'api/_search/genres/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('GenreIbqController', GenreIbqController);

    GenreIbqController.$inject = ['$state', 'Genre', 'GenreSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function GenreIbqController($state, Genre, GenreSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                GenreSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Genre.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.genres = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('EnsambleIbqDialogController', EnsambleIbqDialogController);

    EnsambleIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ensamble', 'MusicalPiece', 'MusicSheet'];

    function EnsambleIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ensamble, MusicalPiece, MusicSheet) {
        var vm = this;

        vm.ensamble = entity;
        vm.clear = clear;
        vm.save = save;
        vm.musicalpieces = MusicalPiece.query();
        vm.musicsheets = MusicSheet.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ensamble.id !== null) {
                Ensamble.update(vm.ensamble, onSaveSuccess, onSaveError);
            } else {
                Ensamble.save(vm.ensamble, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:ensambleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('EnsambleIbqDetailController', EnsambleIbqDetailController);

    EnsambleIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ensamble', 'MusicalPiece', 'MusicSheet'];

    function EnsambleIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Ensamble, MusicalPiece, MusicSheet) {
        var vm = this;

        vm.ensamble = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:ensambleUpdate', function(event, result) {
            vm.ensamble = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('EnsambleIbqDeleteController',EnsambleIbqDeleteController);

    EnsambleIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ensamble'];

    function EnsambleIbqDeleteController($uibModalInstance, entity, Ensamble) {
        var vm = this;

        vm.ensamble = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ensamble.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ensamble-ibq', {
            parent: 'entity',
            url: '/ensamble-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.ensamble.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ensamble/ensamblesibq.html',
                    controller: 'EnsambleIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ensamble');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ensamble-ibq-detail', {
            parent: 'ensamble-ibq',
            url: '/ensamble-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.ensamble.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ensamble/ensamble-ibq-detail.html',
                    controller: 'EnsambleIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ensamble');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ensamble', function($stateParams, Ensamble) {
                    return Ensamble.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ensamble-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ensamble-ibq-detail.edit', {
            parent: 'ensamble-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ensamble/ensamble-ibq-dialog.html',
                    controller: 'EnsambleIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ensamble', function(Ensamble) {
                            return Ensamble.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ensamble-ibq.new', {
            parent: 'ensamble-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ensamble/ensamble-ibq-dialog.html',
                    controller: 'EnsambleIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ensamble-ibq', null, { reload: 'ensamble-ibq' });
                }, function() {
                    $state.go('ensamble-ibq');
                });
            }]
        })
        .state('ensamble-ibq.edit', {
            parent: 'ensamble-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ensamble/ensamble-ibq-dialog.html',
                    controller: 'EnsambleIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ensamble', function(Ensamble) {
                            return Ensamble.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ensamble-ibq', null, { reload: 'ensamble-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ensamble-ibq.delete', {
            parent: 'ensamble-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ensamble/ensamble-ibq-delete-dialog.html',
                    controller: 'EnsambleIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ensamble', function(Ensamble) {
                            return Ensamble.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ensamble-ibq', null, { reload: 'ensamble-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Ensamble', Ensamble);

    Ensamble.$inject = ['$resource'];

    function Ensamble ($resource) {
        var resourceUrl =  'api/ensambles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('EnsambleSearch', EnsambleSearch);

    EnsambleSearch.$inject = ['$resource'];

    function EnsambleSearch($resource) {
        var resourceUrl =  'api/_search/ensambles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('EnsambleIbqController', EnsambleIbqController);

    EnsambleIbqController.$inject = ['$state', 'Ensamble', 'EnsambleSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function EnsambleIbqController($state, Ensamble, EnsambleSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                EnsambleSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Ensamble.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.ensambles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('DiscIbqDialogController', DiscIbqDialogController);

    DiscIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Disc', 'Audio', 'Collection', 'Participation'];

    function DiscIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Disc, Audio, Collection, Participation) {
        var vm = this;

        vm.disc = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.audio = Audio.query();
        vm.collections = Collection.query();
        vm.participations = Participation.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.disc.id !== null) {
                Disc.update(vm.disc, onSaveSuccess, onSaveError);
            } else {
                Disc.save(vm.disc, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:discUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setCoverFile = function ($file, disc) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        disc.coverFile = base64Data;
                        disc.coverFileContentType = $file.type;
                        disc.coverPath = $file.name;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('DiscIbqDetailController', DiscIbqDetailController);

    DiscIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Disc', 'Audio', 'Collection', 'Participation'];

    function DiscIbqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Disc, Audio, Collection, Participation) {
        var vm = this;

        vm.disc = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:discUpdate', function(event, result) {
            vm.disc = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('DiscIbqDeleteController',DiscIbqDeleteController);

    DiscIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Disc'];

    function DiscIbqDeleteController($uibModalInstance, entity, Disc) {
        var vm = this;

        vm.disc = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Disc.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('disc-ibq', {
            parent: 'entity',
            url: '/disc-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.disc.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disc/discsibq.html',
                    controller: 'DiscIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('disc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('disc-ibq-detail', {
            parent: 'disc-ibq',
            url: '/disc-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.disc.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disc/disc-ibq-detail.html',
                    controller: 'DiscIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('disc');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Disc', function($stateParams, Disc) {
                    return Disc.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'disc-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('disc-ibq-detail.edit', {
            parent: 'disc-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disc/disc-ibq-dialog.html',
                    controller: 'DiscIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Disc', function(Disc) {
                            return Disc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('disc-ibq.new', {
            parent: 'disc-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disc/disc-ibq-dialog.html',
                    controller: 'DiscIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                paralelTitle: null,
                                serieNumber: null,
                                content: null,
                                productionYear: null,
                                coverFile: null,
                                coverFileContentType: null,
                                coverPath: null,
                                producer: null,
                                interpreter: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('disc-ibq', null, { reload: 'disc-ibq' });
                }, function() {
                    $state.go('disc-ibq');
                });
            }]
        })
        .state('disc-ibq.edit', {
            parent: 'disc-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disc/disc-ibq-dialog.html',
                    controller: 'DiscIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Disc', function(Disc) {
                            return Disc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('disc-ibq', null, { reload: 'disc-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('disc-ibq.delete', {
            parent: 'disc-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disc/disc-ibq-delete-dialog.html',
                    controller: 'DiscIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Disc', function(Disc) {
                            return Disc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('disc-ibq', null, { reload: 'disc-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Disc', Disc);

    Disc.$inject = ['$resource'];

    function Disc ($resource) {
        var resourceUrl =  'api/discs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('DiscSearch', DiscSearch);

    DiscSearch.$inject = ['$resource'];

    function DiscSearch($resource) {
        var resourceUrl =  'api/_search/discs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('DiscIbqController', DiscIbqController);

    DiscIbqController.$inject = ['$state', 'DataUtils', 'Disc', 'DiscSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DiscIbqController($state, DataUtils, Disc, DiscSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DiscSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Disc.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.discs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CountryIbqDialogController', CountryIbqDialogController);

    CountryIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Country'];

    function CountryIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.country.id !== null) {
                Country.update(vm.country, onSaveSuccess, onSaveError);
            } else {
                Country.save(vm.country, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:countryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CountryIbqDetailController', CountryIbqDetailController);

    CountryIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Country'];

    function CountryIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:countryUpdate', function(event, result) {
            vm.country = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CountryIbqDeleteController',CountryIbqDeleteController);

    CountryIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Country'];

    function CountryIbqDeleteController($uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Country.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('country-ibq', {
            parent: 'entity',
            url: '/country-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.country.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/countriesibq.html',
                    controller: 'CountryIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('country-ibq-detail', {
            parent: 'country-ibq',
            url: '/country-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.country.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/country-ibq-detail.html',
                    controller: 'CountryIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Country', function($stateParams, Country) {
                    return Country.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'country-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('country-ibq-detail.edit', {
            parent: 'country-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-ibq-dialog.html',
                    controller: 'CountryIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country-ibq.new', {
            parent: 'country-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-ibq-dialog.html',
                    controller: 'CountryIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                belongIbq: null,
                                url: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('country-ibq', null, { reload: 'country-ibq' });
                }, function() {
                    $state.go('country-ibq');
                });
            }]
        })
        .state('country-ibq.edit', {
            parent: 'country-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-ibq-dialog.html',
                    controller: 'CountryIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country-ibq', null, { reload: 'country-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country-ibq.delete', {
            parent: 'country-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-ibq-delete-dialog.html',
                    controller: 'CountryIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country-ibq', null, { reload: 'country-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Country', Country);

    Country.$inject = ['$resource'];

    function Country ($resource) {
        var resourceUrl =  'api/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('CountrySearch', CountrySearch);

    CountrySearch.$inject = ['$resource'];

    function CountrySearch($resource) {
        var resourceUrl =  'api/_search/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CountryIbqController', CountryIbqController);

    CountryIbqController.$inject = ['$state', 'Country', 'CountrySearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CountryIbqController($state, Country, CountrySearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CountrySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Country.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.countries = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CopyrightDialogController', CopyrightDialogController);

    CopyrightDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Copyright'];

    function CopyrightDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Copyright) {
        var vm = this;

        vm.copyright = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.copyright.id !== null) {
                Copyright.update(vm.copyright, onSaveSuccess, onSaveError);
            } else {
                Copyright.save(vm.copyright, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:copyrightUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CopyrightDetailController', CopyrightDetailController);

    CopyrightDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Copyright'];

    function CopyrightDetailController($scope, $rootScope, $stateParams, previousState, entity, Copyright) {
        var vm = this;

        vm.copyright = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:copyrightUpdate', function(event, result) {
            vm.copyright = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CopyrightDeleteController',CopyrightDeleteController);

    CopyrightDeleteController.$inject = ['$uibModalInstance', 'entity', 'Copyright'];

    function CopyrightDeleteController($uibModalInstance, entity, Copyright) {
        var vm = this;

        vm.copyright = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Copyright.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('copyright', {
            parent: 'entity',
            url: '/copyright?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.copyright.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/copyright/copyrights.html',
                    controller: 'CopyrightController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('copyright');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('copyright-detail', {
            parent: 'copyright',
            url: '/copyright/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.copyright.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/copyright/copyright-detail.html',
                    controller: 'CopyrightDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('copyright');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Copyright', function($stateParams, Copyright) {
                    return Copyright.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'copyright',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('copyright-detail.edit', {
            parent: 'copyright-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/copyright/copyright-dialog.html',
                    controller: 'CopyrightDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Copyright', function(Copyright) {
                            return Copyright.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('copyright.new', {
            parent: 'copyright',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/copyright/copyright-dialog.html',
                    controller: 'CopyrightDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('copyright', null, { reload: 'copyright' });
                }, function() {
                    $state.go('copyright');
                });
            }]
        })
        .state('copyright.edit', {
            parent: 'copyright',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/copyright/copyright-dialog.html',
                    controller: 'CopyrightDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Copyright', function(Copyright) {
                            return Copyright.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('copyright', null, { reload: 'copyright' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('copyright.delete', {
            parent: 'copyright',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/copyright/copyright-delete-dialog.html',
                    controller: 'CopyrightDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Copyright', function(Copyright) {
                            return Copyright.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('copyright', null, { reload: 'copyright' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Copyright', Copyright);

    Copyright.$inject = ['$resource'];

    function Copyright ($resource) {
        var resourceUrl =  'api/copyrights/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('CopyrightSearch', CopyrightSearch);

    CopyrightSearch.$inject = ['$resource'];

    function CopyrightSearch($resource) {
        var resourceUrl =  'api/_search/copyrights/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CopyrightController', CopyrightController);

    CopyrightController.$inject = ['$state', 'Copyright', 'CopyrightSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CopyrightController($state, Copyright, CopyrightSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CopyrightSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Copyright.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.copyrights = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CollectionIbqDialogController', CollectionIbqDialogController);

    CollectionIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Collection', 'Disc'];

    function CollectionIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Collection, Disc) {
        var vm = this;

        vm.collection = entity;
        vm.clear = clear;
        vm.save = save;
        vm.discs = Disc.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.collection.id !== null) {
                Collection.update(vm.collection, onSaveSuccess, onSaveError);
            } else {
                Collection.save(vm.collection, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:collectionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CollectionIbqDetailController', CollectionIbqDetailController);

    CollectionIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Collection', 'Disc'];

    function CollectionIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Collection, Disc) {
        var vm = this;

        vm.collection = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:collectionUpdate', function(event, result) {
            vm.collection = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CollectionIbqDeleteController',CollectionIbqDeleteController);

    CollectionIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Collection'];

    function CollectionIbqDeleteController($uibModalInstance, entity, Collection) {
        var vm = this;

        vm.collection = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Collection.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('collection-ibq', {
            parent: 'entity',
            url: '/collection-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.collection.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/collection/collectionsibq.html',
                    controller: 'CollectionIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('collection');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('collection-ibq-detail', {
            parent: 'collection-ibq',
            url: '/collection-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.collection.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/collection/collection-ibq-detail.html',
                    controller: 'CollectionIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('collection');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Collection', function($stateParams, Collection) {
                    return Collection.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'collection-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('collection-ibq-detail.edit', {
            parent: 'collection-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collection/collection-ibq-dialog.html',
                    controller: 'CollectionIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Collection', function(Collection) {
                            return Collection.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('collection-ibq.new', {
            parent: 'collection-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collection/collection-ibq-dialog.html',
                    controller: 'CollectionIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('collection-ibq', null, { reload: 'collection-ibq' });
                }, function() {
                    $state.go('collection-ibq');
                });
            }]
        })
        .state('collection-ibq.edit', {
            parent: 'collection-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collection/collection-ibq-dialog.html',
                    controller: 'CollectionIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Collection', function(Collection) {
                            return Collection.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('collection-ibq', null, { reload: 'collection-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('collection-ibq.delete', {
            parent: 'collection-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collection/collection-ibq-delete-dialog.html',
                    controller: 'CollectionIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Collection', function(Collection) {
                            return Collection.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('collection-ibq', null, { reload: 'collection-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Collection', Collection);

    Collection.$inject = ['$resource'];

    function Collection ($resource) {
        var resourceUrl =  'api/collections/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('CollectionSearch', CollectionSearch);

    CollectionSearch.$inject = ['$resource'];

    function CollectionSearch($resource) {
        var resourceUrl =  'api/_search/collections/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CollectionIbqController', CollectionIbqController);

    CollectionIbqController.$inject = ['$state', 'Collection', 'CollectionSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CollectionIbqController($state, Collection, CollectionSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CollectionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Collection.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.collections = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CategoryIbqDialogController', CategoryIbqDialogController);

    CategoryIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Category', 'MusicalPiece'];

    function CategoryIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Category, MusicalPiece) {
        var vm = this;

        vm.category = entity;
        vm.clear = clear;
        vm.save = save;
        vm.categories = Category.query();
        vm.musicalpieces = MusicalPiece.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.category.id !== null) {
                Category.update(vm.category, onSaveSuccess, onSaveError);
            } else {
                Category.save(vm.category, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:categoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CategoryIbqDetailController', CategoryIbqDetailController);

    CategoryIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Category', 'MusicalPiece'];

    function CategoryIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Category, MusicalPiece) {
        var vm = this;

        vm.category = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:categoryUpdate', function(event, result) {
            vm.category = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CategoryIbqDeleteController',CategoryIbqDeleteController);

    CategoryIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Category'];

    function CategoryIbqDeleteController($uibModalInstance, entity, Category) {
        var vm = this;

        vm.category = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Category.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('category-ibq', {
            parent: 'entity',
            url: '/category-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.category.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/category/categoriesibq.html',
                    controller: 'CategoryIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('category');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('category-ibq-detail', {
            parent: 'category-ibq',
            url: '/category-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.category.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/category/category-ibq-detail.html',
                    controller: 'CategoryIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('category');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Category', function($stateParams, Category) {
                    return Category.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'category-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('category-ibq-detail.edit', {
            parent: 'category-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/category/category-ibq-dialog.html',
                    controller: 'CategoryIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Category', function(Category) {
                            return Category.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('category-ibq.new', {
            parent: 'category-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/category/category-ibq-dialog.html',
                    controller: 'CategoryIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('category-ibq', null, { reload: 'category-ibq' });
                }, function() {
                    $state.go('category-ibq');
                });
            }]
        })
        .state('category-ibq.edit', {
            parent: 'category-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/category/category-ibq-dialog.html',
                    controller: 'CategoryIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Category', function(Category) {
                            return Category.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('category-ibq', null, { reload: 'category-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('category-ibq.delete', {
            parent: 'category-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/category/category-ibq-delete-dialog.html',
                    controller: 'CategoryIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Category', function(Category) {
                            return Category.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('category-ibq', null, { reload: 'category-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Category', Category);

    Category.$inject = ['$resource'];

    function Category ($resource) {
        var resourceUrl =  'api/categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('CategorySearch', CategorySearch);

    CategorySearch.$inject = ['$resource'];

    function CategorySearch($resource) {
        var resourceUrl =  'api/_search/categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CategoryIbqController', CategoryIbqController);

    CategoryIbqController.$inject = ['$state', 'Category', 'CategorySearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CategoryIbqController($state, Category, CategorySearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.roleSync = roleSync;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CategorySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Category.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.categories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function roleSync() {
           console.log("Sync Roles");
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('AudioIbqDialogController', AudioIbqDialogController);

    AudioIbqDialogController.$inject = ['$sanitize','$timeout', '$scope', '$stateParams', '$uibModalInstance','DataUtils', 'entity', 'Audio', 'Disc', 'MusicalPiece', 'Person', 'Copyright'];

    function AudioIbqDialogController ($sanitize, $timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Audio, Disc, MusicalPiece, Person, Copyright) {
        var vm = this;
        vm.audio = entity;
        vm.clear = clear;
        vm.save = save;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.discs = Disc.query();
        vm.musicalpieces = MusicalPiece.query();
        vm.people = Person.query();
        vm.copyrights = Copyright.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            //vm.audio.audioFile=$sanitize(vm.audio.audioFile);

            if (vm.audio.id !== null) {
                Audio.update(vm.audio, onSaveSuccess, onSaveError);
            } else {
                Audio.save(vm.audio, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:audioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.setAudioFile = function ($file, audioFile) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        audioFile.afile = base64Data;
                        audioFile.audioContentType = $file.type;
                        audioFile.audioFile=$file.name;
                    });
                });
            }
        };


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('AudioIbqDetailController', AudioIbqDetailController);

    AudioIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Audio', 'Disc', 'MusicalPiece', 'Person', 'Copyright'];

    function AudioIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Audio, Disc, MusicalPiece, Person, Copyright) {
        var vm = this;

        vm.audio = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:audioUpdate', function(event, result) {
            vm.audio = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('AudioIbqDeleteController',AudioIbqDeleteController);

    AudioIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Audio'];

    function AudioIbqDeleteController($uibModalInstance, entity, Audio) {
        var vm = this;

        vm.audio = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Audio.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('audio-ibq', {
            parent: 'entity',
            url: '/audio-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.audio.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/audio/audioibq.html',
                    controller: 'AudioIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('audio-ibq-detail', {
            parent: 'audio-ibq',
            url: '/audio-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.audio.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/audio/audio-ibq-detail.html',
                    controller: 'AudioIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audio');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Audio', function($stateParams, Audio) {
                    return Audio.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'audio-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('audio-ibq-detail.edit', {
            parent: 'audio-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/audio/audio-ibq-dialog.html',
                    controller: 'AudioIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Audio', function(Audio) {
                            return Audio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('audio-ibq.new', {
            parent: 'audio-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/audio/audio-ibq-dialog.html',
                    controller: 'AudioIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                audioFile: null,
                                duration: null,
                                didactic: null,
                                audioURL: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('audio-ibq', null, { reload: 'audio-ibq' });
                }, function() {
                    $state.go('audio-ibq');
                });
            }]
        })
        .state('audio-ibq.edit', {
            parent: 'audio-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/audio/audio-ibq-dialog.html',
                    controller: 'AudioIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Audio', function(Audio) {
                            return Audio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('audio-ibq', null, { reload: 'audio-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('audio-ibq.delete', {
            parent: 'audio-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/audio/audio-ibq-delete-dialog.html',
                    controller: 'AudioIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Audio', function(Audio) {
                            return Audio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('audio-ibq', null, { reload: 'audio-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Audio', Audio);

    Audio.$inject = ['$resource'];

    function Audio ($resource) {
        var resourceUrl =  'api/audio/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('AudioSearch', AudioSearch);

    AudioSearch.$inject = ['$resource'];

    function AudioSearch($resource) {
        var resourceUrl =  'api/_search/audio/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('AudioIbqController', AudioIbqController);

    AudioIbqController.$inject = ['$state','$sce', 'Audio', 'AudioSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AudioIbqController($state ,$sce, Audio, AudioSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.trustAsHtml=$sce.trustAsHtml;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                AudioSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Audio.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.audio = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('AlbumDialogController', AlbumDialogController);

    AlbumDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Album'];

    function AlbumDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Album) {
        var vm = this;

        vm.album = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.album.id !== null) {
                Album.update(vm.album, onSaveSuccess, onSaveError);
            } else {
                Album.save(vm.album, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:albumUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('AlbumDetailController', AlbumDetailController);

    AlbumDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Album'];

    function AlbumDetailController($scope, $rootScope, $stateParams, previousState, entity, Album) {
        var vm = this;

        vm.album = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:albumUpdate', function(event, result) {
            vm.album = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('AlbumDeleteController',AlbumDeleteController);

    AlbumDeleteController.$inject = ['$uibModalInstance', 'entity', 'Album'];

    function AlbumDeleteController($uibModalInstance, entity, Album) {
        var vm = this;

        vm.album = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Album.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('album', {
            parent: 'entity',
            url: '/album?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.album.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/album/albums.html',
                    controller: 'AlbumController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('album');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('album-detail', {
            parent: 'album',
            url: '/album/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.album.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/album/album-detail.html',
                    controller: 'AlbumDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('album');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Album', function($stateParams, Album) {
                    return Album.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'album',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('album-detail.edit', {
            parent: 'album-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/album/album-dialog.html',
                    controller: 'AlbumDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Album', function(Album) {
                            return Album.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('album.new', {
            parent: 'album',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/album/album-dialog.html',
                    controller: 'AlbumDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('album', null, { reload: 'album' });
                }, function() {
                    $state.go('album');
                });
            }]
        })
        .state('album.edit', {
            parent: 'album',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/album/album-dialog.html',
                    controller: 'AlbumDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Album', function(Album) {
                            return Album.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('album', null, { reload: 'album' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('album.delete', {
            parent: 'album',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/album/album-delete-dialog.html',
                    controller: 'AlbumDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Album', function(Album) {
                            return Album.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('album', null, { reload: 'album' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Album', Album);

    Album.$inject = ['$resource'];

    function Album ($resource) {
        var resourceUrl =  'api/albums/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('AlbumSearch', AlbumSearch);

    AlbumSearch.$inject = ['$resource'];

    function AlbumSearch($resource) {
        var resourceUrl =  'api/_search/albums/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('AlbumController', AlbumController);

    AlbumController.$inject = ['$state', 'Album', 'AlbumSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AlbumController($state, Album, AlbumSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                AlbumSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Album.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.albums = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('virtuallibraryApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'pt-pt': { name: 'Português' },
        'es': { name: 'Español' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'es',
            'pt-pt'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('virtuallibraryApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('virtuallibraryApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('virtuallibraryApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('virtuallibraryApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('virtuallibraryApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "es"');
                $cookies.putObject(name, 'es');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('es');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('virtuallibraryApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1717505421448)
;
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('virtuallibraryApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('elasticsearch-reindex');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource'];

    function ElasticsearchReindex($resource) {
        var service = $resource('api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'email address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('about-us', {
            parent: 'app',
            url: '/about-us',
            data: {
                authorities: [],
                pageTitle: 'global.menu.about-us'
            },
            views: {
                'content@': {
                    templateUrl: 'app/about-us/about-us.html',
                    controller: 'AboutUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('about-us');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('AboutUsService', AboutUsService);

    AboutUsService.$inject = ['$resource'];

    function AboutUsService($resource) {
        var service = {
            getOrdinalIndicator: getOrdinalIndicator
        };

        return service;

        function getOrdinalIndicator(n) {

            if (n || n === 0) {

                if (hasANonGenericOrdinalIndicator(n)) {
                    return 'th';
                }

                var decimal = n % 10;
                switch (decimal) {
                    case 1:
                        return 'st';
                        break;
                    case 2:
                        return 'nd';
                        break;
                    case 3:
                        return 'rd';
                        break;
                    default:
                        return 'th';
                        break;
                }
            }

            return '';
        }

        function hasANonGenericOrdinalIndicator(n) {
            var lastTwoDigits = n % 100;
            return lastTwoDigits > 10 && lastTwoDigits < 14;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .directive('aboutToday', aboutToday);

    aboutToday.$inject = ['AboutUsService'];

    function aboutToday(AboutUsService) {

        var directive = {
            restrict: 'A',
            template: 'Today is {{weekday}}, the {{dateWithOrdinal}} of {{month}}, {{fullYear}}',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {

            element.addClass('text-left');

            var today = new Date();
            var date = today.getDate();

            scope.weekday = today.toLocaleString('en-us', {weekday: 'long'});
            scope.dateWithOrdinal = date + AboutUsService.getOrdinalIndicator(date);
            scope.month = today.toLocaleString('en-us', {month: 'long'});
            scope.fullYear = today.getFullYear();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('AboutUsController', AboutUsController);

    AboutUsController.$inject = ['$scope', 'AboutUsService'];

    function AboutUsController($scope, AboutUsService) {
        var vm = this;

        $scope.controllerMessage = todayToString();

        vm.todayToString = todayToString;

        function todayToString() {
            var today = new Date();
            var dayName = today.toLocaleString('en-us', {weekday: 'long'});
            var monthName = today.toLocaleString('en-us', {month: 'long'});
            var date = today.getDate();

            return 'Today is ' + dayName + ', the ' + dateWithOrdinal(date) + ' of ' + monthName + ', ' + today.getFullYear();
        }

        function dateWithOrdinal(date) {
            return date + AboutUsService.getOrdinalIndicator(date);
        }

    }
})();
(function(){angular.module('virtuallibraryApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/about-us/about-us.html','<div ng-cloak><div class="row"><div class="col-md-1"></div><div class="col-md-10"><!--directive: start--><h6 about-today></h6><!--directive: end--><h6 class="text-right" ng-bind="controllerMessage"></h6><h1 class="text-capitalize text-center" data-translate="about-us.title">Title</h1><h5 class="text-center" data-translate="about-us.subtitle">Subtitle</h5><hr><p class="text-justify" data-translate="about-us.content">Content</p></div><div class="col-md-1"></div></div></div>');
$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><!--div class="col-md-4">\n            <span class="hipster img-responsive img-rounded"></span>\n        </div--><div class="col-md-12"><!--<span class="hipster img-responsive img-rounded"></span>--><h1 data-translate="home.title">Welcome to the administration system of the Virtual Library of Iberorquestas Juveniles!</h1><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><!--div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.authenticated" translate-compile>\n                    If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br/>- Administrator (login="admin" and password="admin") <br/>- User (login="user" and password="user").\n                </div>\n\n                <div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile>\n                    You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a>\n                </div--></div><!--<p data-translate="home.question">If you have any question on JHipster: </p>--><!--ul>\n                <li><a href="http://www.jhipster.tech/" target="_blank" rel="noopener" data-translate="home.link.homepage">JHipster homepage</a></li>\n                <li><a href="http://stackoverflow.com/tags/jhipster/info" target="_blank" rel="noopener" data-translate="home.link.stackoverflow">JHipster on Stack Overflow</a></li>\n                <li><a href="https://github.com/jhipster/generator-jhipster/issues?state=open" target="_blank" rel="noopener" data-translate="home.link.bugtracker">JHipster bug tracker</a></li>\n                <li><a href="https://gitter.im/jhipster/generator-jhipster" target="_blank" rel="noopener" data-translate="home.link.chat">JHipster public chat room</a></li>\n                <li><a href="https://twitter.com/java_hipster" target="_blank" rel="noopener" data-translate="home.link.follow">follow @java_hipster on Twitter</a></li>\n            </ul--><!--p>\n             <span data-translate="home.like">If you like JHipster, don\'t forget to give us a star on </span>&nbsp;<a href="https://github.com/jhipster/generator-jhipster" target="_blank" rel="noopener" data-translate="home.github">GitHub</a>!\n            </p--></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><!--div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>\n                If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br/>- Administrator (login="admin" and password="admin") <br/>- User (login="user" and password="user").\n            </div--></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length === 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length === 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm" ng-submit="vm.confirmReindex()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="elasticsearch.reindex.dialog.title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="elasticsearch.reindex.dialog.question">Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.confirm">Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<div class="clearfix"><h1 data-translate="elasticsearch.reindex.title">Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p data-translate="elasticsearch.reindex.instructions1">This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p data-translate="elasticsearch.reindex.instructions2">This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><button type="button" class="btn btn-primary pull-right" ui-sref="elasticsearch-reindex.dialog"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="elasticsearch.reindex.go">Go</span></button></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><!--div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>\n                You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a>\n            </div--></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.http.403">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo.svg" alt="logo" width="212" height="93"> <span data-translate="global.title" class="logo-text">Virtual library</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!--li ui-sref-active="active">\n                                <a ui-sref="about-us" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span data-translate="global.menu.about-us">About Us</span>\n                                </a>\n                            </li--><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="audio-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.audioIbq">Audio Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="material-file-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.materialFileIbq">Material File Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="disc-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.discIbq">Disc Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="ensamble-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ensambleIbq">Ensamble Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="photo-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.photoIbq">Photo Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="graphic-archive-item-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.graphicArchiveItemIbq">Graphic Archive Item Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="material-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.materialIbq">Material Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="musical-piece-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.musicalPieceIbq">Musical Piece Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="part-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.partIbq">Part Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="participation-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.participationIbq">Participation Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="music-sheet-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.musicSheetIbq">Music Sheet Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="person-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.personIbq">Person Ibq</span></a></li><!--li ui-sref-active="active">\n                                <a ui-sref="musical-arrangement-ibq" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span data-translate="global.menu.entities.musicalArrangementIbq">Musical Arrangement Ibq</span>\n                                </a>\n                            </li--><li ui-sref-active="active"><a ui-sref="video-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.videoIbq">Video Ibq</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="directory-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.directories">Directories </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="album" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.album">Album</span></a></li><li ui-sref-active="active"><a ui-sref="collection-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.collectionIbq">Collection Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="copyright" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.copyright">Copyright</span></a></li><li ui-sref-active="active"><a ui-sref="publisher-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.publisherIbq">Publisher Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="specialty-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.specialtyIbq">Specialty Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="state-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.stateIbq">State Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="genre-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.genreIbq">Genre Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="language-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.languageIbq">Language Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="instrument" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.instrument">Instrument</span></a></li><li ui-sref-active="active"><a ui-sref="level-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.levelIbq">Level Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="country-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.countryIbq">Country Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="role-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.roleIbq">Role Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="portal-role" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.portalRole">Portal Role</span></a></li><li ui-sref-active="active"><a ui-sref="musical-arrangement-type-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.musicalArrangementTypeIbq">Musical Arrangement Type Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="type-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.typeIbq">Type Ibq</span></a></li><li ui-sref-active="active"><a ui-sref="video-type-ibq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.videoTypeIbq">Video Type Ibq</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.account.sessions">Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><!--li ui-sref-active="active" ng-switch-when="false">\n                            <a ui-sref="register" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-plus-sign"></span>&nbsp;\n                                <span data-translate="global.menu.account.register">Register</span>\n                            </a>\n                        </li--></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="elasticsearch-reindex" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="global.menu.admin.elasticsearch-reindex">Elasticsearch Reindex</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/entities/album/album-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.album.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.album.delete.question" translate-values="{id: \'{{vm.album.id}}\'}">Are you sure you want to delete this Album?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/album/album-detail.html','<div><h2><span data-translate="virtuallibraryApp.album.detail.title">Album</span> {{vm.album.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.album.name">Name</span></dt><dd><span>{{vm.album.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="album-detail.edit({id:vm.album.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/album/album-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAlbumLabel" data-translate="virtuallibraryApp.album.home.createOrEditLabel">Create or edit a Album</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.album.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.album.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.album.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.album.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/album/albums.html','<div><h2 data-translate="virtuallibraryApp.album.home.title">Albums</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="album.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.album.home.createLabel">Create new Album</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.album.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.album.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="album in vm.albums track by album.id"><td><a ui-sref="album-detail({id:album.id})">{{album.id}}</a></td><td>{{album.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="album-detail({id:album.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="album.edit({id:album.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="album.delete({id:album.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/audio/audio-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.audio.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.audio.delete.question" translate-values="{id: \'{{vm.audio.id}}\'}">Are you sure you want to delete this Audio?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/audio/audio-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.audio.detail.title">Audio</span> {{vm.audio.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.audio.title">Title</span></dt><dd><span>{{vm.audio.title}}</span></dd><dt><span data-translate="virtuallibraryApp.audio.audioFile">Audio File</span></dt><dd><a class="glyphicon glyphicon-download" href="{{vm.audio.audioFile}}"></a></dd><dt><span data-translate="virtuallibraryApp.audio.duration">Duration</span></dt><dd><span>{{vm.audio.duration}}</span></dd><dt><span data-translate="virtuallibraryApp.audio.didactic">Didactic</span></dt><dd><span><span ng-if="vm.audio.didactic" class="glyphicon glyphicon-ok"></span> <span ng-if="!vm.audio.didactic" class="glyphicon glyphicon-remove"></span></span></dd><dt><span data-translate="virtuallibraryApp.audio.audioUrl">Audio URL</span></dt><dd><span>{{vm.audio.audioURL}}</span></dd><dt><span data-translate="virtuallibraryApp.audio.disc">Disc</span></dt><dd><a ui-sref="disc-ibq-detail({id:vm.audio.discId})">{{vm.audio.discTitle}}</a></dd><dt><span data-translate="virtuallibraryApp.audio.musicalPiece">Musical Piece</span></dt><dd><a ui-sref="musical-piece-ibq-detail({id:vm.audio.musicalPieceId})">{{vm.audio.musicalPieceMainTitle}}</a></dd><dt><span data-translate="virtuallibraryApp.audio.copyright">Copyright</span></dt><dd><a ui-sref="copyright-detail({id:vm.audio.copyrightId})">{{vm.audio.copyrightName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="audio-ibq-detail.edit({id:vm.audio.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/audio/audio-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAudioLabel" data-translate="virtuallibraryApp.audio.home.createOrEditLabel">Create or edit a Audio</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.audio.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.audio.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.audio.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.audio.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.audio.audioUrl" for="field_audioFile">Audio File</label><textarea class="form-control" name="audioFile" id="field_audioFile" ng-model="vm.audio.audioURL"></textarea><!--div ng-show="editForm.audioFile.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.audioFile.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div--></div><div class="form-group" ngf-drop ngf-change="vm.setAudioFile($file, vm.audio)"><label class="control-label" data-translate="virtuallibraryApp.audio.audioFile" for="field_audioFile">Matl File</label><div><!--div ng-if="vm.audio.aFile" class="help-block clearfix">\n                    <a class="pull-left" ng-click="vm.openFile(vm.audio.audioContentType, vm.audio.aFile)" data-translate="entity.action.open">open</a><br>\n                    <span class="pull-left">{{vm.audio.audioContentType}}, {{vm.byteSize(vm.audio.aFile)}}</span>\n                    <button type="button" ng-click="vm.audio.aFile=null;vm.audio.audioContentType=null;"\n                            class="btn btn-default btn-xs pull-right">\n                        <span class="glyphicon glyphicon-remove"></span>\n                    </button>\n                </div--><div ng-if="vm.audio.audioFile" class="help-block clearfix"><span ng-if="!vm.audio.audioFile.includes(\'api\')" class="pull-left">{{vm.audio.audioFile}}</span> <span ng-if="vm.audio.audioFile.includes(\'api\')" class="pull-left">{{vm.audio.audioFile.substring(vm.audio.audioFile.lastIndexOf(\'-\')+1,vm.audio.audioFile.length)}}</span><!--button type="button" ng-click="vm.part.partFile=null;vm.part.partFileContentType=null;"\n                            class="btn btn-default btn-xs pull-right">\n                        <span class="glyphicon glyphicon-remove"></span>\n                    </button--></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setAudioFile($file, vm.audio)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="matlFile" id="field_matlFile" ng-model="vm.audio.aFile"> <input type="hidden" class="form-control" name="audioContentType" id="field_audioContentType" ng-model="vm.audio.audioContentType"><div ng-show="editForm.audio.$invalid"></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.audio.duration" for="field_duration">Duration</label><input type="number" class="form-control" name="duration" id="field_duration" ng-model="vm.audio.duration"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.audio.didactic" for="field_didactic">Didactic</label><input type="checkbox" name="didactic" id="field_didactic" ng-model="vm.audio.didactic"></div><!--div class="form-group">\n            <label class="control-label" data-translate="virtuallibraryApp.audio.audioURL" for="field_audioURL">Audio URL</label>\n            <input type="text" class="form-control" name="audioURL" id="field_audioURL"\n                    ng-model="vm.audio.audioURL"\n                    ng-maxlength="10000"/>\n            <div ng-show="editForm.audioURL.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.audioURL.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10000">\n                    This field cannot be longer than 10000 characters.\n                </p>\n            </div>\n        </div--><div class="form-group"><label data-translate="virtuallibraryApp.audio.disc" for="field_disc">Disc</label><select class="form-control" id="field_disc" name="disc" ng-model="vm.audio.discId" ng-options="disc.id as disc.title for disc in vm.discs"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.audio.musicalPiece" for="field_musicalPiece">Musical Piece</label><select class="form-control" id="field_musicalPiece" name="musicalPiece" ng-model="vm.audio.musicalPieceId" ng-options="musicalPiece.id as musicalPiece.mainTitle for musicalPiece in vm.musicalpieces"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.audio.copyright" for="field_copyright">Copyright</label><select class="form-control" id="field_copyright" name="copyright" ng-model="vm.audio.copyrightId" ng-options="copyright.id as copyright.name for copyright in vm.copyrights"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/audio/audioibq.html','<div><h2 data-translate="virtuallibraryApp.audio.home.title">Audio</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="audio-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.audio.home.createLabel">Create new Audio</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.audio.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="virtuallibraryApp.audio.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="audioFile"><span data-translate="virtuallibraryApp.audio.audioFile">Audio File</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="duration"><span data-translate="virtuallibraryApp.audio.duration">Duration</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="didactic"><span data-translate="virtuallibraryApp.audio.didactic">Didactic</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="discTitle"><span data-translate="virtuallibraryApp.audio.disc">Disc</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="musicalPieceMainTitle"><span data-translate="virtuallibraryApp.audio.musicalPiece">Musical Piece</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="audio in vm.audio track by audio.id"><td><a ui-sref="audio-ibq-detail({id:audio.id})">{{audio.id}}</a></td><td>{{audio.title}}</td><!--<td ng-bind-html="vm.trustAsHtml(audio.audioFile)"> </td>--><td>{{audio.duration}}</td><td><span ng-if="audio.didactic" data-translate="yes"><span ng-if="!audio.didactic" data-translate="No"></td><td><a ui-sref="disc-ibq-detail({id:audio.discId})">{{audio.discTitle}}</a></td><td><a ui-sref="musical-piece-ibq-detail({id:audio.musicalPieceId})">{{audio.musicalPieceMainTitle}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="audio-ibq-detail({id:audio.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="audio-ibq.edit({id:audio.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="audio-ibq.delete({id:audio.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/category/categoriesibq.html','<div><h2 data-translate="virtuallibraryApp.category.home.title">Categories</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="category-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.category.home.createLabel">Create new Category</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.category.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.category.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="categoryName"><span data-translate="virtuallibraryApp.category.category">Category</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="category in vm.categories track by category.id"><td><a ui-sref="category-ibq-detail({id:category.id})">{{category.id}}</a></td><td>{{category.name}}</td><td><a ui-sref="category-ibq-detail({id:category.categoryId})">{{category.categoryName}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="category-ibq-detail({id:category.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="category-ibq.edit({id:category.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="category-ibq.delete({id:category.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/category/category-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.category.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.category.delete.question" translate-values="{id: \'{{vm.category.id}}\'}">Are you sure you want to delete this Category?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/category/category-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.category.detail.title">Category</span> {{vm.category.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.category.name">Name</span></dt><dd><span>{{vm.category.name}}</span></dd><dt><span data-translate="virtuallibraryApp.category.category">Category</span></dt><dd><a ui-sref="category-ibq-detail({id:vm.category.categoryId})">{{vm.category.categoryName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="category-ibq-detail.edit({id:vm.category.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/category/category-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCategoryLabel" data-translate="virtuallibraryApp.category.home.createOrEditLabel">Create or edit a Category</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.category.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.category.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.category.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.category.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="virtuallibraryApp.category.category" for="field_category">Category</label><select class="form-control" id="field_category" name="category" ng-model="vm.category.categoryId" ng-options="category.id as category.name for category in vm.categories"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/collection/collection-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.collection.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.collection.delete.question" translate-values="{id: \'{{vm.collection.id}}\'}">Are you sure you want to delete this Collection?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/collection/collection-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.collection.detail.title">Collection</span> {{vm.collection.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.collection.name">Name</span></dt><dd><span>{{vm.collection.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="collection-ibq-detail.edit({id:vm.collection.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/collection/collection-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCollectionLabel" data-translate="virtuallibraryApp.collection.home.createOrEditLabel">Create or edit a Collection</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.collection.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.collection.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.collection.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.collection.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/collection/collectionsibq.html','<div><h2 data-translate="virtuallibraryApp.collection.home.title">Collections</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="collection-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.collection.home.createLabel">Create new Collection</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.collection.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.collection.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="collection in vm.collections track by collection.id"><td><a ui-sref="collection-ibq-detail({id:collection.id})">{{collection.id}}</a></td><td>{{collection.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="collection-ibq-detail({id:collection.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="collection-ibq.edit({id:collection.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="collection-ibq.delete({id:collection.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/copyright/copyright-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.copyright.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.copyright.delete.question" translate-values="{id: \'{{vm.copyright.id}}\'}">Are you sure you want to delete this Copyright?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/copyright/copyright-detail.html','<div><h2><span data-translate="virtuallibraryApp.copyright.detail.title">Copyright</span> {{vm.copyright.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.copyright.name">Name</span></dt><dd><span>{{vm.copyright.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="copyright-detail.edit({id:vm.copyright.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/copyright/copyright-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCopyrightLabel" data-translate="virtuallibraryApp.copyright.home.createOrEditLabel">Create or edit a Copyright</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.copyright.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.copyright.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.copyright.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.copyright.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/copyright/copyrights.html','<div><h2 data-translate="virtuallibraryApp.copyright.home.title">Copyrights</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="copyright.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.copyright.home.createLabel">Create new Copyright</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.copyright.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.copyright.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="copyright in vm.copyrights track by copyright.id"><td><a ui-sref="copyright-detail({id:copyright.id})">{{copyright.id}}</a></td><td>{{copyright.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="copyright-detail({id:copyright.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="copyright.edit({id:copyright.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="copyright.delete({id:copyright.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/country/countriesibq.html','<div><h2 data-translate="virtuallibraryApp.country.home.title">Countries</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="country-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.country.home.createLabel">Create new Country</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.country.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.country.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="belongIbq"><span data-translate="virtuallibraryApp.country.belongIbq">Belong Ibq</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="url"><span data-translate="virtuallibraryApp.country.url">Url</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="country in vm.countries track by country.id"><td><a ui-sref="country-ibq-detail({id:country.id})">{{country.id}}</a></td><td>{{country.name}}</td><td class="text-center"><span ng-if="country.belongIbq" class="glyphicon glyphicon-ok"></span><span ng-if="!country.belongIbq" class="glyphicon glyphicon-remove"></span></td><td>{{country.url}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="country-ibq-detail({id:country.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="country-ibq.edit({id:country.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="country-ibq.delete({id:country.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/country/country-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.country.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.country.delete.question" translate-values="{id: \'{{vm.country.id}}\'}">Are you sure you want to delete this Country?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/country/country-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.country.detail.title">Country</span> {{vm.country.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.country.name">Name</span></dt><dd><span>{{vm.country.name}}</span></dd><dt><span data-translate="virtuallibraryApp.country.belongIbq">Belong Ibq</span></dt><dd><span ng-if="vm.country.belongIbq" class="glyphicon glyphicon-ok"></span> <span ng-if="!vm.country.belongIbq" class="glyphicon glyphicon-remove"></span></dd><dt><span data-translate="virtuallibraryApp.country.url">Url</span></dt><dd><span>{{vm.country.url}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="country-ibq-detail.edit({id:vm.country.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/country/country-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCountryLabel" data-translate="virtuallibraryApp.country.home.createOrEditLabel">Create or edit a Country</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.country.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.country.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.country.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.country.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.country.belongIbq" for="field_belongIbq">Belong Ibq</label><input type="checkbox" name="belongIbq" id="field_belongIbq" ng-model="vm.country.belongIbq"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.country.url" for="field_url">Url</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.country.url"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/disc/disc-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.disc.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.disc.delete.question" translate-values="{id: \'{{vm.disc.id}}\'}">Are you sure you want to delete this Disc?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/disc/disc-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.disc.detail.title">Disc</span> {{vm.disc.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.disc.title">Title</span></dt><dd><span>{{vm.disc.title}}</span></dd><dt><span data-translate="virtuallibraryApp.disc.paralelTitle">Paralel Title</span></dt><dd><span>{{vm.disc.paralelTitle}}</span></dd><dt><span data-translate="virtuallibraryApp.disc.serieNumber">Serie Number</span></dt><dd><span>{{vm.disc.serieNumber}}</span></dd><dt><span data-translate="virtuallibraryApp.disc.content">Content</span></dt><dd><span>{{vm.disc.content}}</span></dd><dt><span data-translate="virtuallibraryApp.disc.productionYear">Production Year</span></dt><dd><span>{{vm.disc.productionYear}}</span></dd><!--<dt><span data-translate="virtuallibraryApp.disc.coverFile">Cover File</span></dt>--><!--dd>\n            <div ng-if="vm.disc.coverFile">\n                <a ng-click="vm.openFile(vm.disc.coverFileContentType, vm.disc.coverFile)">\n                    <img data-ng-src="{{\'data:\' + vm.disc.coverFileContentType + \';base64,\' + vm.disc.coverFile}}" style="max-width: 100%;" alt="disc image"/>\n                </a>\n                {{vm.disc.coverFileContentType}}, {{vm.byteSize(vm.disc.coverFile)}}\n            </div>\n        </dd--><dt><span data-translate="virtuallibraryApp.disc.coverPath">Cover Path</span></dt><dd><span><img src="{{vm.disc.coverPath}}" width="100"></span></dd><dt><span data-translate="virtuallibraryApp.disc.producer">Producer</span></dt><dd><span>{{vm.disc.producer}}</span></dd><dt><span data-translate="virtuallibraryApp.disc.interpreter">Interpreter</span></dt><dd><span>{{vm.disc.interpreter}}</span></dd><dt><span data-translate="virtuallibraryApp.disc.collection">Collection</span></dt><dd><a ui-sref="collection-ibq-detail({id:vm.disc.collectionId})">{{vm.disc.collectionName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="disc-ibq-detail.edit({id:vm.disc.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/disc/disc-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDiscLabel" data-translate="virtuallibraryApp.disc.home.createOrEditLabel">Create or edit a Disc</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.disc.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.disc.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.disc.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.disc.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.disc.paralelTitle" for="field_paralelTitle">Paralel Title</label><input type="text" class="form-control" name="paralelTitle" id="field_paralelTitle" ng-model="vm.disc.paralelTitle"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.disc.serieNumber" for="field_serieNumber">Serie Number</label><input type="text" class="form-control" name="serieNumber" id="field_serieNumber" ng-model="vm.disc.serieNumber"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.disc.content" for="field_content">Content</label><textarea class="form-control" name="content" id="field_content" ng-model="vm.disc.content"></textarea></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.disc.productionYear" for="field_productionYear">Production Year</label><input type="text" class="form-control" name="productionYear" id="field_productionYear" ng-model="vm.disc.productionYear"></div><div class="form-group" ngf-drop ngf-change="vm.setCoverFile($file, vm.disc)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="virtuallibraryApp.disc.coverFile" for="field_coverFile">Cover File</label><div><img data-ng-src="{{\'data:\' + vm.disc.coverFileContentType + \';base64,\' + vm.disc.coverFile}}" style="max-height: 100px" ng-if="vm.disc.coverFile" alt="disc image"><div ng-if="vm.disc.coverFile" class="help-block clearfix"><span class="pull-left">{{vm.disc.coverFileContentType}}, {{vm.byteSize(vm.disc.coverFile)}}</span> <button type="button" ng-click="vm.disc.coverFile=null;vm.disc.coverFileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setCoverFile($file, vm.disc)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="coverFile" id="field_coverFile" ng-model="vm.disc.coverFile"> <input type="hidden" class="form-control" name="coverFileContentType" id="field_coverFileContentType" ng-model="vm.disc.coverFileContentType"></div><div class="form-group"><!--<label class="control-label" data-translate="virtuallibraryApp.disc.coverPath" for="field_coverPath">Cover Path</label>--> <input type="hidden" class="form-control" name="coverPath" id="field_coverPath" ng-model="vm.disc.coverPath"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.disc.producer" for="field_producer">Producer</label><input type="text" class="form-control" name="producer" id="field_producer" ng-model="vm.disc.producer"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.disc.interpreter" for="field_interpreter">Interpreter</label><input type="text" class="form-control" name="interpreter" id="field_interpreter" ng-model="vm.disc.interpreter"></div><div class="form-group"><label data-translate="virtuallibraryApp.disc.collection" for="field_collection">Collection</label><select class="form-control" id="field_collection" name="collection" ng-model="vm.disc.collectionId" ng-options="collection.id as collection.name for collection in vm.collections"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/disc/discsibq.html','<div><h2 data-translate="virtuallibraryApp.disc.home.title">Discs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="disc-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.disc.home.createLabel">Create new Disc</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.disc.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="virtuallibraryApp.disc.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="paralelTitle"><span data-translate="virtuallibraryApp.disc.paralelTitle">Paralel Title</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="serieNumber"><span data-translate="virtuallibraryApp.disc.serieNumber">Serie Number</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="content"><span data-translate="virtuallibraryApp.disc.content">Content</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="productionYear"><span data-translate="virtuallibraryApp.disc.productionYear">Production Year</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="coverFile"><span data-translate="virtuallibraryApp.disc.coverFile">Cover File</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="coverPath"><span data-translate="virtuallibraryApp.disc.coverPath">Cover Path</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="producer"><span data-translate="virtuallibraryApp.disc.producer">Producer</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="interpreter"><span data-translate="virtuallibraryApp.disc.interpreter">Interpreter</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="collectionName"><span data-translate="virtuallibraryApp.disc.collection">Collection</span> <span class="glyphicon glyphicon-sort"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat="disc in vm.discs track by disc.id"><td><a ui-sref="disc-ibq-detail({id:disc.id})">{{disc.id}}</a></td><td>{{disc.title}}</td><!--<td>{{disc.paralelTitle}}</td>--><!--<td>{{disc.serieNumber}}</td>--><!--<td>{{disc.content}}</td>--><!--<td>{{disc.productionYear}}</td>--><!--td>\n                        <a ng-if="disc.coverFile" ng-click="vm.openFile(disc.coverFileContentType, disc.coverFile)">\n                            <img data-ng-src="{{\'data:\' + disc.coverFileContentType + \';base64,\' + disc.coverFile}}" style="max-height: 30px;" alt="disc image"/>\n                        </a>\n                        <span ng-if="disc.coverFile">{{disc.coverFileContentType}}, {{vm.byteSize(disc.coverFile)}}</span>\n                    </td--><!--<td><img src="{{disc.coverPath}}" width="100"></td>--><td>{{disc.producer}}</td><td>{{disc.interpreter}}</td><!--td>\n                        <a ui-sref="collection-ibq-detail({id:disc.collectionId})">{{disc.collectionName}}</a>\n                    </td--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="disc-ibq-detail({id:disc.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="disc-ibq.edit({id:disc.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="disc-ibq.delete({id:disc.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/ensamble/ensamble-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ensamble.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.ensamble.delete.question" translate-values="{id: \'{{vm.ensamble.id}}\'}">Are you sure you want to delete this Ensamble?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ensamble/ensamble-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.ensamble.detail.title">Ensamble</span> {{vm.ensamble.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.ensamble.name">Name</span></dt><dd><span>{{vm.ensamble.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ensamble-ibq-detail.edit({id:vm.ensamble.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ensamble/ensamble-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEnsambleLabel" data-translate="virtuallibraryApp.ensamble.home.createOrEditLabel">Create or edit a Ensamble</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ensamble.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ensamble.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.ensamble.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.ensamble.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ensamble/ensamblesibq.html','<div><h2 data-translate="virtuallibraryApp.ensamble.home.title">Ensambles</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ensamble-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.ensamble.home.createLabel">Create new Ensamble</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.ensamble.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.ensamble.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="ensamble in vm.ensambles track by ensamble.id"><td><a ui-sref="ensamble-ibq-detail({id:ensamble.id})">{{ensamble.id}}</a></td><td>{{ensamble.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ensamble-ibq-detail({id:ensamble.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="ensamble-ibq.edit({id:ensamble.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="ensamble-ibq.delete({id:ensamble.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/genre/genre-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.genre.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.genre.delete.question" translate-values="{id: \'{{vm.genre.id}}\'}">Are you sure you want to delete this Genre?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/genre/genre-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.genre.detail.title">Genre</span> {{vm.genre.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.genre.name">Name</span></dt><dd><span>{{vm.genre.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="genre-ibq-detail.edit({id:vm.genre.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/genre/genre-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGenreLabel" data-translate="virtuallibraryApp.genre.home.createOrEditLabel">Create or edit a Genre</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.genre.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.genre.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.genre.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.genre.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/genre/genresibq.html','<div><h2 data-translate="virtuallibraryApp.genre.home.title">Genres</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="genre-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.genre.home.createLabel">Create new Genre</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.genre.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.genre.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="genre in vm.genres track by genre.id"><td><a ui-sref="genre-ibq-detail({id:genre.id})">{{genre.id}}</a></td><td>{{genre.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="genre-ibq-detail({id:genre.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="genre-ibq.edit({id:genre.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="genre-ibq.delete({id:genre.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/graphic-archive-item/graphic-archive-item-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.graphicArchiveItem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.graphicArchiveItem.delete.question" translate-values="{id: \'{{vm.graphicArchiveItem.id}}\'}">Are you sure you want to delete this Graphic Archive Item?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/graphic-archive-item/graphic-archive-item-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.graphicArchiveItem.detail.title">Graphic Archive Item</span> {{vm.graphicArchiveItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.graphicArchiveItem.publicationDate">Publication Date</span></dt><dd><span>{{vm.graphicArchiveItem.publicationDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="virtuallibraryApp.graphicArchiveItem.publicationPlace">Publication Place</span></dt><dd><span>{{vm.graphicArchiveItem.publicationPlace}}</span></dd><dt><span data-translate="virtuallibraryApp.graphicArchiveItem.note">Note</span></dt><dd><span>{{vm.graphicArchiveItem.note}}</span></dd><dt><span data-translate="virtuallibraryApp.graphicArchiveItem.source">Source</span></dt><dd><span>{{vm.graphicArchiveItem.source}}</span></dd><dt><span data-translate="virtuallibraryApp.graphicArchiveItem.title">Title</span></dt><dd><span>{{vm.graphicArchiveItem.title}}</span></dd><dt><span data-translate="virtuallibraryApp.graphicArchiveItem.name">Name</span></dt><dd><span>{{vm.graphicArchiveItem.name}}</span></dd><dt><span data-translate="virtuallibraryApp.graphicArchiveItem.musicalPiece">Musical Piece</span></dt><dd><a ui-sref="musical-piece-ibq-detail({id:vm.graphicArchiveItem.musicalPieceId})">{{vm.graphicArchiveItem.musicalPieceMainTitle}}</a></dd><dt><span data-translate="virtuallibraryApp.graphicArchiveItem.publisher">Publisher</span></dt><dd><a ui-sref="publisher-ibq-detail({id:vm.graphicArchiveItem.publisherId})">{{vm.graphicArchiveItem.publisherName}}</a></dd><dt><span data-translate="virtuallibraryApp.graphicArchiveItem.publicationCountry">Publication Country</span></dt><dd><a ui-sref="country-ibq-detail({id:vm.graphicArchiveItem.publicationCountryId})">{{vm.graphicArchiveItem.publicationCountryName}}</a></dd><dt><span data-translate="virtuallibraryApp.graphicArchiveItem.person">Person</span></dt><dd><a ui-sref="person-ibq-detail({id:vm.graphicArchiveItem.personId})">{{vm.graphicArchiveItem.personName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="graphic-archive-item-ibq-detail.edit({id:vm.graphicArchiveItem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/graphic-archive-item/graphic-archive-item-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGraphicArchiveItemLabel" data-translate="virtuallibraryApp.graphicArchiveItem.home.createOrEditLabel">Create or edit a Graphic Archive Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.graphicArchiveItem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.graphicArchiveItem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.graphicArchiveItem.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.graphicArchiveItem.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.graphicArchiveItem.publicationDate" for="field_publicationDate">Publication Date</label><div class="input-group"><input id="field_publicationDate" type="text" class="form-control" name="publicationDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.graphicArchiveItem.publicationDate" is-open="vm.datePickerOpenStatus.publicationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'publicationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.graphicArchiveItem.publicationPlace" for="field_publicationPlace">Publication Place</label><input type="text" class="form-control" name="publicationPlace" id="field_publicationPlace" ng-model="vm.graphicArchiveItem.publicationPlace"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.graphicArchiveItem.note" for="field_note">Note</label><textarea class="form-control" name="note" id="field_note" ng-model="vm.graphicArchiveItem.note"></textarea></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.graphicArchiveItem.source" for="field_source">Source</label><textarea class="form-control" name="source" id="field_source" ng-model="vm.graphicArchiveItem.source"></textarea></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.graphicArchiveItem.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.graphicArchiveItem.name"></div><div class="form-group"><label data-translate="virtuallibraryApp.graphicArchiveItem.musicalPiece" for="field_musicalPiece">Musical Piece</label><select class="form-control" id="field_musicalPiece" name="musicalPiece" ng-model="vm.graphicArchiveItem.musicalPieceId" ng-options="musicalPiece.id as musicalPiece.mainTitle for musicalPiece in vm.musicalpieces"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.graphicArchiveItem.publisher" for="field_publisher">Publisher</label><select class="form-control" id="field_publisher" name="publisher" ng-model="vm.graphicArchiveItem.publisherId" ng-options="publisher.id as publisher.name for publisher in vm.publishers"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.graphicArchiveItem.publicationCountry" for="field_publicationCountry">Publication Country</label><select class="form-control" id="field_publicationCountry" name="publicationCountry" ng-model="vm.graphicArchiveItem.publicationCountryId" ng-options="country.id as country.name for country in vm.countries"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.graphicArchiveItem.person" for="field_person">Person</label><select class="form-control" id="field_person" name="person" ng-model="vm.graphicArchiveItem.personId" ng-options="person.id as person.name for person in vm.people"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/graphic-archive-item/graphic-archive-itemsibq.html','<div><h2 data-translate="virtuallibraryApp.graphicArchiveItem.home.title">Graphic Archive Items</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="graphic-archive-item-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.graphicArchiveItem.home.createLabel">Create new Graphic Archive Item</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.graphicArchiveItem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicationDate"><span data-translate="virtuallibraryApp.graphicArchiveItem.publicationDate">Publication Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicationPlace"><span data-translate="virtuallibraryApp.graphicArchiveItem.publicationPlace">Publication Place</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="note"><span data-translate="virtuallibraryApp.graphicArchiveItem.note">Note</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="source"><span data-translate="virtuallibraryApp.graphicArchiveItem.source">Source</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="title"><span data-translate="virtuallibraryApp.graphicArchiveItem.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.graphicArchiveItem.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="musicalPieceMainTitle"><span data-translate="virtuallibraryApp.graphicArchiveItem.musicalPiece">Musical Piece</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="publisherName"><span data-translate="virtuallibraryApp.graphicArchiveItem.publisher">Publisher</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="publicationCountryName"><span data-translate="virtuallibraryApp.graphicArchiveItem.publicationCountry">Publication Country</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="personName"><span data-translate="virtuallibraryApp.graphicArchiveItem.person">Person</span> <span class="glyphicon glyphicon-sort"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat="graphicArchiveItem in vm.graphicArchiveItems track by graphicArchiveItem.id"><td><a ui-sref="graphic-archive-item-ibq-detail({id:graphicArchiveItem.id})">{{graphicArchiveItem.id}}</a></td><td>{{graphicArchiveItem.publicationDate | date:\'mediumDate\'}}</td><td>{{graphicArchiveItem.publicationPlace}}</td><!--<td>{{graphicArchiveItem.note}}</td>--><!--<td>{{graphicArchiveItem.source}}</td>--><td>{{graphicArchiveItem.title}}</td><td>{{graphicArchiveItem.name}}</td><!--td>\n                        <a ui-sref="musical-piece-ibq-detail({id:graphicArchiveItem.musicalPieceId})">{{graphicArchiveItem.musicalPieceMainTitle}}</a>\n                    </td--><td><a ui-sref="publisher-ibq-detail({id:graphicArchiveItem.publisherId})">{{graphicArchiveItem.publisherName}}</a></td><!--td>\n                        <a ui-sref="country-ibq-detail({id:graphicArchiveItem.publicationCountryId})">{{graphicArchiveItem.publicationCountryName}}</a>\n                    </td--><!--td>\n                        <a ui-sref="person-ibq-detail({id:graphicArchiveItem.personId})">{{graphicArchiveItem.personName}}</a>\n                    </td--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="graphic-archive-item-ibq-detail({id:graphicArchiveItem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="graphic-archive-item-ibq.edit({id:graphicArchiveItem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="graphic-archive-item-ibq.delete({id:graphicArchiveItem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/instrument/instrument-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.instrument.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.instrument.delete.question" translate-values="{id: \'{{vm.instrument.id}}\'}">Are you sure you want to delete this Instrument?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/instrument/instrument-detail.html','<div><h2><span data-translate="virtuallibraryApp.instrument.detail.title">Instrument</span> {{vm.instrument.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.instrument.name">Name</span></dt><dd><span>{{vm.instrument.name}}</span></dd><dt><span data-translate="virtuallibraryApp.instrument.representation">Representation</span></dt><dd><span>{{vm.instrument.representation}}</span></dd><dt><span data-translate="virtuallibraryApp.instrument.type">Type</span></dt><dd><span data-translate="{{\'virtuallibraryApp.InstrumentType.\' + vm.instrument.type}}">{{vm.instrument.type}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="instrument-detail.edit({id:vm.instrument.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/instrument/instrument-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInstrumentLabel" data-translate="virtuallibraryApp.instrument.home.createOrEditLabel">Create or edit a Instrument</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.instrument.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.instrument.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.instrument.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.instrument.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.instrument.representation" for="field_representation">Representation</label><input type="text" class="form-control" name="representation" id="field_representation" ng-model="vm.instrument.representation"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.instrument.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.instrument.type" id="field_type"><option value="Vocal" data-translate="virtuallibraryApp.InstrumentType.Vocal">Vocal</option><option value="Instrumental" data-translate="virtuallibraryApp.InstrumentType.Instrumental">Instrumental</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/instrument/instruments.html','<div><h2 data-translate="virtuallibraryApp.instrument.home.title">Instruments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="instrument.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.instrument.home.createLabel">Create new Instrument</span></button> <button type="button" ngf-select="upload($file)" class="btn btn-success"><!--ngf-change="vm.setCSVFile($file)" accept="csv/*"--> <span class="glyphicon glyphicon-import"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.instrument.home.import">Import Instruments</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.instrument.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="row" ng-show="vm.upload"><div class="col-xs-2 no-padding-right"><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setCoverImage($file, vm.musicalPiece)" accept="csv/*">Archivo</button> <input type="hidden" class="form-control" name="coverImage" id="field_coverImage" ng-model="vm.musicalPiece.coverImage"></div></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.instrument.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="representation"><span data-translate="virtuallibraryApp.instrument.representation">Representation</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="virtuallibraryApp.instrument.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="instrument in vm.instruments track by instrument.id"><td><a ui-sref="instrument-detail({id:instrument.id})">{{instrument.id}}</a></td><td>{{instrument.name}}</td><td>{{instrument.representation}}</td><td data-translate="{{\'virtuallibraryApp.InstrumentType.\' + instrument.type}}">{{instrument.type}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="instrument-detail({id:instrument.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="instrument.edit({id:instrument.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="instrument.delete({id:instrument.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager>');
$templateCache.put('app/entities/language/language-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.language.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.language.delete.question" translate-values="{id: \'{{vm.language.id}}\'}">Are you sure you want to delete this Language?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/language/language-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.language.detail.title">Language</span> {{vm.language.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.language.name">Name</span></dt><dd><span>{{vm.language.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="language-ibq-detail.edit({id:vm.language.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/language/language-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLanguageLabel" data-translate="virtuallibraryApp.language.home.createOrEditLabel">Create or edit a Language</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.language.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.language.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.language.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.language.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/language/languagesibq.html','<div><h2 data-translate="virtuallibraryApp.language.home.title">Languages</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="language-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.language.home.createLabel">Create new Language</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.language.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.language.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="language in vm.languages track by language.id"><td><a ui-sref="language-ibq-detail({id:language.id})">{{language.id}}</a></td><td>{{language.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="language-ibq-detail({id:language.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--span class="hidden-sm-down" data-translate="entity.action.view"></span--></button> <button type="submit" ui-sref="language-ibq.edit({id:language.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--span class="hidden-sm-down" data-translate="entity.action.edit"></span--></button> <button type="submit" ui-sref="language-ibq.delete({id:language.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--span class="hidden-sm-down" data-translate="entity.action.delete"></span--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/level/level-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.level.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.level.delete.question" translate-values="{id: \'{{vm.level.id}}\'}">Are you sure you want to delete this Level?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/level/level-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.level.detail.title">Level</span> {{vm.level.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.level.name">Name</span></dt><dd><span>{{vm.level.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="level-ibq-detail.edit({id:vm.level.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/level/level-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLevelLabel" data-translate="virtuallibraryApp.level.home.createOrEditLabel">Create or edit a Level</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.level.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.level.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.level.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.level.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/level/levelsibq.html','<div><h2 data-translate="virtuallibraryApp.level.home.title">Levels</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="level-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.level.home.createLabel">Create new Level</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.level.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.level.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="level in vm.levels track by level.id"><td><a ui-sref="level-ibq-detail({id:level.id})">{{level.id}}</a></td><td>{{level.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="level-ibq-detail({id:level.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="level-ibq.edit({id:level.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="level-ibq.delete({id:level.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/material/material-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.material.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.material.delete.question" translate-values="{id: \'{{vm.material.id}}\'}">Are you sure you want to delete this Material?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/material/material-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.material.detail.title">Material</span> {{vm.material.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.material.title">Title</span></dt><dd><span>{{vm.material.title}}</span></dd><dt><span data-translate="virtuallibraryApp.material.subtitle">Subtitle</span></dt><dd><span>{{vm.material.subtitle}}</span></dd><dt><span data-translate="virtuallibraryApp.material.editionNumber">Edition Number</span></dt><dd><span>{{vm.material.editionNumber}}</span></dd><dt><span data-translate="virtuallibraryApp.material.pages">Pages</span></dt><dd><span>{{vm.material.pages}}</span></dd><dt><span data-translate="virtuallibraryApp.material.isbn">Isbn</span></dt><dd><span>{{vm.material.isbn}}</span></dd><dt><span data-translate="virtuallibraryApp.material.description">Description</span></dt><dd><span>{{vm.material.description}}</span></dd><dt><span data-translate="virtuallibraryApp.material.editionYear">Edition Year</span></dt><dd><span>{{vm.material.editionYear}}</span></dd><!--dt><span data-translate="virtuallibraryApp.material.coverFile">Cover File</span></dt>\n        <dd>\n            <div ng-if="vm.material.coverFile">\n                <a ng-click="vm.openFile(vm.material.coverFileContentType, vm.material.coverFile)">\n                    <img data-ng-src="{{\'data:\' + vm.material.coverFileContentType + \';base64,\' + vm.material.coverFile}}" style="max-width: 100%;" alt="material image"/>\n                </a>\n                {{vm.material.coverFileContentType}}, {{vm.byteSize(vm.material.coverFile)}}\n            </div>\n        </dd--><dt><span data-translate="virtuallibraryApp.material.coverPath">Cover Path</span></dt><dd><img src="{{vm.material.coverPath}}" width="100"></dd><dt><span data-translate="virtuallibraryApp.material.type">Type</span></dt><dd><a ui-sref="type-ibq-detail({id:vm.material.typeId})">{{vm.material.typeName}}</a></dd><dt><span data-translate="virtuallibraryApp.material.publisher">Publisher</span></dt><dd><a ui-sref="publisher-ibq-detail({id:vm.material.publisherId})">{{vm.material.publisherName}}</a></dd><dt><span data-translate="virtuallibraryApp.material.person">Person</span></dt><dd><span ng-repeat="person in vm.material.people"><a ui-sref="person-ibq-detail({id: person.id})">{{person.name}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="material-ibq-detail.edit({id:vm.material.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/material/material-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMaterialLabel" data-translate="virtuallibraryApp.material.home.createOrEditLabel">Create or edit a Material</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.material.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.material.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.material.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.material.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.material.subtitle" for="field_subtitle">Subtitle</label><input type="text" class="form-control" name="subtitle" id="field_subtitle" ng-model="vm.material.subtitle"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.material.editionNumber" for="field_editionNumber">Edition Number</label><input type="text" class="form-control" name="editionNumber" id="field_editionNumber" ng-model="vm.material.editionNumber"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.material.pages" for="field_pages">Pages</label><input type="number" class="form-control" name="pages" id="field_pages" ng-model="vm.material.pages"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.material.isbn" for="field_isbn">Isbn</label><input type="text" class="form-control" name="isbn" id="field_isbn" ng-model="vm.material.isbn"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.material.description" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" maxlength="255" ng-model="vm.material.description"></textarea></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.material.editionYear" for="field_editionYear">Edition Year</label><input type="number" class="form-control" name="editionYear" id="field_editionYear" ng-model="vm.material.editionYear"></div><div class="form-group" ngf-drop ngf-change="vm.setCoverFile($file, vm.material)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="virtuallibraryApp.material.coverFile" for="field_coverFile">Cover File</label><div><img data-ng-src="{{\'data:\' + vm.material.coverFileContentType + \';base64,\' + vm.material.coverFile}}" style="max-height: 100px; margin-bottom: 10px" ng-if="!vm.material.coverPath.includes(\'api\')&& vm.material.coverPath" alt="cover image"> <img data-ng-src="{{vm.material.coverPath}}" style="max-height: 100px; margin-bottom: 10px" ng-if="vm.material.coverPath.includes(\'api\')" alt="cover image"><!--img data-ng-src="{{\'data:\' + vm.material.coverFileContentType + \';base64,\' + vm.material.coverFile}}" style="max-height: 100px;" ng-if="vm.material.coverFile" alt="material image"/>\n                <div ng-if="vm.material.coverFile" class="help-block clearfix">\n                    <span class="pull-left">{{vm.material.coverFileContentType}}, {{vm.byteSize(vm.material.coverFile)}}</span>\n                    <button type="button" ng-click="vm.material.coverFile=null;vm.material.coverFileContentType=null;"\n                            class="btn btn-default btn-xs pull-right">\n                        <span class="glyphicon glyphicon-remove"></span>\n                    </button>\n                </div--> <button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setCoverFile($file, vm.material)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="coverFile" id="field_coverFile" ng-model="vm.material.coverFile"> <input type="hidden" class="form-control" name="coverFileContentType" id="field_coverFileContentType" ng-model="vm.material.coverFileContentType"></div><div class="form-group"><!--<label class="control-label" data-translate="virtuallibraryApp.material.coverPath" for="field_coverPath">Cover Path</label>--> <input type="hidden" class="form-control" name="coverPath" id="field_coverPath" ng-model="vm.material.coverPath"></div><div class="form-group"><label data-translate="virtuallibraryApp.material.type" for="field_type">Type</label><select class="form-control" id="field_type" name="type" ng-model="vm.material.typeId" ng-options="type.id as type.name for type in vm.types"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.material.publisher" for="field_publisher">Publisher</label><select class="form-control" id="field_publisher" name="publisher" ng-model="vm.material.publisherId" ng-options="publisher.id as publisher.name for publisher in vm.publishers"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.material.person" for="field_person">Person</label><!--<select class="form-control" id="field_person" multiple name="person" ng-model="vm.material.people" ng-options="person as person.name for person in vm.people track by person.id"></select>--><ui-select multiple="multiple" ng-model="vm.material.people" theme="bootstrap"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="person in vm.people | propsFilter: {name: $select.search}"><div ng-bind-html="person.name | highlight: $select.search"></div><small>{{person.lastName}} <span ng-bind-html="\'\'+person.age | highlight: $select.search"></span></small></ui-select-choices></ui-select></div><!--div class="form-group">\n            <label data-translate="virtuallibraryApp.material.portalRole" for="field_portalRole">Portal Role</label>\n            <select class="form-control" id="field_portalRole" multiple name="portalRole" ng-model="vm.material.portalRoles" ng-options="portalRole as portalRole.name for portalRole in vm.portalroles track by portalRole.id"></select>\n\n\n                <ui-select multiple ng-model="vm.material.portalRoles" theme="bootstrap" name="field_portalRole"\n                           id="field_country">\n                    <ui-select-match>{{$item.name}}</ui-select-match>\n                    <ui-select-choices repeat="portalRole in vm.portalroles | propsFilter: {name: $select.search}">\n                        <div ng-bind-html="portalRole.name | highlight: $select.search"></div>\n                    </ui-select-choices>\n                </ui-select>\n\n        </div--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/material/materialsibq.html','<div><h2 data-translate="virtuallibraryApp.material.home.title">Materials</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="material-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.material.home.createLabel">Create new Material</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.material.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="virtuallibraryApp.material.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="subtitle"><span data-translate="virtuallibraryApp.material.subtitle">Subtitle</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="editionNumber"><span data-translate="virtuallibraryApp.material.editionNumber">Edition Number</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="pages"><span data-translate="virtuallibraryApp.material.pages">Pages</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isbn"><span data-translate="virtuallibraryApp.material.isbn">Isbn</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="description"><span data-translate="virtuallibraryApp.material.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="editionYear"><span data-translate="virtuallibraryApp.material.editionYear">Edition Year</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="coverFile"><span data-translate="virtuallibraryApp.material.coverFile">Cover File</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="coverPath"><span data-translate="virtuallibraryApp.material.coverPath">Cover Path</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="typeName"><span data-translate="virtuallibraryApp.material.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="publisherName"><span data-translate="virtuallibraryApp.material.publisher">Publisher</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="material in vm.materials track by material.id"><td><a ui-sref="material-ibq-detail({id:material.id})">{{material.id}}</a></td><td>{{material.title}}</td><!--<td>{{material.subtitle}}</td>--><!--<td>{{material.editionNumber}}</td>--><td>{{material.pages}}</td><td>{{material.isbn}}</td><!--<td>{{material.description}}</td>--><!--<td>{{material.editionYear}}</td>--><!--td>\n                        <a ng-if="material.coverFile" ng-click="vm.openFile(material.coverFileContentType, material.coverFile)">\n                            <img data-ng-src="{{\'data:\' + material.coverFileContentType + \';base64,\' + material.coverFile}}" style="max-height: 30px;" alt="material image"/>\n                        </a>\n                        <span ng-if="material.coverFile">{{material.coverFileContentType}}, {{vm.byteSize(material.coverFile)}}</span>\n                    </td--><td><img src="{{material.coverPath}}" width="100"></td><!--td>\n                        <a ui-sref="type-ibq-detail({id:material.typeId})">{{material.typeName}}</a>\n                    </td--><td><a ui-sref="publisher-ibq-detail({id:material.publisherId})">{{material.publisherName}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="material-ibq-detail({id:material.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="material-ibq.edit({id:material.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="material-ibq.delete({id:material.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/material-file/material-file-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.materialFile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.materialFile.delete.question" translate-values="{id: \'{{vm.materialFile.id}}\'}">Are you sure you want to delete this Material File?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/material-file/material-file-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.materialFile.detail.title">Material File</span> {{vm.materialFile.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.materialFile.name">Name</span></dt><dd><span>{{vm.materialFile.name}}</span></dd><!--dt><span data-translate="virtuallibraryApp.materialFile.matlFile">Matl File</span></dt>\n        <dd>\n            <div ng-if="vm.materialFile.matlFile">\n                <a ng-click="vm.openFile(vm.materialFile.matlFileContentType, vm.materialFile.matlFile)" data-translate="entity.action.open">open</a>\n                {{vm.materialFile.matlFileContentType}}, {{vm.byteSize(vm.materialFile.matlFile)}}\n            </div>\n        </dd--><dt><span data-translate="virtuallibraryApp.materialFile.partPath">Part Path</span></dt><dd><span><a class="glyphicon glyphicon-download" href="{{vm.materialFile.partPath}}"></a></span></dd><dt><span data-translate="virtuallibraryApp.materialFile.material">Material</span></dt><dd><a ui-sref="material-ibq-detail({id:vm.materialFile.materialId})">{{vm.materialFile.materialTitle}}</a></dd><dt><span data-translate="virtuallibraryApp.materialFile.portalRole">Portal Role</span></dt><dd><span ng-repeat="portalRole in vm.materialFile.portalRoles"><a ui-sref="portal-role-detail({id: portalRole.id})">{{portalRole.name}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="virtuallibraryApp.materialFile.copyright">Copyright</span></dt><dd><a ui-sref="copyright-detail({id:vm.materialFile.copyrightId})">{{vm.materialFile.copyrightName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="material-file-ibq-detail.edit({id:vm.materialFile.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/material-file/material-file-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMaterialFileLabel" data-translate="virtuallibraryApp.materialFile.home.createOrEditLabel">Create or edit a Material File</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.materialFile.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.materialFile.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.materialFile.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.materialFile.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setMatlFile($file, vm.materialFile)"><label class="control-label" data-translate="virtuallibraryApp.materialFile.matlFile" for="field_matlFile">Matl File</label><div><div class="help-block clearfix"><span ng-if="!vm.materialFile.partPath.includes(\'api\')" class="pull-left">{{vm.materialFile.partPath}}</span> <span ng-if="vm.materialFile.partPath.includes(\'api\')" class="pull-left">{{vm.materialFile.partPath.substring(vm.materialFile.partPath.lastIndexOf(\'-\')+1,vm.materialFile.partPath.length)}}</span><!--a class="pull-left" ng-click="vm.openFile(vm.materialFile.matlFileContentType, vm.materialFile.matlFile)" data-translate="entity.action.open">open</a><br>\n                    <span class="pull-left">{{vm.materialFile.matlFileContentType}}, {{vm.byteSize(vm.materialFile.matlFile)}}</span>\n                    <button type="button" ng-click="vm.materialFile.matlFile=null;vm.materialFile.matlFileContentType=null;"\n                            class="btn btn-default btn-xs pull-right">\n                        <span class="glyphicon glyphicon-remove"></span>\n                    </button--></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setMatlFile($file, vm.materialFile)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="matlFile" id="field_matlFile" ng-model="vm.materialFile.matlFile" ng-required="!vm.materialFile.id"> <input type="hidden" class="form-control" name="matlFileContentType" id="field_matlFileContentType" ng-model="vm.materialFile.matlFileContentType"><div ng-show="editForm.matlFile.$invalid"><p class="help-block" ng-show="editForm.matlFile.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><!--<label class="control-label" data-translate="virtuallibraryApp.materialFile.partPath" for="field_partPath">Part Path</label>--> <input type="hidden" class="form-control" name="partPath" id="field_partPath" ng-model="vm.materialFile.partPath"></div><div class="form-group"><label data-translate="virtuallibraryApp.materialFile.material" for="field_material">Material</label><select class="form-control" id="field_material" name="material" ng-model="vm.materialFile.materialId" ng-options="material.id as material.title for material in vm.materials"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.materialFile.portalRole" for="field_portalRole">Portal Role</label><!--<select class="form-control" id="field_portalRole" multiple name="portalRole" ng-model="vm.materialFile.portalRoles" ng-options="portalRole as portalRole.name for portalRole in vm.portalroles track by portalRole.id"></select>--><ui-select multiple="multiple" ng-model="vm.materialFile.portalRoles" theme="bootstrap" name="field_portalRole" id="field_country"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="portalRole in vm.portalroles | propsFilter: {name: $select.search}"><div ng-bind-html="portalRole.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group"><label data-translate="virtuallibraryApp.materialFile.copyright" for="field_copyright">Copyright</label><select class="form-control" id="field_copyright" name="copyright" ng-model="vm.materialFile.copyrightId" ng-options="copyright.id as copyright.name for copyright in vm.copyrights"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/material-file/material-filesibq.html','<div><h2 data-translate="virtuallibraryApp.materialFile.home.title">Material Files</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="material-file-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.materialFile.home.createLabel">Create new Material File</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.materialFile.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.materialFile.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="matlFile"><span data-translate="virtuallibraryApp.materialFile.matlFile">Matl File</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="partPath"><span data-translate="virtuallibraryApp.materialFile.partPath">Part Path</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="materialTitle"><span data-translate="virtuallibraryApp.materialFile.material">Material</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="materialFile in vm.materialFiles track by materialFile.id"><td><a ui-sref="material-file-ibq-detail({id:materialFile.id})">{{materialFile.id}}</a></td><td>{{materialFile.name}}</td><!--td>\n                        <a ng-if="materialFile.matlFile" ng-click="vm.openFile(materialFile.matlFileContentType, materialFile.matlFile)" data-translate="entity.action.open">open</a>\n                        <span ng-if="materialFile.matlFile">{{materialFile.matlFileContentType}}, {{vm.byteSize(materialFile.matlFile)}}</span>\n                    </td--><td><a class="glyphicon glyphicon-download" href="{{materialFile.partPath}}"></a></td><td><a ui-sref="material-ibq-detail({id:materialFile.materialId})">{{materialFile.materialTitle}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="material-file-ibq-detail({id:materialFile.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="material-file-ibq.edit({id:materialFile.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="material-file-ibq.delete({id:materialFile.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/music-sheet/music-sheet-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.musicSheet.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.musicSheet.delete.question" translate-values="{id: \'{{vm.musicSheet.id}}\'}">Are you sure you want to delete this Music Sheet?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/music-sheet/music-sheet-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.musicSheet.detail.title">Music Sheet</span> {{vm.musicSheet.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><!--dt><span data-translate="virtuallibraryApp.musicSheet.musicSheetFile">Music Sheet File</span></dt>\n        <dd>\n            <div ng-if="vm.musicSheet.musicSheetFile">\n                <a ng-click="vm.openFile(vm.musicSheet.musicSheetFileContentType, vm.musicSheet.musicSheetFile)" data-translate="entity.action.open">open</a>\n                {{vm.musicSheet.musicSheetFileContentType}}, {{vm.byteSize(vm.musicSheet.musicSheetFile)}}\n            </div>\n        </dd--><dt><span data-translate="virtuallibraryApp.musicSheet.editionDate">Edition Date</span></dt><dd><span>{{vm.musicSheet.editionDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="virtuallibraryApp.musicSheet.pages">Pages</span></dt><dd><span>{{vm.musicSheet.pages}}</span></dd><dt><span data-translate="virtuallibraryApp.musicSheet.comments">Comments</span></dt><dd><span>{{vm.musicSheet.comments}}</span></dd><dt><span data-translate="virtuallibraryApp.musicSheet.musicSheetFilePath">Music Sheet File Path</span></dt><dd><span><a class="glyphicon glyphicon-download" href="{{vm.musicSheet.musicSheetFilePath}}"></a></span></dd><dt><span data-translate="virtuallibraryApp.musicSheet.title">Title</span></dt><dd><span>{{vm.musicSheet.title}}</span></dd><dt><span data-translate="virtuallibraryApp.musicSheet.arrangement">Arrangement</span></dt><dd><span>{{vm.musicSheet.arrangement}}</span></dd><dt><span data-translate="virtuallibraryApp.musicSheet.cover">Cover</span></dt><dd><img ng-src="{{vm.musicSheet.cover}}" width="100"></dd><dt><span data-translate="virtuallibraryApp.musicSheet.duration">Duration</span></dt><dd><span>{{vm.musicSheet.duration}}</span></dd><dt><span data-translate="virtuallibraryApp.musicSheet.movements">Movements</span></dt><dd><span>{{vm.musicSheet.movements}}</span></dd><dt><span data-translate="virtuallibraryApp.musicSheet.instrumentation">Instrumentation</span></dt><dd><span>{{vm.musicSheet.instrumentation}}</span></dd><dt><span data-translate="virtuallibraryApp.musicSheet.musicalPiece">Musical Piece</span></dt><dd><a ui-sref="musical-piece-ibq-detail({id:vm.musicSheet.musicalPieceId})">{{vm.musicSheet.musicalPieceMainTitle}}</a></dd><dt><span data-translate="virtuallibraryApp.musicSheet.publisher">Publisher</span></dt><dd><a ui-sref="publisher-ibq-detail({id:vm.musicSheet.publisherId})">{{vm.musicSheet.publisherName}}</a></dd><dt><span data-translate="virtuallibraryApp.musicSheet.level">Level</span></dt><dd><a ui-sref="level-ibq-detail({id:vm.musicSheet.levelId})">{{vm.musicSheet.levelName}}</a></dd><dt><span data-translate="virtuallibraryApp.musicSheet.sheetState">Sheet State</span></dt><dd><a ui-sref="state-ibq-detail({id:vm.musicSheet.sheetStateId})">{{vm.musicSheet.sheetStateName}}</a></dd><dt><span data-translate="virtuallibraryApp.musicSheet.musicalArrangementType">Musical Arrangement Type</span></dt><dd><a ui-sref="musical-arrangement-type-ibq-detail({id:vm.musicSheet.musicalArrangementTypeId})">{{vm.musicSheet.musicalArrangementTypeName}}</a></dd><dt><span data-translate="virtuallibraryApp.musicSheet.person">Person</span></dt><dd><a ui-sref="person-ibq-detail({id:vm.musicSheet.personId})">{{vm.musicSheet.personName}}</a></dd><dt><span data-translate="virtuallibraryApp.musicSheet.portalRole">Portal Role</span></dt><dd><span ng-repeat="portalRole in vm.musicSheet.portalRoles"><a ui-sref="portal-role-detail({id: portalRole.id})">{{portalRole.name}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="virtuallibraryApp.musicSheet.country">Country</span></dt><dd><a ui-sref="country-ibq-detail({id:vm.musicSheet.countryId})">{{vm.musicSheet.countryName}}</a></dd><dt><span data-translate="virtuallibraryApp.musicSheet.ensamble">Ensamble</span></dt><dd><span ng-repeat="ensamble in vm.musicSheet.ensambles"><a ui-sref="ensamble-ibq-detail({id: ensamble.id})">{{ensamble.name}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="music-sheet-ibq-detail.edit({id:vm.musicSheet.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/music-sheet/music-sheet-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMusicSheetLabel" data-translate="virtuallibraryApp.musicSheet.home.createOrEditLabel">Create or edit a Music Sheet</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.musicSheet.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.musicSheet.id" readonly="readonly"></div><div class="form-group" ngf-drop ngf-change="vm.setMusicSheetFile($file, vm.musicSheet)"><label class="control-label" data-translate="virtuallibraryApp.musicSheet.musicSheetFile" for="field_musicSheetFile">Music Sheet File</label><div><div ng-if="vm.musicSheet.musicSheetFilePath" class="help-block clearfix"><span ng-if="!vm.musicSheet.musicSheetFilePath.includes(\'api\')" class="pull-left">{{vm.musicSheet.musicSheetFilePath}}</span> <span ng-if="vm.musicSheet.musicSheetFilePath.includes(\'api\')" class="pull-left">{{vm.musicSheet.musicSheetFilePath.substring(vm.musicSheet.musicSheetFilePath.lastIndexOf(\'-\')+1,vm.musicSheet.musicSheetFilePath.length)}}</span><!--button type="button" class="btn btn-success" ng-click="vm.openFile(vm.musicSheet.musicSheetFileContentType, vm.musicSheet.musicSheetFile)">\n                        <span class="glyphicon glyphicon-download" aria-hidden="true"></span>\n                    </button>\n                    <span class="pull-left">{{vm.musicSheet.musicSheetFileContentType}}, {{vm.byteSize(vm.musicSheet.musicSheetFile)}}</span>\n                    <button type="button"\n                            ng-click="vm.musicSheet.musicSheetFile=null;vm.musicSheet.musicSheetFileContentType=null;"\n                            class="btn btn-default btn-xs pull-right">\n                        <span class="glyphicon glyphicon-remove"></span>\n                    </button--></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setMusicSheetFile($file, vm.musicSheet)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="musicSheetFile" id="field_musicSheetFile" ng-model="vm.musicSheet.musicSheetFile" ng-required="!vm.musicSheet.id"> <input type="hidden" class="form-control" name="musicSheetFileContentType" id="field_musicSheetFileContentType" ng-model="vm.musicSheet.musicSheetFileContentType"><div ng-show="editForm.musicSheetFile.$invalid"><p class="help-block" ng-show="editForm.musicSheetFile.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicSheet.editionDate" for="field_editionDate">Edition Date</label><div class="input-group"><input id="field_editionDate" type="text" class="form-control" name="editionDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.musicSheet.editionDate" is-open="vm.datePickerOpenStatus.editionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'editionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicSheet.pages" for="field_pages">Pages</label><input type="number" class="form-control" name="pages" id="field_pages" ng-model="vm.musicSheet.pages"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicSheet.comments" for="field_comments">Comments</label><textarea class="form-control" name="comments" id="field_comments" ng-model="vm.musicSheet.comments"></textarea></div><div class="form-group"><!--label class="control-label" data-translate="virtuallibraryApp.musicSheet.musicSheetFilePath" for="field_musicSheetFilePath">Music Sheet File Path</label--> <input type="hidden" class="form-control" name="musicSheetFilePath" id="field_musicSheetFilePath" ng-model="vm.musicSheet.musicSheetFilePath"></div><div class="form-group"><div class="form-group" ngf-drop ngf-change="vm.setMusicSheetCoverFile($file, vm.musicSheet)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="virtuallibraryApp.musicSheet.cover" for="field_cover">Cover File</label><div><img data-ng-src="{{\'data:\' + vm.musicSheet.musicSheetCoverFileContentType + \';base64,\' + vm.musicSheet.musicSheetCoverFile}}" style="max-height: 100px; margin-bottom: 10px" ng-if="!vm.musicSheet.cover.includes(\'api\')&& vm.musicSheet.cover" alt="cover image"> <img data-ng-src="{{vm.musicSheet.cover}}" style="max-height: 100px; margin-bottom: 10px" ng-if="vm.musicSheet.cover.includes(\'api\')" alt="cover image"><!--img\n                        data-ng-src="{{\'data:\' + vm.musicSheet.musicSheetCoverFileContentType + \';base64,\' + vm.musicSheet.musicSheetCoverFile}}"\n                        style="max-height: 100px;" ng-if="vm.musicSheet.musicSheetCoverFile" alt="musicSheet image"/>\n                    <div ng-if="vm.musicSheet.musicSheetCoverFile" class="help-block clearfix">\n                    <span\n                        class="pull-left">{{vm.musicSheet.musicSheetCoverFileContentType}}, {{vm.byteSize(vm.musicSheet.musicSheetCoverFile)}}</span>\n                        <button type="button"\n                                ng-click="vm.musicSheet.musicSheetCoverFile=null;vm.musicSheet.musicSheetCoverFileContentType=null;"\n                                class="btn btn-default btn-xs pull-right">\n                            <span class="glyphicon glyphicon-remove"></span>\n                        </button>\n                    </div--> <button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setMusicSheetCoverFile($file, vm.musicSheet)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="coverFile" id="field_coverFile" ng-model="vm.musicSheet.musicSheetCoverFile"> <input type="hidden" class="form-control" name="musicSheetCoverFileContentType" id="field_musicSheetCoverFileContentType" ng-model="vm.musicSheet.musicSheetCoverFileContentType"></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicSheet.duration" for="field_duration">Duration</label><input type="number" class="form-control" name="duration" id="field_duration" ng-model="vm.musicSheet.duration"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicSheet.movements" for="field_movements">Movements</label><input type="text" class="form-control" name="movements" id="field_movements" ng-model="vm.musicSheet.movements"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicSheet.instrumentation" for="field_instrumentation">Instrumentation</label><input type="text" class="form-control" name="instrumentation" id="field_instrumentation" ng-model="vm.musicSheet.instrumentation"></div><div class="form-group"><label data-translate="virtuallibraryApp.musicSheet.musicalPiece" for="field_musicalPiece">Musical Piece</label><select class="form-control" id="field_musicalPiece" name="musicalPiece" ng-model="vm.musicSheet.musicalPieceId" ng-options="musicalPiece.id as musicalPiece.mainTitle for musicalPiece in vm.musicalpieces"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.musicSheet.publisher" for="field_publisher">Publisher</label><select class="form-control" id="field_publisher" name="publisher" ng-model="vm.musicSheet.publisherId" ng-options="publisher.id as publisher.name for publisher in vm.publishers"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.musicSheet.level" for="field_level">Level</label><select class="form-control" id="field_level" name="level" ng-model="vm.musicSheet.levelId" ng-options="level.id as level.name for level in vm.levels"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.musicSheet.sheetState" for="field_sheetState">Sheet State</label><select class="form-control" id="field_sheetState" name="sheetState" ng-model="vm.musicSheet.sheetStateId" ng-options="state.id as state.name for state in vm.states"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicSheet.arrangement" for="field_arrangement">Arrangement</label><input type="checkbox" name="arrangement" id="field_arrangement" ng-model="vm.musicSheet.arrangement"></div><div ng-show="vm.musicSheet.arrangement"><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicSheet.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.musicSheet.title"></div><div class="form-group"><label data-translate="virtuallibraryApp.musicSheet.musicalArrangementType" for="field_musicalArrangementType">Musical Arrangement Type</label><select class="form-control" id="field_musicalArrangementType" name="musicalArrangementType" ng-model="vm.musicSheet.musicalArrangementTypeId" ng-options="musicalArrangementType.id as musicalArrangementType.name for musicalArrangementType in vm.musicalarrangementtypes"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.musicSheet.person" for="field_person">Person</label><!--select class="form-control" id="field_person" name="person" ng-model="vm.musicSheet.personId"\n                        ng-options="person.id as person.name for person in vm.people">\n                    <option value=""></option>\n                </select--><ui-select ng-model="vm.musicSheet.personId" name="field_person" id="field_person" theme="bootstrap"><ui-select-match>{{$select.selected.value.name}}&nbsp;{{$select.selected.value.lastName}}</ui-select-match><ui-select-choices repeat="person.value.id as (id, person) in vm.people | filter: { value: { name: $select.search }}"><div><span ng-bind-html="person.value.name | highlight: $select.search"></span>&af; <span ng-bind-html="person.value.lastName | highlight: $select.search"></span></div></ui-select-choices></ui-select></div></div><div class="form-group"><label data-translate="virtuallibraryApp.musicSheet.portalRole" for="field_portalRole">Portal Role</label><!--<select class="form-control" id="field_portalRole" multiple name="portalRole" ng-model="vm.musicSheet.portalRoles" ng-options="portalRole as portalRole.name for portalRole in vm.portalroles track by portalRole.id"></select>--><ui-select multiple="multiple" ng-model="vm.musicSheet.portalRoles" theme="bootstrap" name="field_portalRole" id="field_country"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="portalRole in vm.portalroles | propsFilter: {name: $select.search}"><div ng-bind-html="portalRole.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group"><label data-translate="virtuallibraryApp.musicSheet.country" for="field_country">Country</label><!--<select class="form-control" id="field_country" name="country" ng-model="vm.musicSheet.countryId" ng-options="country.id as country.name for country in vm.countries"><option value=""></option></select>--><ui-select ng-model="vm.musicSheet.countryId" name="field_country" id="field_country" theme="bootstrap"><ui-select-match>{{$select.selected.value.name}}</ui-select-match><ui-select-choices repeat="country.value.id as (id, country) in vm.countries | filter: { value: { name: $select.search }}"><div><span ng-bind-html="country.value.name | highlight: $select.search"></span>&af; <span ng-bind-html="country.value.lastName | highlight: $select.search"></span></div></ui-select-choices></ui-select><div class="form-group"><label data-translate="virtuallibraryApp.musicSheet.ensamble" for="field_ensamble">Ensamble</label><ui-select multiple="multiple" ng-model="vm.musicSheet.ensambles" theme="bootstrap" name="field_ensamble" id="field_ensamble"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="ensamble in vm.ensambles | propsFilter: {name: $select.search}"><div ng-bind-html="ensamble.name | highlight: $select.search"></div></ui-select-choices></ui-select><!--select class="form-control" id="field_ensamble" multiple name="ensamble"\n                        ng-model="vm.musicSheet.ensambles"\n                        ng-options="ensamble as ensamble.name for ensamble in vm.ensambles track by ensamble.id"></select--></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/music-sheet/music-sheetsibq.html','<div><h2 data-translate="virtuallibraryApp.musicSheet.home.title">Music Sheets</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="music-sheet-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.musicSheet.home.createLabel">Create new Music Sheet</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.musicSheet.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="musicSheetFile"><span data-translate="virtuallibraryApp.musicSheet.musicSheetFile">Music Sheet File</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="editionDate"><span data-translate="virtuallibraryApp.musicSheet.editionDate">Edition Date</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="pages"><span data-translate="virtuallibraryApp.musicSheet.pages">Pages</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="comments"><span data-translate="virtuallibraryApp.musicSheet.comments">Comments</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="musicSheetFilePath"><span data-translate="virtuallibraryApp.musicSheet.musicSheetFilePath">Music Sheet File Path</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="musicalPieceMainTitle"><span data-translate="virtuallibraryApp.musicSheet.musicalPiece">Musical Piece</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publisherName"><span data-translate="virtuallibraryApp.musicSheet.publisher">Publisher</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="levelName"><span data-translate="virtuallibraryApp.musicSheet.level">Level</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sheetStateName"><span data-translate="virtuallibraryApp.musicSheet.sheetState">Sheet State</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="musicSheet in vm.musicSheets track by musicSheet.id"><td><a ui-sref="music-sheet-ibq-detail({id:musicSheet.id})">{{musicSheet.id}}</a></td><!--td>\n                        <a ng-if="musicSheet.musicSheetFile" ng-click="vm.openFile(musicSheet.musicSheetFileContentType, musicSheet.musicSheetFile)" data-translate="entity.action.open">open</a>\n                        <span ng-if="musicSheet.musicSheetFile">{{musicSheet.musicSheetFileContentType}}, {{vm.byteSize(musicSheet.musicSheetFile)}}</span>\n                    </td--><!--td>{{musicSheet.editionDate | date:\'mediumDate\'}}</td--><td>{{musicSheet.pages}}</td><!--<td>{{musicSheet.comments}}</td>--><td><a class="glyphicon glyphicon-download" href="{{musicSheet.musicSheetFilePath}}"></a></td><td><a ui-sref="musical-piece-ibq-detail({id:musicSheet.musicalPieceId})">{{musicSheet.musicalPieceMainTitle}}</a></td><td><a ui-sref="publisher-ibq-detail({id:musicSheet.publisherId})">{{musicSheet.publisherName}}</a></td><td><a ui-sref="level-ibq-detail({id:musicSheet.levelId})">{{musicSheet.levelName}}</a></td><td><a ui-sref="state-ibq-detail({id:musicSheet.sheetStateId})">{{musicSheet.sheetStateName}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="music-sheet-ibq-detail({id:musicSheet.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="music-sheet-ibq.edit({id:musicSheet.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="music-sheet-ibq.delete({id:musicSheet.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/musical-arrangement/musical-arrangement-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.musicalArrangement.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.musicalArrangement.delete.question" translate-values="{id: \'{{vm.musicalArrangement.id}}\'}">Are you sure you want to delete this Musical Arrangement?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/musical-arrangement/musical-arrangement-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.musicalArrangement.detail.title">Musical Arrangement</span> {{vm.musicalArrangement.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.musicalArrangement.title">Title</span></dt><dd><span>{{vm.musicalArrangement.title}}</span></dd><!--dt><span data-translate="virtuallibraryApp.musicalArrangement.arrangementFile">Arrangement File</span></dt>\n        <dd>\n            <div ng-if="vm.musicalArrangement.arrangementFile">\n                <a ng-click="vm.openFile(vm.musicalArrangement.arrangementFileContentType, vm.musicalArrangement.arrangementFile)" data-translate="entity.action.open">open</a>\n                {{vm.musicalArrangement.arrangementFileContentType}}, {{vm.byteSize(vm.musicalArrangement.arrangementFile)}}\n            </div>\n        </dd--><dt><span data-translate="virtuallibraryApp.musicalArrangement.arrangementFilePath">Arrangement File Path</span></dt><dd><a href="{{vm.musicalArrangement.arrangementFilePath}}">{{vm.musicalArrangement.arrangementFilePath}}</a></dd><dt><span data-translate="virtuallibraryApp.musicalArrangement.pages">Pages</span></dt><dd><span>{{vm.musicalArrangement.pages}}</span></dd><dt><span data-translate="virtuallibraryApp.musicalArrangement.comments">Comments</span></dt><dd><span>{{vm.musicalArrangement.comments}}</span></dd><dt><span data-translate="virtuallibraryApp.musicalArrangement.type">Type</span></dt><dd><a ui-sref="musical-arrangement-type-ibq-detail({id:vm.musicalArrangement.typeId})">{{vm.musicalArrangement.typeName}}</a></dd><dt><span data-translate="virtuallibraryApp.musicalArrangement.level">Level</span></dt><dd><a ui-sref="level-ibq-detail({id:vm.musicalArrangement.levelId})">{{vm.musicalArrangement.levelName}}</a></dd><dt><span data-translate="virtuallibraryApp.musicalArrangement.state">State</span></dt><dd><a ui-sref="state-ibq-detail({id:vm.musicalArrangement.stateId})">{{vm.musicalArrangement.stateName}}</a></dd><dt><span data-translate="virtuallibraryApp.musicalArrangement.publisher">Publisher</span></dt><dd><a ui-sref="publisher-ibq-detail({id:vm.musicalArrangement.publisherId})">{{vm.musicalArrangement.publisherName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="musical-arrangement-ibq-detail.edit({id:vm.musicalArrangement.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/musical-arrangement/musical-arrangement-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMusicalArrangementLabel" data-translate="virtuallibraryApp.musicalArrangement.home.createOrEditLabel">Create or edit a Musical Arrangement</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.musicalArrangement.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.musicalArrangement.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicalArrangement.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.musicalArrangement.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setArrangementFile($file, vm.musicalArrangement)"><label class="control-label" data-translate="virtuallibraryApp.musicalArrangement.arrangementFile" for="field_arrangementFile">Arrangement File</label><div><div ng-if="vm.musicalArrangement.arrangementFile" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.musicalArrangement.arrangementFileContentType, vm.musicalArrangement.arrangementFile)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.musicalArrangement.arrangementFileContentType}}, {{vm.byteSize(vm.musicalArrangement.arrangementFile)}}</span> <button type="button" ng-click="vm.musicalArrangement.arrangementFile=null;vm.musicalArrangement.arrangementFileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setArrangementFile($file, vm.musicalArrangement)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="arrangementFile" id="field_arrangementFile" ng-model="vm.musicalArrangement.arrangementFile"> <input type="hidden" class="form-control" name="arrangementFileContentType" id="field_arrangementFileContentType" ng-model="vm.musicalArrangement.arrangementFileContentType"></div><div class="form-group"><!--label class="control-label" data-translate="virtuallibraryApp.musicalArrangement.arrangementFilePath" for="field_arrangementFilePath">Arrangement File Path</label--> <input type="hidden" class="form-control" name="arrangementFilePath" id="field_arrangementFilePath" ng-model="vm.musicalArrangement.arrangementFilePath"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicalArrangement.pages" for="field_pages">Pages</label><input type="number" class="form-control" name="pages" id="field_pages" ng-model="vm.musicalArrangement.pages"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicalArrangement.comments" for="field_comments">Comments</label><textarea class="form-control" name="comments" id="field_comments" ng-model="vm.musicalArrangement.comments"></textarea></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicalArrangement.instrumentation" for="field_instrumentation">Instrumentation</label><textarea class="form-control" name="instrumentation" id="field_instrumentation" ng-model="vm.musicalArrangement.instrumentation" ng-maxlength="6000"></textarea><div ng-show="editForm.instrumentation.$invalid"><p class="help-block" ng-show="editForm.instrumentation.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6000">This field cannot be longer than 6000 characters.</p></div></div><div class="form-group"><label data-translate="virtuallibraryApp.musicalArrangement.type" for="field_type">Type</label><!--select class="form-control" id="field_type" name="type" ng-model="vm.musicalArrangement.typeId" ng-options="musicalArrangementType.id as musicalArrangementType.name for musicalArrangementType in vm.musicalarrangementtypes"            >\n                <option value=""></option>\n            </select--><ui-select ng-model="vm.musicalArrangement.typeId" name="field_type" id="field_type" theme="bootstrap"><ui-select-match>{{$select.selected.value.name}}</ui-select-match><ui-select-choices repeat="musicalArrangementType.value.id as (id, musicalArrangementType) in vm.musicalarrangementtypes | filter: { value: { name: $select.search }}"><div ng-bind-html="musicalArrangementType.value.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><!--div class="form-group">\n            <label data-translate="virtuallibraryApp.musicalArrangement.level" for="field_level">Level</label>\n            <nselect class="form-control" id="field_level" name="level" ng-model="vm.musicalArrangement.levelId" ng-options="level.id as level.name for level in vm.levels"            >\n                <option value=""></option>\n            </select>\n            <ui-select ng-model="vm.musicalArrangement.levelId" name="field_level" id="field_level" theme="bootstrap">\n                <ui-select-match>{{$select.selected.value.name}}</ui-select-match>\n                <ui-select-choices repeat="level.value.id as (id, level) in vm.levels | filter: { value: { name: $select.search }}">\n                    <div ng-bind-html="level.value.name | highlight: $select.search"></div>\n                </ui-select-choices>\n            </ui-select>\n\n        </div--><div class="form-group"><label data-translate="virtuallibraryApp.musicalArrangement.state" for="field_state">State</label><!--select class="form-control" id="field_state" name="state" ng-model="vm.musicalArrangement.stateId" ng-options="state.id as state.name for state in vm.states"            >\n                <option value=""></option>\n            </select--><ui-select ng-model="vm.musicalArrangement.stateId" name="field_state" id="field_state" theme="bootstrap"><ui-select-match>{{$select.selected.value.name}}</ui-select-match><ui-select-choices repeat="state.value.id as (id, state) in vm.states | filter: { value: { name: $select.search }}"><div ng-bind-html="state.value.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group"><label data-translate="virtuallibraryApp.musicalArrangement.publisher" for="field_publisher">Publisher</label><!--select class="form-control" id="field_publisher" name="publisher" ng-model="vm.musicalArrangement.publisherId" ng-options="publisher.id as publisher.name for publisher in vm.publishers"            >\n                <option value=""></option>\n            </select--><ui-select ng-model="vm.musicalArrangement.publisherId" name="field_publisher" id="field_publisher" theme="bootstrap"><ui-select-match>{{$select.selected.value.name}}</ui-select-match><ui-select-choices repeat="publisher.value.id as (id, publisher) in vm.publishers | filter: { value: { name: $select.search }}"><div ng-bind-html="publisher.value.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group"><label data-translate="virtuallibraryApp.musicalArrangement.person" for="field_person">Person</label><select class="form-control" id="field_person" name="person" ng-model="vm.musicalArrangement.personId" ng-options="person.id as person.name for person in vm.people"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/musical-arrangement/musical-arrangementsibq.html','<div><h2 data-translate="virtuallibraryApp.musicalArrangement.home.title">Musical Arrangements</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="musical-arrangement-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.musicalArrangement.home.createLabel">Create new Musical Arrangement</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.musicalArrangement.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="virtuallibraryApp.musicalArrangement.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="arrangementFile"><span data-translate="virtuallibraryApp.musicalArrangement.arrangementFile">Arrangement File</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="arrangementFilePath"><span data-translate="virtuallibraryApp.musicalArrangement.arrangementFilePath">Arrangement File Path</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pages"><span data-translate="virtuallibraryApp.musicalArrangement.pages">Pages</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="comments"><span data-translate="virtuallibraryApp.musicalArrangement.comments">Comments</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="typeName"><span data-translate="virtuallibraryApp.musicalArrangement.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="levelName"><span data-translate="virtuallibraryApp.musicalArrangement.level">Level</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="stateName"><span data-translate="virtuallibraryApp.musicalArrangement.state">State</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="musicalArrangement in vm.musicalArrangements track by musicalArrangement.id"><td><a ui-sref="musical-arrangement-ibq-detail({id:musicalArrangement.id})">{{musicalArrangement.id}}</a></td><td>{{musicalArrangement.title}}</td><!--td>\n                        <a ng-if="musicalArrangement.arrangementFile" ng-click="vm.openFile(musicalArrangement.arrangementFileContentType, musicalArrangement.arrangementFile)" data-translate="entity.action.open">open</a>\n                        <span ng-if="musicalArrangement.arrangementFile">{{musicalArrangement.arrangementFileContentType}}, {{vm.byteSize(musicalArrangement.arrangementFile)}}</span>\n                    </td--><td><a ng-if="musicalArrangement.arrangementFilePath" class="glyphicon glyphicon-download" href="{{musicalArrangement.arrangementFilePath}}"></a></td><td>{{musicalArrangement.pages}}</td><!--<td>{{musicalArrangement.comments}}</td>--><td><a ui-sref="musical-arrangement-type-ibq-detail({id:musicalArrangement.typeId})">{{musicalArrangement.typeName}}</a></td><td><a ui-sref="level-ibq-detail({id:musicalArrangement.levelId})">{{musicalArrangement.levelName}}</a></td><td><a ui-sref="state-ibq-detail({id:musicalArrangement.stateId})">{{musicalArrangement.stateName}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="musical-arrangement-ibq-detail({id:musicalArrangement.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="musical-arrangement-ibq.edit({id:musicalArrangement.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="musical-arrangement-ibq.delete({id:musicalArrangement.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/musical-arrangement-type/musical-arrangement-type-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.musicalArrangementType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.musicalArrangementType.delete.question" translate-values="{id: \'{{vm.musicalArrangementType.id}}\'}">Are you sure you want to delete this Musical Arrangement Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/musical-arrangement-type/musical-arrangement-type-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.musicalArrangementType.detail.title">Musical Arrangement Type</span> {{vm.musicalArrangementType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.musicalArrangementType.name">Name</span></dt><dd><span>{{vm.musicalArrangementType.name}}</span></dd><dt><span data-translate="virtuallibraryApp.musicalArrangementType.description">Description</span></dt><dd><span>{{vm.musicalArrangementType.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="musical-arrangement-type-ibq-detail.edit({id:vm.musicalArrangementType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/musical-arrangement-type/musical-arrangement-type-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMusicalArrangementTypeLabel" data-translate="virtuallibraryApp.musicalArrangementType.home.createOrEditLabel">Create or edit a Musical Arrangement Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.musicalArrangementType.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.musicalArrangementType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicalArrangementType.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.musicalArrangementType.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicalArrangementType.description" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" ng-model="vm.musicalArrangementType.description" ng-maxlength="6000"></textarea><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6000">This field cannot be longer than 6000 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/musical-arrangement-type/musical-arrangement-typesibq.html','<div><h2 data-translate="virtuallibraryApp.musicalArrangementType.home.title">Musical Arrangement Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="musical-arrangement-type-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.musicalArrangementType.home.createLabel">Create new Musical Arrangement Type</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.musicalArrangementType.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.musicalArrangementType.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="description"><span data-translate="virtuallibraryApp.musicalArrangementType.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat="musicalArrangementType in vm.musicalArrangementTypes track by musicalArrangementType.id"><td><a ui-sref="musical-arrangement-type-ibq-detail({id:musicalArrangementType.id})">{{musicalArrangementType.id}}</a></td><td>{{musicalArrangementType.name}}</td><!--<td>{{musicalArrangementType.description}}</td>--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="musical-arrangement-type-ibq-detail({id:musicalArrangementType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="musical-arrangement-type-ibq.edit({id:musicalArrangementType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="musical-arrangement-type-ibq.delete({id:musicalArrangementType.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/musical-piece/musical-piece-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.musicalPiece.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.musicalPiece.delete.question" translate-values="{id: \'{{vm.musicalPiece.id}}\'}">Are you sure you want to delete this Musical Piece?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/musical-piece/musical-piece-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.musicalPiece.detail.title">Musical Piece</span> {{vm.musicalPiece.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.musicalPiece.mainTitle">Main Title</span></dt><dd><span>{{vm.musicalPiece.mainTitle}}</span></dd><dt><span data-translate="virtuallibraryApp.musicalPiece.alternateTitle">Alternate Title</span></dt><dd><span>{{vm.musicalPiece.alternateTitle}}</span></dd><dt><span data-translate="virtuallibraryApp.musicalPiece.subtitle">Subtitle</span></dt><dd><span>{{vm.musicalPiece.subtitle}}</span></dd><dt><span data-translate="virtuallibraryApp.musicalPiece.dedication">Dedication</span></dt><dd><span>{{vm.musicalPiece.dedication}}</span></dd><dt><span data-translate="virtuallibraryApp.musicalPiece.cover">Dedication</span></dt><dd><span><img ng-src="{{vm.musicalPiece.musicalPiecePath}}" width="100"></span></dd><dt><span data-translate="virtuallibraryApp.musicalPiece.compositionYear">Composition Year</span></dt><dd><span>{{vm.musicalPiece.compositionYear}}</span></dd><span ng-repeat="participation in vm.musicalPiece.participations"><a ui-sref="participation-ibq-detail({id: participation.id})">{{participation.title}}</a>{{$last ? \'\' : \', \'}}</span><dt><span data-translate="virtuallibraryApp.musicalPiece.album">Album</span></dt><dd><a ui-sref="album-detail({id:vm.musicalPiece.albumId})">{{vm.musicalPiece.albumName}}</a></dd><dt><span data-translate="virtuallibraryApp.musicalPiece.ensamble">Album</span></dt><dd><span ng-repeat="ensamble in vm.musicalPiece.ensambles"><a ui-sref="ensamble-ibq-detail({id: ensamble.id})">{{ensamble.name}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="musical-piece-ibq-detail.edit({id:vm.musicalPiece.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/musical-piece/musical-piece-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMusicalPieceLabel" data-translate="virtuallibraryApp.musicalPiece.home.createOrEditLabel">Create or edit a Musical Piece</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.musicalPiece.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.musicalPiece.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicalPiece.mainTitle" for="field_mainTitle">Main Title</label><span class="glyphicon glyphicon-question-sign" data aria-hidden="true" uib-tooltip="{{\'virtuallibraryApp.musicalPiece.mainTitleHelp\'|translate}}"></span> <input type="text" class="form-control" name="mainTitle" id="field_mainTitle" ng-model="vm.musicalPiece.mainTitle" required><div ng-show="editForm.mainTitle.$invalid"><p class="help-block" ng-show="editForm.mainTitle.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicalPiece.alternateTitle" for="field_alternateTitle">Alternate Title</label><input type="text" class="form-control" name="alternateTitle" id="field_alternateTitle" ng-model="vm.musicalPiece.alternateTitle"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicalPiece.subtitle" for="field_subtitle">Subtitle</label><input type="text" class="form-control" name="subtitle" id="field_subtitle" ng-model="vm.musicalPiece.subtitle"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicalPiece.dedication" for="field_dedication">Dedication</label><textarea class="form-control" name="dedication" id="field_dedication" ng-model="vm.musicalPiece.dedication"></textarea></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.musicalPiece.compositionYear" for="field_compositionYear">Composition Year</label><input type="number" class="form-control" name="compositionYear" id="field_compositionYear" ng-model="vm.musicalPiece.compositionYear"></div><div class="form-group" ngf-drop ngf-change="vm.setCover($file, vm.musicalPiece)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="virtuallibraryApp.musicalPiece.cover" for="field_cover">Cover</label><div><img data-ng-src="{{\'data:\' + vm.musicalPiece.coverContentType + \';base64,\' + vm.musicalPiece.cover}}" style="max-height: 100px" ng-if="!vm.musicalPiece.musicalPiecePath.includes(\'api\')&& vm.musicalPiece.musicalPiecePath" alt="musicalPiece image"> <img data-ng-src="{{vm.musicalPiece.musicalPiecePath}}" style="max-height: 100px; margin-bottom: 10px" ng-if="vm.musicalPiece.musicalPiecePath.includes(\'api\')" alt="photo image"><br><!--div ng-if="vm.musicalPiece.cover" class="help-block clearfix">\n                    <span class="pull-left">{{vm.musicalPiece.coverContentType}}, {{vm.byteSize(vm.musicalPiece.cover)}}</span>\n                    <button type="button" ng-click="vm.musicalPiece.cover=null;vm.musicalPiece.coverContentType=null;"\n                            class="btn btn-default btn-xs pull-right">\n                        <span class="glyphicon glyphicon-remove"></span>\n                    </button>\n                </div--> <button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setCover($file, vm.musicalPiece)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="cover" id="field_cover" ng-model="vm.musicalPiece.cover"> <input type="hidden" class="form-control" name="coverContentType" id="field_coverContentType" ng-model="vm.musicalPiece.coverContentType"></div><div class="form-group"><label data-translate="virtuallibraryApp.musicalPiece.album" for="field_album">Album</label><ui-select ng-model="vm.musicalPiece.albumId" name="field_album" id="field_album" theme="bootstrap"><ui-select-match>{{$select.selected.value.name}}</ui-select-match><ui-select-choices repeat="album.value.id as (id, album) in vm.albums | filter: { value: { name: $select.search }}"><div ng-bind-html="album.value.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group"><label data-translate="virtuallibraryApp.musicalPiece.ensamble" for="field_ensamble">Ensamble</label><ui-select multiple="multiple" ng-model="vm.musicalPiece.ensambles" theme="bootstrap" name="field_ensamble" id="field_ensamble"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="ensamble in vm.ensambles | propsFilter: {name: $select.search}"><div ng-bind-html="ensamble.name | highlight: $select.search"></div></ui-select-choices></ui-select><!--<select class="form-control" id="field_ensamble" multiple name="ensamble" ng-model="vm.musicalPiece.ensambles" ng-options="ensamble as ensamble.name for ensamble in vm.ensambles track by ensamble.id"></select>--></div><div class="form-group"><label data-translate="virtuallibraryApp.musicalPiece.participations" for="field_participation">Participation</label><div class="row"><div class="col-md-11 no-padding-right"><ui-select multiple="multiple" ng-model="vm.musicalPiece.participations" theme="bootstrap" name="field_country" id="field_country"><ui-select-match>{{$item.title}}</ui-select-match><ui-select-choices repeat="participation in vm.participations | filter: { title: $select.search}"><div ng-bind-html="participation.title | highlight: $select.search"></div><!--small>\n                                T\xEDtulo: {{participation.title}}\n                                <strong>Roles</strong>:<span\n                                ng-repeat-start="role in participation.roles">{{role.roleName}}</span><span\n                                ng-repeat-end\n                                ng-if="!$last">,&nbsp</span>\n                            </small--></ui-select-choices></ui-select></div><div class="col-md-1 no-padding-right"><button type="button" class="btn btn-default" ng-click="vm.participant.show=true"><span class="glyphicon glyphicon-plus"></span></button></div></div></div><div class="row" ng-show="vm.participant.show"><div class="col-md-7"><div class="form-group"><!--data-translate="virtuallibraryApp.musicalPiece.person--><label>Persona</label><ui-select ng-model="vm.participant.person" name="field_person" id="field_person" theme="bootstrap" style="min-width: 300px" title="Choose a person"><ui-select-match>{{$select.selected.name}}&nbsp;{{$select.selected.lastName}}</ui-select-match><ui-select-choices repeat="person in vm.people | propsFilter: {name: $select.search}"><div><span ng-bind-html="person.name | highlight: $select.search">&af;</span> <span ng-bind-html="person.lastName | highlight: $select.search"></span></div></ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group"><!-- data-translate="virtuallibraryApp.person.role --><label for="field_role">Role</label><!--select class="form-control" id="field_role" name="role" ng-model="vm.participant.role"\n                            ng-options="role as role.roleName for role in vm.roles track by role.id"></select--><ui-select multiple="multiple" ng-model="vm.participant.roles" theme="bootstrap" close-on-select="false"><ui-select-match>{{$item.roleName}}</ui-select-match><ui-select-choices repeat="role in vm.roles | filter:$select.search">{{role.roleName}}</ui-select-choices></ui-select></div></div><div class="col-md-1 no-padding-right"><button type="button" class="btn btn-default" style="margin-top: 1.8em" ng-click="vm.addParticipant()"><!-- data-translate="entity.action.add" --> <span class="glyphicon glyphicon-plus"></span></button></div><div class="col-md-12" ng-show="vm.participation.length > 0"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Persona</span></th><th><span>Rol</span></th><th></th></tr></thead><tbody><tr ng-repeat="participant in vm.participation"><td>{{participant.person.name}}</td><td><span ng-repeat-start="role in participant.roles">{{role.roleName}}</span><span ng-repeat-end ng-if="!$last">,&nbsp;</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button class="btn btn-danger btn-sm" ng-click="vm.deleteParticipant(participant)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr><tr ng-repeat="p in vm.participations"><td>{{p.person.name}}</td><td><span ng-repeat-start="role in participant.roles">{{role.roleName}}</span><span ng-repeat-end ng-if="!$last">,&nbsp;</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button class="btn btn-danger btn-sm" ng-click="vm.deleteParticipant(participant)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/musical-piece/musical-piecesibq.html','<div><h2 data-translate="virtuallibraryApp.musicalPiece.home.title">Musical Pieces</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="musical-piece-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.musicalPiece.home.createLabel">Create new Musical Piece</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.musicalPiece.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mainTitle"><span data-translate="virtuallibraryApp.musicalPiece.mainTitle">Main Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="alternateTitle"><span data-translate="virtuallibraryApp.musicalPiece.alternateTitle">Alternate Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="subtitle"><span data-translate="virtuallibraryApp.musicalPiece.subtitle">Subtitle</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="dedication"><span data-translate="virtuallibraryApp.musicalPiece.dedication">Dedication</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="compositionDate"><span data-translate="virtuallibraryApp.musicalPiece.compositionDate">Composition Date</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="albumName"><span data-translate="virtuallibraryApp.musicalPiece.album">Album</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="cover"><span data-translate="virtuallibraryApp.musicalPiece.cover">Cover</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="musicalPiece in vm.musicalPieces track by musicalPiece.id"><td><a ui-sref="musical-piece-ibq-detail({id:musicalPiece.id})">{{musicalPiece.id}}</a></td><td>{{musicalPiece.mainTitle}}</td><td>{{musicalPiece.alternateTitle}}</td><td>{{musicalPiece.subtitle}}</td><td><img ng-src="{{musicalPiece.musicalPiecePath}}" width="100"></td><!--td>{{musicalPiece.dedication}}</td>\n                    <td>{{musicalPiece.compositionDate | date:\'mediumDate\'}}</td>\n                <td>\n                    <a ui-sref="album-detail({id:musicalPiece.albumId})">{{musicalPiece.albumName}}</a>\n                </td--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="musical-piece-ibq-detail({id:musicalPiece.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="musical-piece-ibq.edit({id:musicalPiece.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="musical-piece-ibq.delete({id:musicalPiece.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/part/part-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.part.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.part.delete.question" translate-values="{id: \'{{vm.part.id}}\'}">Are you sure you want to delete this Part?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/part/part-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.part.detail.title">Part</span> {{vm.part.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><!--dt><span data-translate="virtuallibraryApp.part.partFile">Part File</span></dt>\n        <dd>\n            <div ng-if="vm.part.partFile">\n                <a ng-click="vm.openFile(vm.part.partFileContentType, vm.part.partFile)" data-translate="entity.action.open">open</a>\n                {{vm.part.partFileContentType}}, {{vm.byteSize(vm.part.partFile)}}\n            </div>\n        </dd--><dt><span data-translate="virtuallibraryApp.part.partPath">Part Path</span></dt><dd><a href="{{vm.part.partPath}}">{{vm.part.partPath}}</a></dd><dt><span data-translate="virtuallibraryApp.part.pages">Pages</span></dt><dd><span>{{vm.part.pages}}</span></dd><dt><span data-translate="virtuallibraryApp.part.isbn">Isbn</span></dt><dd><span>{{vm.part.isbn}}</span></dd><dt><span data-translate="virtuallibraryApp.part.comments">Comments</span></dt><dd><span>{{vm.part.comments}}</span></dd><dt><span data-translate="virtuallibraryApp.part.musicalPiece">Musical Piece</span></dt><dd><a ui-sref="musical-piece-ibq-detail({id:vm.part.musicalPieceId})">{{vm.part.musicalPieceMainTitle}}</a></dd><dt><span data-translate="virtuallibraryApp.part.publisher">Publisher</span></dt><dd><a ui-sref="publisher-ibq-detail({id:vm.part.publisherId})">{{vm.part.publisherName}}</a></dd><dt><span data-translate="virtuallibraryApp.part.level">Level</span></dt><dd><a ui-sref="level-ibq-detail({id:vm.part.levelId})">{{vm.part.levelName}}</a></dd><dt><span data-translate="virtuallibraryApp.part.partState">Part State</span></dt><dd><a ui-sref="state-ibq-detail({id:vm.part.partStateId})">{{vm.part.partStateName}}</a></dd><dt><span data-translate="virtuallibraryApp.part.instrument">Instruments</span></dt><dd><span ng-repeat="instrument in vm.part.instruments"><a ui-sref="instrument-detail({id: instrument.id})">{{instrument.name}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="part-ibq-detail.edit({id:vm.part.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/part/part-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPartLabel" data-translate="virtuallibraryApp.part.home.createOrEditLabel">Create or edit a Part</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.part.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.part.id" readonly="readonly"></div><div class="form-group" ngf-drop ngf-change="vm.setPartFile($file, vm.part)"><label class="control-label" data-translate="virtuallibraryApp.part.partFile" for="field_partFile">Part File</label><div><div ng-if="vm.part.partPath" class="help-block clearfix"><span ng-if="!vm.part.partPath.includes(\'api\')" class="pull-left">{{vm.part.partPath}}</span> <span ng-if="vm.part.partPath.includes(\'api\')" class="pull-left">{{vm.part.partPath.substring(vm.part.partPath.lastIndexOf(\'-\')+1,vm.part.partPath.length)}}</span><!--a class="pull-left" ng-click="vm.openFile(vm.part.partFileContentType, vm.part.partFile)" data-translate="entity.action.open">open</a><br>\n                    <span class="pull-left">{{vm.part.partFileContentType}}, {{vm.byteSize(vm.part.partFile)}}</span>\n                    <button type="button" ng-click="vm.part.partFile=null;vm.part.partFileContentType=null;"\n                            class="btn btn-default btn-xs pull-right">\n                        <span class="glyphicon glyphicon-remove"></span>\n                    </button--></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setPartFile($file, vm.part)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="partFile" id="field_partFile" ng-model="vm.part.partFile" ng-required="!vm.part.id"> <input type="hidden" class="form-control" name="partFileContentType" id="field_partFileContentType" ng-model="vm.part.partFileContentType"><div ng-show="editForm.partFile.$invalid"><p class="help-block" ng-show="editForm.partFile.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><!--label class="control-label" data-translate="virtuallibraryApp.part.partPath" for="field_partPath">Part Path</label--> <input type="hidden" class="form-control" name="partPath" id="field_partPath" ng-model="vm.part.partPath"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.part.pages" for="field_pages">Pages</label><input type="number" class="form-control" name="pages" id="field_pages" ng-model="vm.part.pages"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.part.isbn" for="field_isbn">Isbn</label><input type="text" class="form-control" name="isbn" id="field_isbn" ng-model="vm.part.isbn"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.part.comments" for="field_comments">Comments</label><textarea class="form-control" name="comments" id="field_comments" ng-model="vm.part.comments"></textarea></div><div class="form-group"><label data-translate="virtuallibraryApp.part.musicalPiece" for="field_musicalPiece">Musical Piece</label><ui-select ng-model="vm.part.musicalPieceId" name="field_musicalPiece" id="field_musicalPiece" theme="bootstrap"><ui-select-match>{{$select.selected.value.mainTitle}}</ui-select-match><ui-select-choices repeat="musicalPiece.value.id as (id, musicalPiece) in vm.musicalpieces | filter: { value: { mainTitle: $select.search }}"><div><span ng-bind-html="musicalPiece.value.mainTitle | highlight: $select.search"></span></div></ui-select-choices></ui-select><!-- <select class="form-control" id="field_musicalPiece" name="musicalPiece"\n                ng-model="vm.part.musicalPieceId" ng-options="musicalPiece.id as musicalPiece.mainTitle for musicalPiece in vm.musicalpieces"            >\n                <option value=""></option>\n            </select> --></div><div class="form-group"><label data-translate="virtuallibraryApp.part.publisher" for="field_publisher">Publisher</label><select class="form-control" id="field_publisher" name="publisher" ng-model="vm.part.publisherId" ng-options="publisher.id as publisher.name for publisher in vm.publishers"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.part.level" for="field_level">Level</label><select class="form-control" id="field_level" name="level" ng-model="vm.part.levelId" ng-options="level.id as level.name for level in vm.levels"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.part.partState" for="field_partState">Part State</label><select class="form-control" id="field_partState" name="partState" ng-model="vm.part.partStateId" ng-options="state.id as state.name for state in vm.states"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.part.instrument" for="field_instrument">Instrument</label><!--<select class="form-control" id="field_instrument" multiple name="instrument" ng-model="vm.part.instruments" ng-options="instrument as instrument.name for instrument in vm.instruments track by instrument.id"></select>--><ui-select multiple="multiple" ng-model="vm.part.instruments" theme="bootstrap" close-on-select="false"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="instrument in vm.instruments | filter:$select.search">{{instrument.name}}&nbsp;({{instrument.representation}})</ui-select-choices></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/part/partsibq.html','<div><h2 data-translate="virtuallibraryApp.part.home.title">Parts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="part-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.part.home.createLabel">Create new Part</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.part.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="partFile"><span data-translate="virtuallibraryApp.part.partFile">Part File</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="partPath"><span data-translate="virtuallibraryApp.part.partPath">Part Path</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pages"><span data-translate="virtuallibraryApp.part.pages">Pages</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isbn"><span data-translate="virtuallibraryApp.part.isbn">Isbn</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="comments"><span data-translate="virtuallibraryApp.part.comments">Comments</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="musicalPieceMainTitle"><span data-translate="virtuallibraryApp.part.musicalPiece">Musical Piece</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publisherName"><span data-translate="virtuallibraryApp.part.publisher">Publisher</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="levelName"><span data-translate="virtuallibraryApp.part.level">Level</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="partStateName"><span data-translate="virtuallibraryApp.part.partState">Part State</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="partStateName"><span data-translate="virtuallibraryApp.part.instrument">Instruments</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="part in vm.parts track by part.id"><td><a ui-sref="part-ibq-detail({id:part.id})">{{part.id}}</a></td><!--td>\n                    <a ng-if="part.partFile" ng-click="vm.openFile(part.partFileContentType, part.partFile)" data-translate="entity.action.open">open</a>\n                    <span ng-if="part.partFile">{{part.partFileContentType}}, {{vm.byteSize(part.partFile)}}</span>\n                </td--><td><a class="glyphicon glyphicon-download" href="{{part.partPath}}"></a></td><td>{{part.pages}}</td><td>{{part.isbn}}</td><!--<td>{{part.comments}}</td>--><td><a ui-sref="musical-piece-ibq-detail({id:part.musicalPieceId})">{{part.musicalPieceMainTitle}}</a></td><td><a ui-sref="publisher-ibq-detail({id:part.publisherId})">{{part.publisherName}}</a></td><td><a ui-sref="level-ibq-detail({id:part.levelId})">{{part.levelName}}</a></td><td><a ui-sref="state-ibq-detail({id:part.partStateId})">{{part.partStateName}}</a></td><td><span ng-repeat="instrument in part.instruments"><a ui-sref="instrument-detail({id: instrument.id})">{{instrument.name}}</a>{{$last ? \'\' : \', \'}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="part-ibq-detail({id:part.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="part-ibq.edit({id:part.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="part-ibq.delete({id:part.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/participation/participation-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.participation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.participation.delete.question" translate-values="{id: \'{{vm.participation.id}}\'}">Are you sure you want to delete this Participation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/participation/participation-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.participation.detail.title">Participation</span> {{vm.participation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.participation.title">Title</span></dt><dd><span>{{vm.participation.title}}</span></dd><dt><span data-translate="virtuallibraryApp.participation.person">Person</span></dt><dd><a ui-sref="person-ibq-detail({id:vm.participation.personId})">{{vm.participation.personName}}</a></dd><dt><span data-translate="virtuallibraryApp.participation.role">Role</span></dt><dd><span ng-repeat="role in vm.participation.roles"><a ui-sref="role-ibq-detail({id: role.id})">{{role.roleName}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="participation-ibq-detail.edit({id:vm.participation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/participation/participation-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myParticipationLabel" data-translate="virtuallibraryApp.participation.home.createOrEditLabel">Create or edit a Participation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.participation.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.participation.id" readonly="readonly"></div><!--div class="form-group">\n            <label class="control-label" data-translate="virtuallibraryApp.participation.title" for="field_title">Title</label>\n            <input type="text" class="form-control" name="title" id="field_title"\n                    ng-model="vm.participation.title"\n                    />\n        </div--><div class="form-group"><label data-translate="virtuallibraryApp.participation.person" for="field_person">Person</label><!--select class="form-control" id="field_person" name="person" ng-model="vm.participation.personId" ng-options="person.id as person.name for person in vm.people"            >\n                <option value=""></option>\n            </select--><ui-select ng-model="vm.participation.personId" name="field_person" id="field_person" theme="bootstrap"><ui-select-match>{{$select.selected.value.name}}&nbsp;{{$select.selected.value.lastName}}</ui-select-match><ui-select-choices repeat="person.value.id as (id, person) in vm.people | filter: { value: { name: $select.search }}"><div><span ng-bind-html="person.value.name | highlight: $select.search"></span>&af; <span ng-bind-html="person.value.lastName | highlight: $select.search"></span></div></ui-select-choices></ui-select></div><div class="form-group"><label data-translate="virtuallibraryApp.participation.role" for="field_role">Role</label><select class="form-control" id="field_role" multiple="multiple" name="role" ng-model="vm.participation.roles" ng-options="role as role.roleName for role in vm.roles track by role.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/participation/participationsibq.html','<div><h2 data-translate="virtuallibraryApp.participation.home.title">Participations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="participation-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.participation.home.createLabel">Create new Participation</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.participation.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="virtuallibraryApp.participation.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="personName"><span data-translate="virtuallibraryApp.participation.person">Person</span> <span class="glyphicon glyphicon-sort"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat="participation in vm.participations track by participation.id"><td><a ui-sref="participation-ibq-detail({id:participation.id})">{{participation.id}}</a></td><td>{{participation.title}}</td><!--td>\n                        <a ui-sref="person-ibq-detail({id:participation.personId})">{{participation.personName}}</a>\n                    </td--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="participation-ibq-detail({id:participation.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="participation-ibq.edit({id:participation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="participation-ibq.delete({id:participation.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/person/peopleibq.html','<div><h2 data-translate="virtuallibraryApp.person.home.title">People</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="person-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.person.home.createLabel">Create new Person</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.person.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.person.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span data-translate="virtuallibraryApp.person.lastName">Last Name</span> <span class="glyphicon glyphicon-sort"></span></th><!--th jh-sort-by="artisticName"><span data-translate="virtuallibraryApp.person.artisticName">Artistic Name</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="pictureFile"><span data-translate="virtuallibraryApp.person.pictureFile">Picture File</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="picturePath"><span data-translate="virtuallibraryApp.person.picturePath">Picture Path</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="birthDate"><span data-translate="virtuallibraryApp.person.birthDate">Birth Date</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="birthPlace"><span data-translate="virtuallibraryApp.person.birthPlace">Birth Place</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="deathDate"><span data-translate="virtuallibraryApp.person.deathDate">Death Date</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="deathPlace"><span data-translate="virtuallibraryApp.person.deathPlace">Death Place</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="sex"><span data-translate="virtuallibraryApp.person.sex">Sex</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="review"><span data-translate="virtuallibraryApp.person.review">Review</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="sources"><span data-translate="virtuallibraryApp.person.sources">Sources</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="comments"><span data-translate="virtuallibraryApp.person.comments">Comments</span> <span class="glyphicon glyphicon-sort"></span></th--><!--<th jh-sort-by="countryName"><span data-translate="virtuallibraryApp.person.country">Country</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="birthCountryName"><span data-translate="virtuallibraryApp.person.birthCountry">Birth Country</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="deathCountryName"><span data-translate="virtuallibraryApp.person.deathCountry">Death Country</span> <span class="glyphicon glyphicon-sort"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat="person in vm.people track by person.id"><td><a ui-sref="person-ibq-detail({id:person.id})">{{person.id}}</a></td><td>{{person.name}}</td><td>{{person.lastName}}</td><!--<td>{{person.artisticName}}</td>>\n                    <td>\n                        <a ng-if="person.pictureFile" ng-click="vm.openFile(person.pictureFileContentType, person.pictureFile)">\n                            <img data-ng-src="{{\'data:\' + person.pictureFileContentType + \';base64,\' + person.pictureFile}}" style="max-height: 30px;" alt="person image"/>\n                        </a>\n                        <span ng-if="person.pictureFile">{{person.pictureFileContentType}}, {{vm.byteSize(person.pictureFile)}}</span>\n                    </td>\n                    <td>{{person.picturePath}}</td>\n                        <td>{{person.birthDate | date:\'mediumDate\'}}</td>\n                    <td>{{person.birthPlace}}</td>\n                        <td>{{person.deathDate | date:\'mediumDate\'}}</td>\n                    <td>{{person.deathPlace}}</td>\n                    <td>{{person.sex}}</td>\n                    <td>{{person.review}}</td>\n                    <td>{{person.sources}}</td>\n                    <td>{{person.comments}}</td>\n                    <td>\n                        <a ui-sref="country-ibq-detail({id:person.countryId})">{{person.birthCountryName}}</a>\n                    </td--><!--td>\n                        <a ui-sref="country-ibq-detail({id:person.birthCountryId})">{{person.birthCountryName}}</a>\n                    </td>\n                    <td>\n                        <a ui-sref="country-ibq-detail({id:person.deathCountryId})">{{person.deathCountryName}}</a>\n                    </td--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="person-ibq-detail({id:person.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="person-ibq.edit({id:person.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="person-ibq.delete({id:person.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/person/person-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.person.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.person.delete.question" translate-values="{id: \'{{vm.person.id}}\'}">Are you sure you want to delete this Person?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/person/person-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.person.detail.title">Person</span> {{vm.person.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.person.name">Name</span></dt><dd><span>{{vm.person.name}}</span></dd><dt><span data-translate="virtuallibraryApp.person.lastName">Last Name</span></dt><dd><span>{{vm.person.lastName}}</span></dd><dt><span data-translate="virtuallibraryApp.person.artisticName">Artistic Name</span></dt><dd><span>{{vm.person.artisticName}}</span></dd><dt><span data-translate="virtuallibraryApp.person.pictureFile">Picture File</span></dt><!--dd>\n            <div ng-if="vm.person.pictureFile">\n                <a ng-click="vm.openFile(vm.person.pictureFileContentType, vm.person.pictureFile)">\n                    <img data-ng-src="{{\'data:\' + vm.person.pictureFileContentType + \';base64,\' + vm.person.pictureFile}}" style="max-width: 100%;" alt="person image"/>\n                </a>\n                {{vm.person.pictureFileContentType}}, {{vm.byteSize(vm.person.pictureFile)}}\n            </div>\n        </dd>\n        <dt><span data-translate="virtuallibraryApp.person.picturePath">Picture Path</span></dt--><dd><span><img ng-src="{{vm.person.picturePath}}" width="100"></span></dd><dt><span data-translate="virtuallibraryApp.person.birthDate">Birth Date</span></dt><dd><span>{{vm.person.birthDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="virtuallibraryApp.person.birthPlace">Birth Place</span></dt><dd><span>{{vm.person.birthPlace}}</span></dd><dt><span data-translate="virtuallibraryApp.person.birthCountry">Birth Country</span></dt><dd><span>{{vm.person.birthCountry}}</span></dd><dt><span data-translate="virtuallibraryApp.person.deathDate">Death Date</span></dt><dd><span>{{vm.person.deathDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="virtuallibraryApp.person.deathPlace">Death Place</span></dt><dd><span>{{vm.person.deathPlace}}</span></dd><dt><span data-translate="virtuallibraryApp.person.deadCountry">Dead Country</span></dt><dd><span>{{vm.person.deadCountry}}</span></dd><dt><span data-translate="virtuallibraryApp.person.sex">Sex</span></dt><dd><span ng-if="vm.person.sex" data-translate="virtuallibraryApp.person.m"></span> <span ng-if="!vm.person.sex" data-translate="virtuallibraryApp.person.f"></span></dd><dt><span data-translate="virtuallibraryApp.person.review">Review</span></dt><dd><span>{{vm.person.review}}</span></dd><dt><span data-translate="virtuallibraryApp.person.sources">Sources</span></dt><dd><span>{{vm.person.sources}}</span></dd><dt><span data-translate="virtuallibraryApp.person.comments">Comments</span></dt><dd><span>{{vm.person.comments}}</span></dd><dt><span data-translate="virtuallibraryApp.person.participations">Participaciones</span></dt><dd><span><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="virtuallibraryApp.person.mainTitle">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.person.compositionYear">Year</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="item in vm.person.musicalPieceDTOS track by item.id"><td><a ui-sref="musical-piece-ibq-detail({id:item.id})">{{item.mainTitle}}</a></td><td>{{item.compositionYear}}</td></tr></tbody></table></div></span></dd><!--dt><span data-translate="virtuallibraryApp.person.country">Country</span></dt>\n        <dd>\n            <a ui-sref="country-ibq-detail({id:vm.person.countryId})">{{vm.person.countryName}}</a>\n        </dd--><!--dt><span data-translate="virtuallibraryApp.person.audio">Audio</span></dt>\n        <dd>\n            <span ng-repeat="audio in vm.person.audio">\n                <a ui-sref="audio-ibq-detail({id: audio.id})">{{audio.title}}</a>{{$last ? \'\' : \', \'}}\n            </span>\n        </dd>\n        <dt><span data-translate="virtuallibraryApp.person.role">Role</span></dt>\n        <dd>\n            <span ng-repeat="role in vm.person.roles">\n                <a ui-sref="role-ibq-detail({id: role.id})">{{role.roleName}}</a>{{$last ? \'\' : \', \'}}\n            </span>\n        </dd>\n        <dt><span data-translate="virtuallibraryApp.person.specialty">Specialty</span></dt>\n        <dd>\n            <span ng-repeat="specialty in vm.person.specialties">\n                <a ui-sref="specialty-ibq-detail({id: specialty.id})">{{specialty.name}}</a>{{$last ? \'\' : \', \'}}\n            </span>\n        </dd--><!--dt><span data-translate="virtuallibraryApp.person.photo">Photo</span></dt>\n        <dd>\n            <span ng-repeat="photo in vm.person.photos">\n                <a ui-sref="photo-ibq-detail({id: photo.id})">{{photo.title}}</a>{{$last ? \'\' : \', \'}}\n            </span>\n        </dd--></dl><br><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="person-ibq-detail.edit({id:vm.person.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/person/person-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clearDialog()">&times;</button><h4 class="modal-title" id="myPersonLabel" data-translate="virtuallibraryApp.person.home.createOrEditLabel">Create or edit a Person</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.person.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.person.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.person.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.person.lastName"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.artisticName" for="field_artisticName">Artistic Name</label><input type="text" class="form-control" name="artisticName" id="field_artisticName" ng-model="vm.person.artisticName"></div><div class="form-group" ngf-drop ngf-change="vm.setPictureFile($file, vm.person)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="virtuallibraryApp.person.pictureFile" for="field_pictureFile">Picture File</label><div><img data-ng-src="{{\'data:\' + vm.person.pictureFileContentType + \';base64,\' + vm.person.pictureFile}}" style="max-height: 100px; margin-bottom: 10px" ng-if="!vm.person.picturePath.includes(\'api\')&& vm.person.picturePath" alt="photo image"> <img data-ng-src="{{vm.person.picturePath}}" style="max-height: 100px; margin-bottom: 10px" ng-if="vm.person.picturePath.includes(\'api\')" alt="photo image"><br><!--img data-ng-src="{{\'data:\' + vm.person.pictureFileContentType + \';base64,\' + vm.person.pictureFile}}"\n                     style="max-height: 100px;" ng-if="vm.person.pictureFile" alt="person image"/>\n                <div ng-if="vm.person.pictureFile" class="help-block clearfix">\n                    <span\n                        class="pull-left">{{vm.person.pictureFileContentType}}, {{vm.byteSize(vm.person.pictureFile)}}</span>\n                    <button type="button" ng-click="vm.person.pictureFile=null;vm.person.pictureFileContentType=null;"\n                            class="btn btn-default btn-xs pull-right">\n                        <span class="glyphicon glyphicon-remove"></span>\n                    </button>\n                </div--> <button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setPictureFile($file, vm.person)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="pictureFile" id="field_pictureFile" ng-model="vm.person.pictureFile"> <input type="hidden" class="form-control" name="pictureFileContentType" id="field_pictureFileContentType" ng-model="vm.person.pictureFileContentType"></div><div class="form-group"><!--<label class="control-label" data-translate="virtuallibraryApp.person.picturePath" for="field_picturePath">Picture Path</label--> <input type="hidden" class="form-control" name="picturePath" id="field_picturePath" ng-model="vm.person.picturePath"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.birthDate" for="field_birthDate">Birth Date</label><div class="input-group"><input id="field_birthDate" type="text" class="form-control" name="birthDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.person.birthDate" is-open="vm.datePickerOpenStatus.birthDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'birthDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.birthPlace" for="field_birthPlace">Birth Place</label><input type="text" class="form-control" name="birthPlace" id="field_birthPlace" ng-model="vm.person.birthPlace"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.birthCountry" for="field_birthCountry">Birth Country</label><input type="text" class="form-control" name="birthCountry" id="field_birthCountry" ng-model="vm.person.birthCountry"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.deathDate" for="field_deathDate">Death Date</label><div class="input-group"><input id="field_deathDate" type="text" class="form-control" name="deathDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.person.deathDate" is-open="vm.datePickerOpenStatus.deathDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'deathDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.deathPlace" for="field_deathPlace">Death Place</label><input type="text" class="form-control" name="deathPlace" id="field_deathPlace" ng-model="vm.person.deathPlace"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.deadCountry" for="field_deadCountry">Dead Country</label><input type="text" class="form-control" name="deadCountry" id="field_deadCountry" ng-model="vm.person.deadCountry"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.sex" for="field_sex">Sex</label><!--<input type="checkbox" name="sex" id="field_sex" ng-model="vm.person.sex"/>--><select name="select" name="sex" id="field_sex" class="form-control" ng-model="vm.person.sex"><option value="" selected="selected"></option><option ng-selected="vm.person.sex" value="true" data-translate="virtuallibraryApp.person.m"></option><option ng-selected="!vm.person.sex && vm.person.id!=null" value="false" data-translate="virtuallibraryApp.person.f"></option></select></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.review" for="field_review">Review</label><textarea type="text" class="form-control" name="review" id="field_review" ng-model="vm.person.review"></textarea></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.sources" for="field_sources">Sources</label><textarea class="form-control" name="sources" id="field_sources" ng-model="vm.person.sources"></textarea></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.person.comments" for="field_comments">Comments</label><textarea class="form-control" name="comments" id="field_comments" ng-model="vm.person.comments"></textarea></div><!--div class="form-group">\n            <label data-translate="virtuallibraryApp.person.country" for="field_country">Country</label>\n            <select class="form-control" id="field_country" name="country" ng-model="vm.person.countryId" ng-options="country.id as country.name for country in vm.countries"            >\n                <option value=""></option>\n            </select>\n\n            <p>Selected: {{vm.country}}</p>\n\n\n            <ui-select ng-model="vm.country" name="field_country" id="field_country" theme="bootstrap"\n                       style="min-width: 300px;" title="Choose a country">\n                <ui-select-match>{{$select.selected.name}}</ui-select-match>\n                <ui-select-choices repeat="country in vm.countries | propsFilter: {name: $select.search}">\n                    <div ng-bind-html="country.name | highlight: $select.search"></div>\n                </ui-select-choices>\n            </ui-select>\n        </div--><!--div class="form-group">\n            <label data-translate="virtuallibraryApp.person.audio" for="field_audio">Audio</label>\n            <select class="form-control" id="field_audio" multiple name="audio" ng-model="vm.person.audio"\n                    ng-options="audio as audio.title for audio in vm.audio track by audio.id"></select>\n        </div--><!--div class="form-group">\n            <label data-translate="virtuallibraryApp.person.role" for="field_role">Role</label>\n            <select class="form-control" id="field_role" multiple name="role" ng-model="vm.person.roles" ng-options="role as role.roleName for role in vm.roles track by role.id"></select>\n\n            <ui-select multiple ng-model="vm.person.roles" theme="bootstrap" sortable="true" close-on-select="false">\n                <ui-select-match>{{$item.roleName}} </ui-select-match>\n                <ui-select-choices\n                    repeat="role in vm.roles | propsFilter: {roleName: $select.search}">\n                    <div ng-bind-html="role.roleName | highlight: $select.search"></div>\n                </ui-select-choices>\n            </ui-select>\n\n\n        </div--><!--div class="form-group">\n            <label data-translate="virtuallibraryApp.person.specialty" for="field_specialty">Specialty</label>\n            <select class="form-control" id="field_specialty" multiple name="specialty" ng-model="vm.person.specialties"\n                    ng-options="specialty as specialty.name for specialty in vm.specialties track by specialty.id"></select>\n        </div--><!--div class="form-group">\n            <label data-translate="virtuallibraryApp.person.photo" for="field_photo">Photo</label>\n            <select class="form-control" id="field_photo" multiple name="photo" ng-model="vm.person.photos"\n                    ng-options="photo as photo.title for photo in vm.photos track by photo.id"></select>\n        </div--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clearDialog()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/person-role/person-role-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.personRole.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.personRole.delete.question" translate-values="{id: \'{{vm.personRole.id}}\'}">Are you sure you want to delete this Person Role?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/person-role/person-role-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.personRole.detail.title">Person Role</span> {{vm.personRole.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.personRole.name">Name</span></dt><dd><span>{{vm.personRole.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="person-role-ibq-detail.edit({id:vm.personRole.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/person-role/person-role-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPersonRoleLabel" data-translate="virtuallibraryApp.personRole.home.createOrEditLabel">Create or edit a Person Role</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.personRole.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.personRole.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.personRole.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.personRole.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/person-role/person-rolesibq.html','<div><h2 data-translate="virtuallibraryApp.personRole.home.title">Person Roles</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="person-role-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.personRole.home.createLabel">Create new Person Role</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.personRole.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.personRole.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="personRole in vm.personRoles track by personRole.id"><td><a ui-sref="person-role-ibq-detail({id:personRole.id})">{{personRole.id}}</a></td><td>{{personRole.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="person-role-ibq-detail({id:personRole.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="person-role-ibq.edit({id:personRole.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="person-role-ibq.delete({id:personRole.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/photo/photo-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.photo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.photo.delete.question" translate-values="{id: \'{{vm.photo.id}}\'}">Are you sure you want to delete this Photo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/photo/photo-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.photo.detail.title">Photo</span> {{vm.photo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.photo.title">Title</span></dt><dd><span>{{vm.photo.title}}</span></dd><dt><span data-translate="virtuallibraryApp.photo.subtitle">Subtitle</span></dt><dd><span>{{vm.photo.subtitle}}</span></dd><dt><span data-translate="virtuallibraryApp.photo.photoFile">Photo File</span></dt><dd><img ng-src="{{vm.photo.photoPath}}" width="100"><!--div ng-if="vm.photo.photoFile">\n                <a ng-click="vm.openFile(vm.photo.photoFileContentType, vm.photo.photoFile)">\n                    <img data-ng-src="{{\'data:\' + vm.photo.photoFileContentType + \';base64,\' + vm.photo.photoFile}}" style="max-width: 100%;" alt="photo image"/>\n                </a>\n                {{vm.photo.photoFileContentType}}, {{vm.byteSize(vm.photo.photoFile)}}\n            </div--></dd><dt><span data-translate="virtuallibraryApp.photo.photoPath">Photo Path</span></dt><dd><span><img ng-src="{{photo.photoPath}}" width="100"></span></dd><dt><span data-translate="virtuallibraryApp.photo.footer">Footer</span></dt><dd><span>{{vm.photo.footer}}</span></dd><dt><span data-translate="virtuallibraryApp.photo.originalSupport">Original Support</span></dt><dd><span>{{vm.photo.originalSupport}}</span></dd><dt><span data-translate="virtuallibraryApp.photo.physicalDescription">Physical Description</span></dt><dd><span>{{vm.photo.physicalDescription}}</span></dd><dt><span data-translate="virtuallibraryApp.photo.originalDimensions">Original Dimensions</span></dt><dd><span>{{vm.photo.originalDimensions}}</span></dd><dt><span data-translate="virtuallibraryApp.photo.comments">Comments</span></dt><dd><span>{{vm.photo.comments}}</span></dd><dt><span data-translate="virtuallibraryApp.photo.alternativeText">Alternative Text</span></dt><dd><span>{{vm.photo.alternativeText}}</span></dd><dt><span data-translate="virtuallibraryApp.photo.source">Source</span></dt><dd><span>{{vm.photo.source}}</span></dd><dt><span data-translate="virtuallibraryApp.photo.musicalPiece">Musical Piece</span></dt><dd><a ui-sref="musical-piece-ibq-detail({id:vm.photo.musicalPieceId})">{{vm.photo.musicalPieceMainTitle}}</a></dd><dt><span data-translate="virtuallibraryApp.photo.person">Person</span></dt><dd><a ui-sref="person-ibq-detail({id:vm.photo.personId})">{{vm.photo.personName}}&nbsp;{{vm.photo.personLastName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="photo-ibq-detail.edit({id:vm.photo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/photo/photo-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPhotoLabel" data-translate="virtuallibraryApp.photo.home.createOrEditLabel">Create or edit a Photo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.photo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.photo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.photo.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.photo.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.photo.subtitle" for="field_subtitle">Subtitle</label><input type="text" class="form-control" name="subtitle" id="field_subtitle" ng-model="vm.photo.subtitle"></div><div class="form-group" ngf-drop ngf-change="vm.setPhotoFile($file, vm.photo)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="virtuallibraryApp.photo.photoFile" for="field_photoFile">Photo File</label><div><!--<a ng-if="!vm.photo.photoFile && vm.photo.photoPath" class="btn btn-primary glyphicon glyphicon-download" ng-href="{{vm.photo.photoPath}}" style="margin-bottom: 10px" data-translate="entity.action.download"> Abrir</a>--> <img data-ng-src="{{\'data:\' + vm.photo.photoFileContentType + \';base64,\' + vm.photo.photoFile}}" style="max-height: 100px; margin-bottom: 10px" ng-if="!vm.photo.photoPath.includes(\'api\')&& vm.photo.photoPath" alt="photo image"> <img data-ng-src="{{vm.photo.photoPath}}" style="max-height: 100px; margin-bottom: 10px" ng-if="vm.photo.photoPath.includes(\'api\')" alt="photo image"><br><!--div ng-if="vm.photo.photoFile" class="help-block clearfix">\n                    <span class="pull-left">{{vm.photo.photoFileContentType}}, {{vm.byteSize(vm.photo.photoFile)}}</span>\n                    <button type="button" ng-click="vm.photo.photoFile=null;vm.photo.photoFileContentType=null;"\n                            class="btn btn-default btn-xs pull-right">\n                        <span class="glyphicon glyphicon-remove"></span>\n                    </button>\n                </div--> <button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setPhotoFile($file, vm.photo)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="photoFile" id="field_photoFile" ng-model="vm.photo.photoFile" ng-required="!vm.photo.id"> <input type="hidden" class="form-control" name="photoFileContentType" id="field_photoFileContentType" ng-model="vm.photo.photoFileContentType"><div ng-show="editForm.photoFile.$invalid"><p class="help-block" ng-show="editForm.photoFile.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><!--label class="control-label" data-translate="virtuallibraryApp.photo.photoPath" for="field_photoPath">Photo Path</label--> <input type="hidden" class="form-control" name="photoPath" id="field_photoPath" ng-model="vm.photo.photoPath"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.photo.footer" for="field_footer">Footer</label><input type="text" class="form-control" name="footer" id="field_footer" ng-model="vm.photo.footer"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.photo.originalSupport" for="field_originalSupport">Original Support</label><input type="text" class="form-control" name="originalSupport" id="field_originalSupport" ng-model="vm.photo.originalSupport"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.photo.physicalDescription" for="field_physicalDescription">Physical Description</label><textarea class="form-control" name="physicalDescription" id="field_physicalDescription" ng-model="vm.photo.physicalDescription"></textarea></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.photo.originalDimensions" for="field_originalDimensions">Original Dimensions</label><input type="text" class="form-control" name="originalDimensions" id="field_originalDimensions" ng-model="vm.photo.originalDimensions"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.photo.comments" for="field_comments">Comments</label><textarea class="form-control" name="comments" id="field_comments" ng-model="vm.photo.comments"></textarea></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.photo.alternativeText" for="field_alternativeText">Alternative Text</label><input type="text" class="form-control" name="alternativeText" id="field_alternativeText" ng-model="vm.photo.alternativeText"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.photo.source" for="field_source">Source</label><textarea class="form-control" name="source" id="field_source" ng-model="vm.photo.source"></textarea></div><div class="form-group"><label data-translate="virtuallibraryApp.photo.musicalPiece" for="field_musicalPiece">Musical Piece</label><select class="form-control" id="field_musicalPiece" name="musicalPiece" ng-model="vm.photo.musicalPieceId" ng-options="musicalPiece.id as musicalPiece.mainTitle for musicalPiece in vm.musicalpieces"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.photo.person" for="field_person">Person</label><!--select class="form-control" id="field_person" name="person" ng-model="vm.photo.personId" ng-options="person.id as person.name for person in vm.people"            >\n                <option value=""></option>\n            </select--><ui-select ng-model="vm.photo.personId" name="field_person" id="field_person" theme="bootstrap"><ui-select-match>{{$select.selected.value.name}}&nbsp;{{$select.selected.value.lastName}}</ui-select-match><ui-select-choices repeat="person.value.id as (id, person) in vm.people | filter: { value: { name: $select.search }}"><div><span ng-bind-html="person.value.name | highlight: $select.search"></span>&af; <span ng-bind-html="person.value.lastName | highlight: $select.search"></span></div></ui-select-choices></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/photo/photosibq.html','<div><h2 data-translate="virtuallibraryApp.photo.home.title">Photos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="photo-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.photo.home.createLabel">Create new Photo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.photo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="virtuallibraryApp.photo.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="subtitle"><span data-translate="virtuallibraryApp.photo.subtitle">Subtitle</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="photoFile"><span data-translate="virtuallibraryApp.photo.photoFile">Photo File</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="photoPath"><span data-translate="virtuallibraryApp.photo.photoPath">Photo Path</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="footer"><span data-translate="virtuallibraryApp.photo.footer">Footer</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="originalSupport"><span data-translate="virtuallibraryApp.photo.originalSupport">Original Support</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="physicalDescription"><span data-translate="virtuallibraryApp.photo.physicalDescription">Physical Description</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="originalDimensions"><span data-translate="virtuallibraryApp.photo.originalDimensions">Original Dimensions</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="comments"><span data-translate="virtuallibraryApp.photo.comments">Comments</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="alternativeText"><span data-translate="virtuallibraryApp.photo.alternativeText">Alternative Text</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="source"><span data-translate="virtuallibraryApp.photo.source">Source</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="musicalPieceMainTitle"><span data-translate="virtuallibraryApp.photo.musicalPiece">Musical Piece</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="personName"><span data-translate="virtuallibraryApp.photo.person">Person</span> <span class="glyphicon glyphicon-sort"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat="photo in vm.photos track by photo.id"><td><a ui-sref="photo-ibq-detail({id:photo.id})">{{photo.id}}</a></td><td>{{photo.title}}</td><!--<td>{{photo.subtitle}}</td>--><!--td>\n                        <a ng-if="photo.photoFile" ng-click="vm.openFile(photo.photoFileContentType, photo.photoFile)">\n                            <img data-ng-src="{{\'data:\' + photo.photoFileContentType + \';base64,\' + photo.photoFile}}" style="max-height: 30px;" alt="photo image"/>\n                        </a>\n                        <span ng-if="photo.photoFile">{{photo.photoFileContentType}}, {{vm.byteSize(photo.photoFile)}}</span>\n                    </td--><td><img ng-src="{{photo.photoPath}}" width="100"></td><!--<td>{{photo.footer}}</td>--><td>{{photo.originalSupport}}</td><!--<td>{{photo.physicalDescription}}</td>--><!--<td>{{photo.originalDimensions}}</td>--><!--<td>{{photo.comments}}</td>--><!--<td>{{photo.alternativeText}}</td>--><td>{{photo.source}}</td><!--td>\n                        <a ui-sref="musical-piece-ibq-detail({id:photo.musicalPieceId})">{{photo.musicalPieceMainTitle}}</a>\n                    </td>\n                    <td>\n                        <a ui-sref="person-ibq-detail({id:photo.personId})">{{photo.personName}}</a>\n                    </td--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="photo-ibq-detail({id:photo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="photo-ibq.edit({id:photo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="photo-ibq.delete({id:photo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/portal-role/portal-role-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.portalRole.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.portalRole.delete.question" translate-values="{id: \'{{vm.portalRole.id}}\'}">Are you sure you want to delete this Portal Role?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/portal-role/portal-role-detail.html','<div><h2><span data-translate="virtuallibraryApp.portalRole.detail.title">Portal Role</span> {{vm.portalRole.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.portalRole.name">Name</span></dt><dd><span>{{vm.portalRole.name}}</span></dd><dt><span data-translate="virtuallibraryApp.portalRole.roleId">Role Id</span></dt><dd><span>{{vm.portalRole.roleId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="portal-role-detail.edit({id:vm.portalRole.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/portal-role/portal-role-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPortalRoleLabel" data-translate="virtuallibraryApp.portalRole.home.createOrEditLabel">Create or edit a Portal Role</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.portalRole.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.portalRole.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.portalRole.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.portalRole.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.portalRole.roleId" for="field_roleId">Role Id</label><input type="number" class="form-control" name="roleId" id="field_roleId" ng-model="vm.portalRole.roleId" required><div ng-show="editForm.roleId.$invalid"><p class="help-block" ng-show="editForm.roleId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.roleId.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/portal-role/portal-roles.html','<div><h2 data-translate="virtuallibraryApp.portalRole.home.title">Portal Roles</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-6 no-padding-left"><button class="btn btn-primary" ui-sref="portal-role.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.portalRole.home.createLabel">Create new Portal Role</span></button> <button ui-sref="portal-role" class="btn btn-success" ng-click="vm.sync()"><span class="glyphicon glyphicon-refresh"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.portalRole.home.sync">Sync</span></button></div><div class="col-xs-6 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.portalRole.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="virtuallibraryApp.portalRole.name">Name</span></th><th><span data-translate="virtuallibraryApp.portalRole.roleId">Role Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="portalRole in vm.portalRoles track by portalRole.id"><td><a ui-sref="portal-role-detail({id:portalRole.id})">{{portalRole.id}}</a></td><td>{{portalRole.name}}</td><td>{{portalRole.roleId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="portal-role-detail({id:portalRole.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="portal-role.edit({id:portalRole.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="portal-role.delete({id:portalRole.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/publisher/publisher-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publisher.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.publisher.delete.question" translate-values="{id: \'{{vm.publisher.id}}\'}">Are you sure you want to delete this Publisher?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/publisher/publisher-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.publisher.detail.title">Publisher</span> {{vm.publisher.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.publisher.name">Name</span></dt><dd><span>{{vm.publisher.name}}</span></dd><dt><span data-translate="virtuallibraryApp.publisher.address">Address</span></dt><dd><span>{{vm.publisher.address}}</span></dd><dt><span data-translate="virtuallibraryApp.publisher.webPage">Web Page</span></dt><dd><span><a ng-href="{{vm.publisher.webPage}}">{{vm.publisher.webPage}}</a></span></dd><dt><span data-translate="virtuallibraryApp.publisher.phone">Phone</span></dt><dd><span>{{vm.publisher.phone}}</span></dd><dt><span data-translate="virtuallibraryApp.publisher.email">Email</span></dt><dd><span>{{vm.publisher.email}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="publisher-ibq-detail.edit({id:vm.publisher.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/publisher/publisher-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublisherLabel" data-translate="virtuallibraryApp.publisher.home.createOrEditLabel">Create or edit a Publisher</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.publisher.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publisher.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.publisher.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.publisher.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.publisher.address" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.publisher.address"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.publisher.webPage" for="field_webPage">Web Page</label><span class="glyphicon glyphicon-question-sign" data aria-hidden="true" uib-tooltip="{{\'virtuallibraryApp.publisher.webPageHelp\'|translate}}"></span> <input type="text" class="form-control" name="webPage" id="field_webPage" ng-model="vm.publisher.webPage"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.publisher.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.publisher.phone"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.publisher.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.publisher.email"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/publisher/publishersibq.html','<div><h2 data-translate="virtuallibraryApp.publisher.home.title">Publishers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="publisher-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.publisher.home.createLabel">Create new Publisher</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.publisher.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.publisher.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="address"><span data-translate="virtuallibraryApp.publisher.address">Address</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="webPage"><span data-translate="virtuallibraryApp.publisher.webPage">Web Page</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span data-translate="virtuallibraryApp.publisher.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="virtuallibraryApp.publisher.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="publisher in vm.publishers track by publisher.id"><td><a ui-sref="publisher-ibq-detail({id:publisher.id})">{{publisher.id}}</a></td><td>{{publisher.name}}</td><!--<td>{{publisher.address}}</td>--><td><a ng-href="{{publisher.webPage}}">{{publisher.webPage}}</a></td><td>{{publisher.phone}}</td><td>{{publisher.email}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="publisher-ibq-detail({id:publisher.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="publisher-ibq.edit({id:publisher.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="publisher-ibq.delete({id:publisher.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/role/role-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.role.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.role.delete.question" translate-values="{id: \'{{vm.role.id}}\'}">Are you sure you want to delete this Role?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/role/role-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.role.detail.title">Role</span> {{vm.role.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.role.roleName">Role Name</span></dt><dd><span>{{vm.role.roleName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="role-ibq-detail.edit({id:vm.role.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/role/role-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRoleLabel" data-translate="virtuallibraryApp.role.home.createOrEditLabel">Create or edit a Role</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.role.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.role.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.role.roleName" for="field_roleName">Role Name</label><input type="text" class="form-control" name="roleName" id="field_roleName" ng-model="vm.role.roleName" required><div ng-show="editForm.roleName.$invalid"><p class="help-block" ng-show="editForm.roleName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/role/rolesibq.html','<div><h2 data-translate="virtuallibraryApp.role.home.title">Roles</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="role-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.role.home.createLabel">Create new Role</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.role.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="roleName"><span data-translate="virtuallibraryApp.role.roleName">Role Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="role in vm.roles track by role.id"><td><a ui-sref="role-ibq-detail({id:role.id})">{{role.id}}</a></td><td>{{role.roleName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="role-ibq-detail({id:role.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="role-ibq.edit({id:role.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="role-ibq.delete({id:role.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/state/state-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.state.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.state.delete.question" translate-values="{id: \'{{vm.state.id}}\'}">Are you sure you want to delete this State?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/state/state-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.state.detail.title">State</span> {{vm.state.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.state.name">Name</span></dt><dd><span>{{vm.state.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="state-ibq-detail.edit({id:vm.state.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/state/state-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myStateLabel" data-translate="virtuallibraryApp.state.home.createOrEditLabel">Create or edit a State</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.state.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.state.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.state.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.state.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/state/statesibq.html','<div><h2 data-translate="virtuallibraryApp.state.home.title">States</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="state-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.state.home.createLabel">Create new State</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.state.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.state.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="state in vm.states track by state.id"><td><a ui-sref="state-ibq-detail({id:state.id})">{{state.id}}</a></td><td>{{state.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="state-ibq-detail({id:state.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="state-ibq.edit({id:state.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="state-ibq.delete({id:state.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/specialty/specialtiesibq.html','<div><h2 data-translate="virtuallibraryApp.specialty.home.title">Specialties</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="specialty-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.specialty.home.createLabel">Create new Specialty</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.specialty.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.specialty.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="specialty in vm.specialties track by specialty.id"><td><a ui-sref="specialty-ibq-detail({id:specialty.id})">{{specialty.id}}</a></td><td>{{specialty.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="specialty-ibq-detail({id:specialty.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="specialty-ibq.edit({id:specialty.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="specialty-ibq.delete({id:specialty.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/specialty/specialty-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.specialty.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.specialty.delete.question" translate-values="{id: \'{{vm.specialty.id}}\'}">Are you sure you want to delete this Specialty?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/specialty/specialty-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.specialty.detail.title">Specialty</span> {{vm.specialty.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.specialty.name">Name</span></dt><dd><span>{{vm.specialty.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="specialty-ibq-detail.edit({id:vm.specialty.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/specialty/specialty-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySpecialtyLabel" data-translate="virtuallibraryApp.specialty.home.createOrEditLabel">Create or edit a Specialty</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.specialty.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.specialty.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.specialty.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.specialty.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/type/type-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.type.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.type.delete.question" translate-values="{id: \'{{vm.type.id}}\'}">Are you sure you want to delete this Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/type/type-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.type.detail.title">Type</span> {{vm.type.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.type.name">Name</span></dt><dd><span>{{vm.type.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="type-ibq-detail.edit({id:vm.type.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/type/type-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTypeLabel" data-translate="virtuallibraryApp.type.home.createOrEditLabel">Create or edit a Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.type.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.type.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.type.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.type.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/type/typesibq.html','<div><h2 data-translate="virtuallibraryApp.type.home.title">Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="type-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.type.home.createLabel">Create new Type</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.type.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.type.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="type in vm.types track by type.id"><td><a ui-sref="type-ibq-detail({id:type.id})">{{type.id}}</a></td><td>{{type.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="type-ibq-detail({id:type.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="type-ibq.edit({id:type.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="type-ibq.delete({id:type.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/video/video-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.video.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.video.delete.question" translate-values="{id: \'{{vm.video.id}}\'}">Are you sure you want to delete this Video?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/video/video-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.video.detail.title">Video</span> {{vm.video.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.video.title">Title</span></dt><dd><span>{{vm.video.title}}</span></dd><dt><span data-translate="virtuallibraryApp.video.creationDate">Creation Date</span></dt><dd><span>{{vm.video.creationDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="virtuallibraryApp.video.creationPlace">Creation Place</span></dt><dd><span>{{vm.video.creationPlace}}</span></dd><dt><span data-translate="virtuallibraryApp.video.videoUrl">Video Url</span></dt><dd><!--span ng-bind-html="vm.trustAsHtml(vm.video.videoUrl)"></span--> <a href="{{vm.video.videoUrl}}">{{vm.video.videoUrl}}</a></dd><dt><span data-translate="virtuallibraryApp.video.comments">Comments</span></dt><dd><span>{{vm.video.comments}}</span></dd><dt><span data-translate="virtuallibraryApp.video.duration">Duration</span></dt><dd><span>{{vm.video.duration}}</span></dd><dt><span data-translate="virtuallibraryApp.video.videoType">Video Type</span></dt><dd><a ui-sref="video-type-ibq-detail({id:vm.video.videoTypeId})">{{vm.video.videoTypeName}}</a></dd><dt><span data-translate="virtuallibraryApp.video.musicalPiece">Musical Piece</span></dt><dd><a ui-sref="musical-piece-ibq-detail({id:vm.video.musicalPieceId})">{{vm.video.musicalPieceMainTitle}}</a></dd><dt><span data-translate="virtuallibraryApp.video.audioLanguage">Audio Language</span></dt><dd><span ng-repeat="audioLanguage in vm.video.audioLanguages"><a ui-sref="language-ibq-detail({id: audioLanguage.id})">{{audioLanguage.name}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="virtuallibraryApp.video.subtitleLanguage">Subtitle Language</span></dt><dd><span ng-repeat="subtitleLanguage in vm.video.subtitleLanguages"><a ui-sref="language-ibq-detail({id: subtitleLanguage.id})">{{subtitleLanguage.name}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="virtuallibraryApp.video.person">Person</span></dt><dd><a ui-sref="person-ibq-detail({id:vm.video.personId})">{{vm.video.personName}}</a></dd><dt><span data-translate="virtuallibraryApp.video.copyright">Copyright</span></dt><dd><a ui-sref="copyright-detail({id:vm.video.copyrightId})">{{vm.video.copyrightName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="video-ibq-detail.edit({id:vm.video.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/video/video-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVideoLabel" data-translate="virtuallibraryApp.video.home.createOrEditLabel">Create or edit a Video</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.video.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.video.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.video.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.video.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.video.creationDate" for="field_creationDate">Creation Date</label><div class="input-group"><input id="field_creationDate" type="text" class="form-control" name="creationDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.video.creationDate" is-open="vm.datePickerOpenStatus.creationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.video.creationPlace" for="field_creationPlace">Creation Place</label><input type="text" class="form-control" name="creationPlace" id="field_creationPlace" ng-model="vm.video.creationPlace"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.video.videoUrl" for="field_videoUrl">Video Url</label><textarea class="form-control" name="videoUrl" id="field_videoUrl" ng-model="vm.video.videoUrl"></textarea></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.video.comments" for="field_comments">Comments</label><textarea class="form-control" name="comments" id="field_comments" ng-model="vm.video.comments"></textarea></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.video.duration" for="field_duration">Duration</label><input type="number" class="form-control" name="duration" id="field_duration" ng-model="vm.video.duration"></div><div class="form-group"><label data-translate="virtuallibraryApp.video.videoType" for="field_videoType">Video Type</label><select class="form-control" id="field_videoType" name="videoType" ng-model="vm.video.videoTypeId" ng-options="videoType.id as videoType.name for videoType in vm.videotypes"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.video.musicalPiece" for="field_musicalPiece">Musical Piece</label><select class="form-control" id="field_musicalPiece" name="musicalPiece" ng-model="vm.video.musicalPieceId" ng-options="musicalPiece.id as musicalPiece.mainTitle for musicalPiece in vm.musicalpieces"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.video.audioLanguage" for="field_audioLanguage">Audio Language</label><!--<select class="form-control" id="field_audioLanguage" multiple name="audioLanguage" ng-model="vm.video.audioLanguages" ng-options="language as language.name for language in vm.languages track by language.id"></select>--><ui-select multiple="multiple" ng-model="vm.video.audioLanguages" theme="bootstrap" name="field_audioLanguage" id="field_audioLanguage"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="language in vm.languages | propsFilter: {name: $select.search}"><div ng-bind-html="language.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group"><label data-translate="virtuallibraryApp.video.subtitleLanguage" for="field_subtitleLanguage">Subtitle Language</label><!--<select class="form-control" id="field_subtitleLanguage" multiple name="subtitleLanguage" ng-model="vm.video.subtitleLanguages" ng-options="language as language.name for language in vm.languages track by language.id"></select>--><ui-select multiple="multiple" ng-model="vm.video.subtitleLanguages" theme="bootstrap" name="field_subtitleLanguage" id="field_subtitleLanguage"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat="language in vm.languages | propsFilter: {name: $select.search}"><div ng-bind-html="language.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group"><label data-translate="virtuallibraryApp.video.person" for="field_person">Person</label><select class="form-control" id="field_person" name="person" ng-model="vm.video.personId" ng-options="person.id as person.name for person in vm.people"><option value=""></option></select></div><div class="form-group"><label data-translate="virtuallibraryApp.video.copyright" for="field_copyright">Copyright</label><select class="form-control" id="field_copyright" name="copyright" ng-model="vm.video.copyrightId" ng-options="copyright.id as copyright.name for copyright in vm.copyrights"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/video/videosibq.html','<div><h2 data-translate="virtuallibraryApp.video.home.title">Videos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="video-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.video.home.createLabel">Create new Video</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.video.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="virtuallibraryApp.video.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationDate"><span data-translate="virtuallibraryApp.video.creationDate">Creation Date</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="creationPlace"><span data-translate="virtuallibraryApp.video.creationPlace">Creation Place</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="videoUrl"><span data-translate="virtuallibraryApp.video.videoUrl">Video Url</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="comments"><span data-translate="virtuallibraryApp.video.comments">Comments</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="duration"><span data-translate="virtuallibraryApp.video.duration">Duration</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="videoTypeName"><span data-translate="virtuallibraryApp.video.videoType">Video Type</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="musicalPieceMainTitle"><span data-translate="virtuallibraryApp.video.musicalPiece">Musical Piece</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="personName"><span data-translate="virtuallibraryApp.video.person">Person</span> <span class="glyphicon glyphicon-sort"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat="video in vm.videos track by video.id"><td><a ui-sref="video-ibq-detail({id:video.id})">{{video.id}}</a></td><td>{{video.title}}</td><td>{{video.creationDate | date:\'mediumDate\'}}</td><!--<td>{{video.creationPlace}}</td>--><!--<td><div ng-bind-html="vm.trustAsHtml(video.videoUrl)"></div></td>--><!--<td>{{video.comments}}</td>--><td>{{video.duration}}</td><td><a ui-sref="video-type-ibq-detail({id:video.videoTypeId})">{{video.videoTypeName}}</a></td><!--td>\n                        <a ui-sref="musical-piece-ibq-detail({id:video.musicalPieceId})">{{video.musicalPieceMainTitle}}</a>\n                    </td--><!--td>\n                        <a ui-sref="person-ibq-detail({id:video.personId})">{{video.personName}}</a>\n                    </td--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="video-ibq-detail({id:video.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="video-ibq.edit({id:video.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="video-ibq.delete({id:video.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/video-type/video-type-ibq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.videoType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="virtuallibraryApp.videoType.delete.question" translate-values="{id: \'{{vm.videoType.id}}\'}">Are you sure you want to delete this Video Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/video-type/video-type-ibq-detail.html','<div><h2><span data-translate="virtuallibraryApp.videoType.detail.title">Video Type</span> {{vm.videoType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="virtuallibraryApp.videoType.name">Name</span></dt><dd><span>{{vm.videoType.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="video-type-ibq-detail.edit({id:vm.videoType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/video-type/video-type-ibq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVideoTypeLabel" data-translate="virtuallibraryApp.videoType.home.createOrEditLabel">Create or edit a Video Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.videoType.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.videoType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="virtuallibraryApp.videoType.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.videoType.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/video-type/video-typesibq.html','<div><h2 data-translate="virtuallibraryApp.videoType.home.title">Video Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="video-type-ibq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="virtuallibraryApp.videoType.home.createLabel">Create new Video Type</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'virtuallibraryApp.videoType.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="virtuallibraryApp.videoType.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="videoType in vm.videoTypes track by videoType.id"><td><a ui-sref="video-type-ibq-detail({id:videoType.id})">{{videoType.id}}</a></td><td>{{videoType.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="video-type-ibq-detail({id:videoType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--></button> <button type="submit" ui-sref="video-type-ibq.edit({id:videoType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="video-type-ibq.delete({id:videoType.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();